module.exports.algs = [
  {
    cat: 'A',
    cases: [
      {
        name: 'A1+',
        scr: [
          "R' U R2 U2' R U2 R2 U' R U R2 U2' R' U2 R'",
          "R' U2 R2 U2 R U2' R2 U2' R U R2 U2' R' U2 R'",
          "R2' U2' R2' U2' R2' U2 R' U R U2 R2 U2' R2 U R2",
          "R' U2 R2' U R2 U R U' R2 U' R2' U2 R'",
          "R' U2' R2 U2' R' U2 R' U R U2 R U2' R2'",
          "R U R2' U2' R U2 R U R' U2 R' U2' R2 U2' R'",
          "R U R' U2 R2' U' R2 U' R U R2 U R2' U2 R'",
          "R2 U R2 U2' R2 U2 R U R' U2 R2' U2' R2' U2' R2'",
          "R' U2 R' U2' R2 U R U2' R2 U2' R U2 R2 U2 R'",
          "R' U2 R' U2' R2 U R U' R2 U2 R U2' R2 U R'",
          "R U2' R' U' R2 U2' R2' U' R2 U2' R2' U' R U2' R'",
          "R U2' R' U' R2' U2' R2 U' R2' U2' R2 U' R U2' R'",
          "R2 U2' R2' U' R2 U2' R2' U' R2 U2' R2' U' R2 U2' R2'",
          "R2 U2' R2' U' R2 U2' R2' U' R2' U2' R2 U' R2' U2' R2",
          "R2 U2' R2' U' R2' U2' R2 U' R2' U2' R2 U' R2 U2' R2'",
          "R2' U2' R2 U' R2 U2' R2' U' R2 U2' R2' U' R2' U2' R2",
          "R2' U2' R2 U' R2' U2' R2 U' R2 U2' R2' U' R2 U2' R2'",
          "R2' U2' R2 U' R2' U2' R2 U' R2' U2' R2 U' R2' U2' R2",
          "R' U2' R U' R2 U2' R2' U' R2 U2' R2' U' R' U2' R",
          "R' U2' R U' R2' U2' R2 U' R2' U2' R2 U' R' U2' R",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          3,
          4,
          2,
          1,
          2,
          3,
          2,
          3,
          4,
          4,
          5,
          5,
          5,
        ],
      },
      {
        name: 'A1-',
        scr: [
          "R U2 R2' U2 R U2' R U' R' U2' R' U2 R2 U' R'",
          "R U2' R2 U' R2' U' R' U R2' U R2 U2' R U' R'",
          "R2 U2 R2 U2 R2 U2' R U' R' U2' R2' U2 R2' U' R2'",
          "R U2' R2' U2' R' U2 R2' U2 R' U' R2' U2 R U2' R",
          "R U' R2' U2 R' U2' R2' U R' U' R2' U2 R U2' R",
          "R U2' R U2 R2' U' R' U R2' U2' R' U2 R2' U' R",
          "R U2' R U2 R2' U' R' U2 R2' U2 R' U2' R2' U2' R",
          "R2' U' R2' U2 R2' U2' R' U' R U2' R2 U2 R2 U2 R2",
          "R' U' R U2' R2 U R2' U R' U' R2' U' R2 U2' R",
          "R' U' R2 U2 R' U2' R' U' R U2' R U2 R2' U2 R",
          "R U2 R' U R2 U2 R2' U R2 U2 R2' U R U2 R'",
          "R U2 R' U R2' U2 R2 U R2' U2 R2 U R U2 R'",
          "R2 U2 R2' U R2 U2 R2' U R2 U2 R2' U R2 U2 R2'",
          "R2 U2 R2' U R2 U2 R2' U R2' U2 R2 U R2' U2 R2",
          "R2 U2 R2' U R2' U2 R2 U R2' U2 R2 U R2 U2 R2'",
          "R2' U2 R2 U R2 U2 R2' U R2 U2 R2' U R2' U2 R2",
          "R2' U2 R2 U R2' U2 R2 U R2 U2 R2' U R2 U2 R2'",
          "R2' U2 R2 U R2' U2 R2 U R2' U2 R2 U R2' U2 R2",
          "R' U2 R U R2 U2 R2' U R2 U2 R2' U R' U2 R",
          "R' U2 R U R2' U2 R2 U R2' U2 R2 U R' U2 R",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          2,
          3,
          2,
          3,
          4,
          3,
          1,
          2,
          4,
          4,
          5,
          5,
          5,
        ],
      },
      {
        name: 'A2+',
        scr: [
          "R U2 R2' U2 R2' U R2 U2 R2 U2' R U' R' U R'",
          "R U2 R' U2 R2 U R2' U2 R U2' R U' R' U R'",
          "R' U R2' U2 R2 U R U' R2 U2' R2' U2' R' U R",
          "R U2 R2' U2' R U2 R U R' U2 R' U2' R2 U2 R'",
          "R U2 R' U2 R2' U' R2 U' R U R2 U R2' U R'",
          "R2 U2 R2 U2' R2 U2 R U R' U2 R2' U2' R2' U2 R2'",
          "R' U2 R' U2' R2' U2 R2' U R2 U2 R2 U2' R U2 R",
          "R' U2 R' U2' R' U2 R2 U R2' U2 R U2' R U2 R",
          "R U2 R U2' R U2 R2' U R2 U2 R' U2' R' U2 R'",
          "R U2 R U2' R2 U2 R2 U R2' U2 R2' U2' R' U2 R'",
          "R2' U2 R2' U2' R2' U2 R' U R U2 R2 U2' R2 U2 R2",
          "R' U R2' U R2 U R U' R2 U' R2' U2 R' U2 R",
          "R' U2 R2 U2' R' U2 R' U R U2 R U2' R2' U2 R",
          "R U2 R' U2 R U2' R2 U R2' U R' U' R2' U' R2' U2' R'",
          "R U2' R2' U2' R' U2 R2' U2' R2' U2 R2 U2 R2 U2' R U2 R",
          "R U' R2 U2 R2 U R U' R2 U2' R2' U2' R' U2 R U R'",
          "R U' R2' U2 R' U2' R2' U2 R2' U2 R2 U2 R2 U2' R U2 R",
          "R' U2' R2 U2 R2' U R2 U2 R2 U2' R U' R' U2' R U2 R",
          "R' U2' R2' U2 R2 U R2' U2 R U2' R U' R' U2' R U2 R",
          "R U2' R' U2' R U2 R2' U2' R2 U' R2' U R U' R' U2' R",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          4,
          1,
          1,
          2,
          2,
          5,
          1,
          3,
          2,
          3,
          4,
          4,
          5,
          5,
          3,
        ],
      },
      {
        name: 'A2-',
        scr: [
          "R U' R U R' U2 R2' U2' R2' U' R2 U2' R2 U2' R'",
          "R U' R U R' U2 R' U2' R2 U' R2' U2' R U2' R'",
          "R' U' R U2 R2 U2 R2' U R' U' R2' U2' R2 U' R",
          "R U2' R2' U2 R U2' R U' R' U2' R' U2 R2 U2' R'",
          "R U' R2 U' R2' U' R' U R2' U R2 U2' R U2' R'",
          "R2 U2' R2 U2 R2 U2' R U' R' U2' R2' U2 R2' U2' R2'",
          "R' U2' R' U2 R2' U2' R2' U' R2 U2' R2 U2 R U2' R",
          "R' U2' R' U2 R' U2' R2 U' R2' U2' R U2 R U2' R",
          "R U2' R U2 R U2' R2' U' R2 U2' R' U2 R' U2' R'",
          "R U2' R U2 R2 U2' R2 U' R2' U2' R2' U2 R' U2' R'",
          "R2' U2' R2' U2 R2' U2' R' U' R U2' R2 U2 R2 U2' R2",
          "R' U2' R U2' R2 U R2' U R' U' R2' U' R2 U' R",
          "R' U2' R2 U2 R' U2' R' U' R U2' R U2 R2' U2' R",
          "R U2 R2 U R2 U R U' R2 U' R2' U2 R' U2' R U2' R'",
          "R U' R' U2' R U2 R2 U2 R2' U R' U' R2' U2' R2' U R'",
          "R' U2' R' U2 R U R' U2 R2' U2' R2' U' R2 U2' R2' U2 R",
          "R' U2' R' U2 R U R' U2 R' U2' R2 U' R2' U2' R2 U2 R",
          "R' U2' R' U2 R2' U2' R2' U2' R2 U2 R2 U2' R U2 R2 U2 R'",
          "R' U2' R' U2 R2' U2' R2' U2' R2 U2' R2 U2 R U2' R2 U R'",
          "R U2' R' U2' R' U' R2 U R2' U2 R2 U2' R' U' R' U2' R",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          3,
          1,
          1,
          2,
          2,
          3,
          4,
          3,
          5,
          1,
          4,
          4,
          5,
          5,
          2,
        ],
      },
    ],
  }, //A
  {
    cat: 'B',
    cases: [
      {
        name: 'B1+',
        scr: [
          "R2 U R2' U2 R2 U2 R2' U2' R2 U R2' U R2 U2' R2'",
          "R2 U R2' U' R2 U2' R2' U2 R2 U' R2' U R2 U2' R2'",
          "R2 U2 R2' U' R2 U R2' U2' R2 U2 R2' U R2 U' R2'",
          "R2 U2 R2' U' R2 U' R2' U2 R2 U2' R2' U2' R2 U' R2'",
          "R2' U R2 U2 R2' U2 R2 U2' R2' U R2 U R2' U2' R2",
          "R2' U R2 U' R2' U2' R2 U2 R2' U' R2 U R2' U2' R2",
          "R2' U2 R2 U' R2' U R2 U2' R2' U2 R2 U R2' U' R2",
          "R2' U2 R2 U' R2' U' R2 U2 R2' U2' R2 U2' R2' U' R2",
          "R U R' U2 R2 U2 R2' U' R U R U2' R' U2 R'",
          "R U R2 U2' R' U2' R2 U2 R2 U2' R U2 R2' U2 R2' U' R'",
          "R U2' R2 U2 R2' U' R' U' R2' U2 R2 U R U2 R2 U2 R2",
          "R U2 R2 U R2' U2 R2 U2 R2 U2' R2' U R2 U R2' U2' R2",
          "R U2 R2 U2' R' U2' R' U2 R2 U2 R2' U' R U R' U2' R'",
          "R2 U2 R U R' U' R2' U2' R2 U R U' R2 U2 R2 U2' R2'",
          "R' U2 R U2' R' U R U2' R U2 R' U R U2 R2' U2' R",
          "R' U2 R2' U R2 U2 R2' U2 R2' U2' R2 U R2' U R2 U2' R2'",
          "R U R U R2' U' R2 U R2' U2' R2 U2 R2' U R U' R'",
          "R U R U R2' U' R2 U' R2' U2 R2 U2' R2' U2' R U' R'",
          "R U R' U2 R2 U2 R2' U2' R2 U R2' U R2 U' R' U' R'",
          "R U R' U' R2 U2' R2' U2 R2 U' R2' U R2 U' R' U' R'",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          2,
          1,
          2,
          3,
          3,
          4,
          1,
          4,
          5,
          4,
          2,
          3,
          5,
          5,
        ],
      },
      {
        name: 'B1-',
        scr: [
          "R2 U2' R2' U R2 U R2' U2' R2 U2 R2' U2 R2 U R2'",
          "R2 U2' R2' U R2 U' R2' U2 R2 U2' R2' U' R2 U R2'",
          "R2 U' R2' U R2 U2 R2' U2' R2 U R2' U' R2 U2 R2'",
          "R2 U' R2' U2' R2 U2' R2' U2 R2 U' R2' U' R2 U2 R2'",
          "R2' U2' R2 U R2' U R2 U2' R2' U2 R2 U2 R2' U R2",
          "R2' U2' R2 U R2' U' R2 U2 R2' U2' R2 U' R2' U R2",
          "R2' U' R2 U R2' U2 R2 U2' R2' U R2 U' R2' U2 R2",
          "R2' U' R2 U2' R2' U2' R2 U2 R2' U' R2 U' R2' U2 R2",
          "R' U' R U2' R2' U2' R2 U R' U' R' U2 R U2' R",
          "R' U2 R2' U2' R2 U R U R2 U2' R2' U' R' U2' R2' U2' R2'",
          "R' U' R2' U2 R U2 R2' U2' R2' U2 R' U2' R2 U2' R2",
          "R2 U2 R U2 R2 U R2' U2 R2 U2' R2 U R2' U' R2 U2 R2'",
          "R2 U2' R2' U R2 U' R2' U2 R2' U2' R2 U' R2' U2' R' U2' R2'",
          "R2' U2 R' U2 R2' U R2 U2 R2' U2' R2' U R2 U' R2' U2 R2",
          "R2' U2' R2 U R2' U' R2 U2 R2 U2' R2' U' R2 U2' R U2' R2",
          "R' U' R U R2' U2 R2 U2' R2' U R2 U' R2' U R",
          "R' U' R U2' R2' U2' R2 U2 R2' U' R2 U' R2' U R",
          "R' U' R' U' R2 U R2' U R2 U2' R2' U2 R2 U2 R'",
          "R' U' R' U' R2 U R2' U' R2 U2 R2' U2' R2 U' R'",
          "R U2' R2 U' R2' U2' R2 U2' R2 U2 R2' U' R2 U' R2' U2 R2",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          4,
          1,
          2,
          2,
          3,
          4,
          3,
          4,
          5,
          5,
          2,
          3,
          1,
          5,
        ],
      },
      {
        name: 'B2+',
        scr: [
          "R U' R' U2 R2 U R2' U' R2 U2 R2' U R U R U2' R2'",
          "R U' R' U2' R2 U R' U R U' R' U2 R' U2' R2 U' R2'",
          "R2' U' R2' U2' R2' U2 R' U R2' U2' R2' U R2 U' R2' U' R",
          "R2 U R2' U2 R U2' R U R' U' R U' R2' U2 R U R'",
          "R2 U2 R' U' R' U' R2 U2' R2' U R2 U' R2' U2' R U R'",
          "R' U R2 U R2' U' R2 U2 R2 U' R U2' R2 U2 R2 U R2",
          "R U' R2' U2 R2' U R2 U2 R U2 R2 U2 R2' U R U R U2' R2'",
          "R2' U2 R U2 R U' R U2 R2 U' R2 U' R2 U' R2' U R' U' R'",
          "R2' U' R2' U R2' U R' U R2' U2' R2' U R2 U2' R2 U2' R U' R",
          "R2' U' R2' U2' R2' U2 R' U R2' U2 R2' U R2 U R2' U' R2 U' R'",
          "R2' U' R' U2 R2 U R2 U2 R U' R2 U2' R' U' R2' U2 R U2' R2'",
          "R' U R U R' U R2' U2 R2 U2 R U' R2 U R2 U' R2' U2 R2'",
          "R2 U' R2' U' R2' U2' R U2' R2 U2 R2 U2' R U2 R U2 R' U2 R2'",
          "R U R2 U R' U R2' U2' R2 U' R2' U R2 U R' U' R2 U' R2",
          "R2 U2 R U2 R2' U2' R' U' R U2' R2 U2 R' U R2' U R2 U2 R2'",
          "R2 U2' R2' U' R2 U2' R' U R' U' R2' U R2 U R U' R2 U' R2",
          "R2 U2' R2' U' R2 U' R U2' R2' U2 R' U R U2 R2 U2' R' U2' R2'",
          "R2' U R2' U R U' R2' U' R2 U R2' U2 R2 U' R U' R2' U' R'",
          "R2' U R2' U R' U' R2' U' R2 U R U' R U2 R2' U R2 U2 R2'",
          "R2' U R2' U R' U' R2' U' R2 U R U' R2 U2 R2 U R2' U2 R2",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          3,
          1,
          2,
          3,
          3,
          4,
          2,
          4,
          5,
          1,
          2,
          3,
          5,
          5,
        ],
      },
      {
        name: 'B2-',
        scr: [
          "R2 U R2 U2 R2 U2' R U' R2 U2 R2 U' R2' U R2 U R'",
          "R' U R U2 R2' U' R U' R' U R U2' R U2 R2' U R2",
          "R' U R U2' R2' U' R2 U R2' U2' R2 U' R' U' R' U2 R2",
          "R U' R2' U' R2 U R2' U2' R2' U R' U2 R2' U2' R2' U' R2'",
          "R2' U2' R U R U R2' U2 R2 U' R2' U R2 U2 R' U' R",
          "R2' U' R2 U2' R' U2 R' U' R U R' U R2 U2' R' U' R",
          "R U' R' U' R U' R2 U2' R2' U2' R' U R2' U' R2' U R2 U2' R2",
          "R2 U R U2' R2' U' R2' U2' R' U R2' U2 R U R2 U2' R' U2 R2",
          "R2 U R2 U2 R2 U2' R U' R2 U2' R2 U' R2' U' R2 U R2'",
          "R2 U R2 U' R2 U' R U' R2 U2 R2 U' R2' U2 R2' U2 R' U R'",
          "R2 U2' R' U2' R' U R' U2' R2' U R2' U R2' U R2 U' R",
          "R' U R2 U2' R2 U' R2' U2' R' U2' R2' U2' R2 U' R' U' R' U2 R2",
          "R2 U' R2' U2 R2 U' R2' U2' R2 U R2 U2 R2' U R2 U2 R2' U' R2'",
          "R2 U' R2' U2 R2 U' R2' U2' R2 U R2' U2 R2 U R2' U2 R2 U' R2'",
          "R2' U' R2 U2 R2' U' R2 U2' R2' U R2 U2 R2' U R2 U2 R2' U' R2",
          "R2' U' R2 U2 R2' U' R2 U2' R2' U R2' U2 R2 U R2' U2 R2 U' R2",
          "R2 U2 R2' U R2 U2 R2 U' R U R2 U' R2' U' R' U R2' U R2'",
          "R2 U' R2 U' R U R2 U R2' U' R' U R2' U2' R2' U' R2 U2' R2'",
          "R2 U' R2 U' R U R2 U R2' U' R' U R' U2' R2 U' R2' U2' R2",
          "R2 U' R2 U' R' U R2 U R2' U' R2 U2' R2' U R' U R2",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          3,
          1,
          2,
          2,
          3,
          4,
          1,
          4,
          5,
          5,
          2,
          3,
          4,
          5,
        ],
      },
    ],
  },
  {
    cat: 'C',

    cases: [
      {
        name: 'C1+',
        scr: [
          "R U2 R' U2 R' U2' R2 U' R' U R' U2 R U2 R U' R'",
          "R U R' U2' R' U2' R U' R U R2' U2 R U2' R U2' R'",
          "R U2 R' U R2' U R U2' R2' U2 R2' U2' R' U2 R2 U' R2' U2 R'",
          "R2 U R' U R' U2 R' U2' R2 U' R' U R' U2 R U2 R2 U' R2'",
          "R2' U R U2' R U2 R' U R2 U R2 U2 R2' U2 R' U' R'",
          "R2' U R2 U2 R U2 R2 U' R U R2' U R2' U' R2 U' R2 U' R'",
          "R2' U R2' U R' U2 R' U2' R2 U' R' U R' U2 R U2 R2' U' R2",
          "R' U2 R U R U2' R2 U' R2 U' R' U R' U R2' U2 R2' U2 R",
          "R' U' R U2 R2' U2 R2 U R' U' R' U2' R U R U2 R'",
          "R U2 R U2' R U R2 U2 R' U2' R U2 R' U2 R2 U R2 U R2'",
          "R2' U2 R2' U R' U' R2' U2' R2 U2 R' U' R2 U' R' U R'",
          "R U2 R2 U R2' U' R2 U' R U R2' U R2' U' R2 U' R2 U' R'",
          "R U' R2 U2 R U R2' U2 R' U' R U2' R' U2 R' U' R' U2' R'",
          "R U2 R' U2 R U R' U' R U2 R U2 R' U R' U' R2 U2' R2'",
          "R U2 R' U' R U2' R' U R U R2' U' R U' R U R2'",
          "R2 U R2' U R2' U2' R U2' R' U2 R' U' R' U' R' U R2 U2' R2",
          "R2 U2 R2' U R U' R U2' R' U2' R' U R U' R' U2' R U2' R'",
          "R2 U2' R' U2' R U2 R' U2 R' U2 R U R U R' U' R U' R2'",
          "R2' U' R2 U' R U R2 U R2' U2' R' U2' R U2' R' U' R U2' R'",
          "R2' U' R2 U' R U R2 U R2' U2' R' U' R U2 R' U R U2 R'",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          3,
          1,
          1,
          2,
          4,
          3,
          4,
          3,
          5,
          1,
          5,
          4,
          5,
          2,
          2,
        ],
      },
      {
        name: 'C1-',
        scr: [
          "R' U2' R U2' R U2 R2' U R U' R U2' R' U2' R' U R",
          "R' U' R U2 R U2 R' U R' U' R2 U2' R' U2 R' U2 R",
          "R U R' U2' R2 U2' R2' U' R U R U2 R' U' R' U2' R U' R'",
          "R U2' R' U' R' U2 R2' U R2' U R U' R U' R2 U2' R2 U2' R'",
          "R2 U' R2 U' R U2' R U2 R2' U R U' R U2' R' U2' R2 U R2'",
          "R2 U' R2' U2' R' U2' R2' U R' U' R2 U' R2 U R2' U R2'",
          "R2 U' R' U2 R' U2' R U' R2' U' R2' U2' R2 U2' R U R U' R'",
          "R2' U' R U' R U2' R U2 R2' U R U' R U2' R' U2' R2' U R2",
          "R' U2' R U' R2 U' R' U2 R2 U2' R2 U2 R U2' R2' U R2 U2' R",
          "R' U R2' U2' R' U' R2 U2' R U R' U2 R U2' R U R U2 R",
          "R' U2' R2' U' R2 U R2' U R' U' R2 U' R2 U R2' U R2'",
          "R2 U2' R2 U' R U R2 U2 R2' U2' R U R2' U R U' R U' R'",
          "R' U2' R' U2 R' U' R2' U2' R U2 R' U2' R U2' R2' U' R2' U' R2",
          "R U R2' U R U' R U' R2' U R U R' U2' R U' R' U2 R",
          "R2 U R2' U R' U' R2' U' R2 U2 R U R' U2' R U' R' U2' R",
          "R2 U R2' U R' U' R2' U' R2 U2 R U2 R' U2 R U R' U2 R",
          "R2' U2 R U2 R' U2' R U2' R U2' R' U' R' U' R U R' U R2",
          "R2' U2' R2 U' R' U R' U2 R U2 R U' R' U R U2 R' U2 R",
          "R2' U' R2 U' R2 U2 R' U2 R U2' R U R U R U' R2' U2 R2'",
          "R' U2' R U R' U2 R U' R' U' R2 U R' U R' U' R2 U' R'",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          4,
          5,
          5,
          2,
          3,
          2,
          1,
          2,
          4,
          3,
          4,
          3,
          5,
        ],
      },
      {
        name: 'C2+',
        scr: [
          "R' U' R U' R U2 R2' U' R2 U' R2' U2' R U R' U2 R",
          "R U2' R' U2' R U' R2' U2' R U' R U R2' U2 R2 U2 R'",
          "R' U2' R U' R' U2 R2 U R2' U R2 U2' R' U R' U R",
          "R U2' R2' U2' R2 U' R' U R' U2 R2 U R' U2 R U2 R'",
          "R' U' R U' R U R' U R U2' R' U2 R' U R U' R' U2' R",
          "R2 U R2' U2 R2 U2' R2' U' R2 U R2' U2' R2 U' R2' U' R2 U' R2'",
          "R2 U2' R2' U2' R2 U2 R2' U2 R2 U R2' U2' R2 U' R2' U' R2 U' R2'",
          "R2' U R2 U2 R2' U2' R2 U' R2' U R2 U2' R2' U' R2 U' R2' U' R2",
          "R2' U2' R2 U2' R2' U2 R2 U2 R2' U R2 U2' R2' U' R2 U' R2' U' R2",
          "R U2 R U R U2' R U2 R2' U2' R2 U2 R2 U2' R' U R' U2' R'",
          "R U2 R U R U2' R' U2 R2 U2' R2' U2 R' U2' R' U R' U2' R'",
          "R U2 R U' R U2 R U2' R2 U2 R2' U2' R U2 R' U' R' U2' R'",
          "R U2 R U' R U2 R2' U2' R2' U2 R2 U2' R' U2 R' U' R' U2' R'",
          "R U2 R' U' R U' R' U R' U2 R2 U R' U R U2' R2' U2' R",
          "R' U2 R2 U2 R' U' R U' R2' U2' R U' R U R' U R U2' R'",
          "R' U' R U' R' U2 R U R U2' R' U' R U' R' U R U2' R'",
          "R U2' R U R2' U2 R2 U' R U2' R' U' R' U R2 U2 R' U2' R2'",
          "R U2' R2' U2' R U2 R' U2' R2 U' R' U2 R' U R U2' R' U' R",
          "R U2' R' U2 R2' U2' R U' R U R U' R' U R' U' R' U2' R2",
          "R U2' R' U2' R U' R' U2 R2 U R' U R' U R U2' R U' R2'",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          3,
          1,
          1,
          2,
          3,
          5,
          1,
          5,
          4,
          5,
          4,
          3,
          4,
          2,
          2,
        ],
      },
      {
        name: 'C2-',
        scr: [
          "R U R' U R' U2' R2 U R2' U R2 U2 R' U' R U2' R'",
          "R' U2 R2 U2 R2' U R U' R U2' R2' U' R U2' R' U2' R",
          "R U2 R' U R U2' R2' U' R2 U' R2' U2 R U' R U' R'",
          "R' U2 R U2 R' U R2 U2 R' U R' U' R2 U2' R2' U2' R",
          "R U R' U R' U' R U' R' U2 R U2' R U' R' U R U2 R'",
          "R U R' U R U2' R' U' R' U2 R U R' U R U' R' U2 R",
          "R U2' R2' U2' R U R' U R2 U2 R' U R' U' R U' R' U2 R",
          "R' U2' R U R' U R U' R U2' R2' U' R U' R' U2 R2 U2 R'",
          "R' U2' R' U R' U2' R2 U2 R2 U2' R2' U2 R U2' R U R U2 R",
          "R' U2' R' U R' U2' R' U2 R2' U2' R2 U2 R' U2' R U R U2 R",
          "R' U2' R' U' R' U2 R U2' R2' U2 R2 U2' R U2 R U' R U2 R",
          "R' U2' R' U' R' U2 R' U2' R2 U2 R2' U2' R2' U2 R U' R U2 R",
          "R2 U2 R2' U2 R2 U2' R2' U2' R2 U' R2' U2 R2 U R2' U R2 U R2'",
          "R2 U' R2' U2' R2 U2 R2' U R2 U' R2' U2 R2 U R2' U R2 U R2'",
          "R2' U2 R2 U2 R2' U2' R2 U2' R2' U' R2 U2 R2' U R2 U R2' U R2",
          "R2' U' R2 U2' R2' U2 R2 U R2' U' R2 U2 R2' U R2 U R2' U R2",
          "R U R' U R' U2' R2 U' R U2 R2 U R2' U2 R2' U' R U2' R'",
          "R U2 R2' U' R2 U' R' U R' U R U2 R' U2 R U2 R'",
          "R2 U R2' U2 R' U2 R' U2 R U2' R U2' R U R U' R U' R2'",
          "R2 U R' U R' U' R' U2 R' U2 R' U2' R U R2' U' R2 U2' R",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          4,
          5,
          5,
          3,
          4,
          3,
          2,
          3,
          2,
          1,
          2,
          4,
          5,
        ],
      },
      {
        name: 'C3+',
        scr: [
          "R2 U2 R2' U R2 U' R2' U2' R2 U' R2' U2 R2 U2' R2'",
          "R2' U2 R2 U R2' U' R2 U2' R2' U' R2 U2 R2' U2' R2",
          "R2 U2' R2' U2 R2 U' R2' U2 R2 U R2' U' R2 U2' R2'",
          "R2' U2' R2 U2 R2' U' R2 U2 R2' U R2 U' R2' U2' R2",
          "R2 U2 R2' U R2 U' R2' U2' R2 U R2' U2' R2 U2 R2'",
          "R2' U2 R2 U R2' U' R2 U2' R2' U R2 U2' R2' U2 R2",
          "R2 U2 R2' U2' R2 U R2' U2 R2 U R2' U' R2 U2' R2'",
          "R2' U2 R2 U2' R2' U R2 U2 R2' U R2 U' R2' U2' R2",
          "R2 U2 R2' U R2 U2 R U2 R2 U2' R2' U' R2 U2 R2' U2' R2",
          "R2 U2 R2' U R2 U' R2 U2' R2' U' R2 U2' R U' R2 U2' R2'",
          "R2 U2 R2' U2' R' U2' R2' U' R2 U2' R2' U' R2' U2 R2 U2' R2'",
          "R2' U2 R2 U R2' U2 R' U2 R2' U2' R2 U' R2' U2 R2 U2' R2'",
          "R2' U2 R2 U R2' U' R2' U2' R2 U' R2' U2' R' U' R2' U2' R2",
          "R2' U2 R2 U2' R U2' R2 U' R2' U2' R2 U' R2 U2 R2' U2' R2",
          "R2 U2 R2 U' R2 U' R2 U' R2' U R2' U R U2' R2 U2' R",
          "R2 U2' R2' U2 R2 U' R2 U2 R2' U R2 U2 R U2 R2 U2' R2'",
          "R2 U2' R2' U2 R2 U' R2' U2 R2 U2' R U2' R2 U' R2' U2' R2",
          "R2' U2' R2 U2 R2' U' R2 U2 R2' U2' R' U2' R2' U' R2 U2' R2'",
          "R2' U2' R2 U2 R2' U' R2' U2 R2 U R2' U2 R' U2 R2' U2' R2",
          "R2 U2 R2' U R2 U2 R U2 R2 U2' R2' U R2 U2' R2' U2 R2",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          3,
          1,
          1,
          2,
          5,
          4,
          5,
          4,
          3,
          4,
          3,
          5,
          1,
          2,
          2,
        ],
      },
      {
        name: 'C3-',
        scr: [
          "R2 U2' R2' U' R2 U R2' U2 R2 U R2' U2' R2 U2 R2'",
          "R2' U2' R2 U' R2' U R2 U2 R2' U R2 U2' R2' U2 R2",
          "R2 U2 R2' U2' R2 U R2' U2' R2 U' R2' U R2 U2 R2'",
          "R2' U2 R2 U2' R2' U R2 U2' R2' U' R2 U R2' U2 R2",
          "R2 U2' R2' U2 R2 U' R2' U2' R2 U' R2' U R2 U2 R2'",
          "R2' U2' R2 U2 R2' U' R2 U2' R2' U' R2 U R2' U2 R2",
          "R2 U2' R2' U' R2 U R2' U2 R2 U' R2' U2 R2 U2' R2'",
          "R2' U2' R2 U' R2' U R2 U2 R2' U' R2 U2 R2' U2' R2",
          "R2' U2' R2' U R2' U R2' U R2 U' R2 U' R' U2 R2' U2 R'",
          "R2 U2' R2' U2 R' U2 R2' U R2 U2 R2' U R2' U2' R2 U2 R2'",
          "R2 U2' R2' U' R2 U R2 U2 R2' U R2 U2 R U R2 U2 R2'",
          "R2 U2' R2' U' R2 U2' R U2' R2 U2 R2' U R2 U2' R2' U2 R2",
          "R2' U2' R2 U2 R U2 R2 U R2' U2 R2 U R2 U2' R2' U2 R2",
          "R2' U2' R2 U' R2' U R2' U2 R2 U R2' U2 R' U R2' U2 R2",
          "R2' U2' R2 U' R2' U2' R' U2' R2' U2 R2 U R2' U2' R2 U2 R2'",
          "R2 U2 R2' U2' R2 U R2 U2' R2' U' R2 U2' R U2' R2 U2 R2'",
          "R2 U2 R2' U2' R2 U R2' U2' R2 U2 R U2 R2 U R2' U2 R2",
          "R2' U2 R2 U2' R2' U R2 U2' R2' U2 R' U2 R2' U R2 U2 R2'",
          "R2' U2 R2 U2' R2' U R2' U2' R2 U' R2' U2' R' U2' R2' U2 R2",
          "R U2' R2 U2' R U R2' U R2' U' R2 U' R2 U' R2 U2 R2",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          4,
          5,
          5,
          1,
          2,
          4,
          3,
          4,
          3,
          2,
          3,
          2,
          5,
        ],
      },
      {
        name: 'C4+',
        scr: [
          "R2 U2' R2' U' R2 U2' R2' U R2 U2 R2' U R2 U2 R2'",
          "R2 U2' R2' U' R2 U2' R2' U R2' U2 R2 U R2' U2 R2",
          "R2' U2' R2 U' R2' U2' R2 U R2 U2 R2' U R2 U2 R2'",
          "R2' U2' R2 U' R2' U2' R2 U R2' U2 R2 U R2' U2 R2",
          "R2' U R2' U R2' U R2 U2' R' U' R' U2 R U2 R2' U2' R2",
          "R U2' R U2 R U2' R2' U' R2 U2' R2' U' R U2' R' U2 R'",
          "R U2' R U2 R2 U2' R2 U' R2' U2' R2 U' R U2' R' U2 R'",
          "R2 U2' R2' U' R2 U R U2 R2 U R2' U2 R2 U R2 U2 R2'",
          "R2' U2' R2 U' R2' U R' U2 R2' U R2 U2 R2' U R2' U2 R2",
          "R U R2' U2 R U' R2 U2' R' U' R' U R2 U2 R2 U' R2 U' R'",
          "R U R' U2 R2' U2 R' U2' R U2 R2 U' R2 U' R2 U R U' R",
          "R U2 R' U' R U' R' U2 R U2' R' U2' R U R' U' R U' R'",
          "R' U2' R U' R' U2' R2 U2' R2' U' R U2' R' U2' R U2' R U2 R'",
          "R' U2' R2 U2' R2' U' R' U R2 U' R U' R' U R2' U' R2' U' R'",
          "R' U2' R2' U2' R2 U' R U' R' U R2' U R2 U2' R U R2 U2' R2'",
          "R U2 R U2' R' U' R U2' R' U2 R' U2' R2 U2' R2' U' R2 U2' R2'",
          "R U2 R U2' R' U' R U2' R' U2 R' U2' R2' U2' R2 U' R2' U2' R2",
          "R U2' R U2 R' U R U2 R' U2' R' U2' R2 U2' R2' U' R2 U2' R2'",
          "R U2' R U2 R' U R U2 R' U2' R' U2' R2' U2' R2 U' R2' U2' R2",
          "R U2' R U2 R' U2' R' U R U R' U2 R2 U2 R2' U' R U' R'",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          5,
          1,
          1,
          2,
          3,
          5,
          1,
          2,
          3,
          4,
          5,
          2,
          3,
          4,
          4,
        ],
      },
      {
        name: 'C4-',
        scr: [
          "R2 U2 R2' U R2 U2 R2' U' R2 U2' R2' U' R2 U2' R2'",
          "R2 U2 R2' U R2 U2 R2' U' R2' U2' R2 U' R2' U2' R2",
          "R2' U2 R2 U R2' U2 R2 U' R2 U2' R2' U' R2 U2' R2'",
          "R2' U2 R2 U R2' U2 R2 U' R2' U2' R2 U' R2' U2' R2",
          "R2 U' R2 U' R2 U' R2' U2 R U R U2' R' U2' R2 U2 R2'",
          "R' U2 R' U2' R2' U2 R2' U R2 U2 R2' U R' U2 R U2' R",
          "R' U2 R' U2' R' U2 R2 U R2' U2 R2 U R' U2 R U2' R",
          "R2 U2 R2' U R2 U' R U2' R2 U' R2' U2' R2 U' R2 U2' R2'",
          "R2' U2 R2 U R2' U' R' U2' R2' U' R2 U2' R2' U' R2' U2' R2",
          "R U2 R2 U2 R2' U R' U R U' R2 U' R2' U2 R' U' R2' U2 R2",
          "R U2 R2' U2 R2 U R U' R2' U R' U R U' R2 U R2 U R",
          "R U2 R' U R U2 R2' U2 R2 U R' U2 R U2 R' U2 R' U2' R",
          "R' U2' R U R' U R U2' R' U2 R U2 R' U' R U R' U R",
          "R' U' R U2' R2 U2' R U2 R' U2' R2' U R2' U R2' U' R' U R'",
          "R' U' R2 U2' R' U R2' U2 R U R U' R2' U2' R2' U R2' U R",
          "R2' U' R2 U' R2' U2 R U2 R U' R U2 R' U' R U' R2' U' R",
          "R' U2' R' U2 R U2' R U R' U' R U2' R2' U2' R2 U R' U R",
          "R2 U2' R2 U' R U R2 U R2' U' R' U R2' U2' R2' U R2 U2 R2'",
          "R2' U2 R' U2' R2 U2 R U R' U2 R2' U2' R U' R2 U R2' U2 R2",
          "R2 U' R U R2 U2 R2' U2 R U2 R2' U R2 U' R U R' U2 R",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          2,
          3,
          3,
          4,
          5,
          2,
          3,
          4,
          5,
          1,
          2,
          4,
          5,
        ],
      },
      {
        name: 'C5+',
        scr: [
          "R' U2' R U2' R' U' R U R' U2' R' U2' R U' R' U2' R2",
          "R U R U2 R2' U R U' R U2' R' U2' R' U2' R U2' R'",
          "R U2 R2 U' R' U2 R2 U2' R2 U2 R U2' R2' U R2' U2' R'",
          "R2 U2' R2' U2' R2 U' R U R' U R2' U R2 U2' R U' R2",
          "R' U2' R U2' R' U' R2' U R2 U R U R' U2' R2' U' R2'",
          "R U2' R2 U R2 U2 R' U2' R2' U2 R2' U2' R U' R2' U2 R'",
          "R' U2' R U2' R' U' R U R' U' R' U2 R U R' U2 R U R",
          "R U2 R2 U' R' U2 R2 U2 R2 U2' R U2 R2 U R U R2' U2' R'",
          "R2' U R2' U R U R2 U2 R2 U2' R U2 R2 U2 R' U' R2 U' R2",
          "R2' U R2' U R U R2 U2' R2 U2 R U2' R2 U R' U' R2 U' R2",
          "R2' U2' R' U2' R2 U' R' U2 R2' U2' R2' U2 R2' U' R2' U2 R U2 R2",
          "R' U' R2' U2 R2 U' R' U2 R2' U2' R2' U2 R2' U' R2' U2' R2 U R",
          "R U2 R' U R' U' R2 U2' R2' U2' R U R U R' U R U2' R'",
          "R U2' R' U' R U' R' U R U2' R' U2 R U2' R' U2' R U' R'",
          "R2 U2' R2' U' R2 U R2' U' R2 U2' R2' U' R2 U2 R2' U R2 U2 R2'",
          "R2 U2' R2' U' R2 U R2' U' R2 U2' R2' U' R2' U2 R2 U R2' U2 R2",
          "R2' U2' R2 U' R2' U R2 U' R2' U2' R2 U' R2 U2 R2' U R2 U2 R2'",
          "R2' U2' R2 U' R2' U R2 U' R2' U2' R2 U' R2' U2 R2 U R2' U2 R2",
          "R2' U' R2' U R U2 R U2 R' U' R' U2' R U' R U2' R2' U2 R'",
          "R U2 R2 U' R U R2' U R2' U' R' U2' R' U' R' U2 R' U R2",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          4,
          1,
          1,
          2,
          4,
          5,
          1,
          5,
          2,
          3,
          2,
          4,
          5,
          3,
          3,
        ],
      },
      {
        name: 'C5-',
        scr: [
          "R U2 R' U2 R U R' U' R U2 R U2 R' U R U2 R2'",
          "R' U2' R2' U R U2' R2' U2 R2' U2' R' U2 R2 U' R2 U2 R",
          "R' U' R' U2' R2 U' R' U R' U2 R U2 R U2 R' U2 R",
          "R U2 R' U2 R U R2 U' R2' U' R' U' R U2 R2 U R2",
          "R2' U2 R2 U2 R2' U R' U' R U' R2 U' R2' U2 R' U R2'",
          "R' U2 R2' U' R2' U2' R U2 R2 U2' R2 U2 R' U R2 U2' R",
          "R U2 R' U2 R U R' U' R U R U2' R' U' R U2' R' U' R'",
          "R2 U R2 U' R' U2' R' U2' R U R U2 R' U R' U2 R2 U2' R",
          "R2 U2 R2' U R2 U' R2' U R2 U2 R2' U R2 U2' R2' U' R2 U2' R2'",
          "R2 U2 R2' U R2 U' R2' U R2 U2 R2' U R2' U2' R2 U' R2' U2' R2",
          "R2' U2 R2 U R2' U' R2 U R2' U2 R2 U R2 U2' R2' U' R2 U2' R2'",
          "R2' U2 R2 U R2' U' R2 U R2' U2 R2 U R2' U2' R2 U' R2' U2' R2",
          "R' U2 R U R' U R U' R' U2 R U2' R' U2 R U2 R' U R",
          "R' U2' R U' R U R2' U2 R2 U2 R' U' R' U' R U' R' U2 R",
          "R U R2 U2' R2' U R U2' R2 U2 R2 U2' R2 U R2 U2 R2' U' R'",
          "R2 U2 R U2 R2' U R U2' R2 U2 R2 U2' R2 U R2 U2' R' U2' R2'",
          "R2 U' R2 U' R' U' R2' U2 R2' U2' R' U2 R2' U' R U R2' U R2'",
          "R2 U' R2 U' R' U' R2' U2' R2' U2 R' U2' R2' U2' R U R2' U R2'",
          "R' U2' R2' U R U2' R2' U2' R2' U2 R' U2' R2' U' R' U' R2 U2 R",
          "R U2 R' U R2' U2 R U R U R' U' R' U2 R U2 R2 U R'",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          3,
          4,
          4,
          2,
          3,
          5,
          4,
          5,
          2,
          1,
          2,
          3,
          5,
        ],
      },
      {
        name: 'C6+',
        scr: [
          "R U R U R' U R U R' U2' R U' R2' U2' R U R'",
          "R U2 R U2' R' U' R' U' R' U R2' U2' R' U2 R2' U' R",
          "R U2 R U2' R' U' R' U' R' U2 R2' U2 R' U2' R2' U2' R",
          "R2' U' R U2' R2 U2' R2' U' R2 U' R2 U R2 U' R U' R'",
          "R U2' R' U2' R U R' U' R U' R' U R' U' R U' R' U2 R",
          "R U R U R' U R' U2' R U R2' U2' R' U R2' U' R U2 R",
          "R' U2 R U R2 U2 R2' U R2 U2 R' U R2' U2 R U2' R U' R'",
          "R' U2 R U R2' U2 R2 U R2' U2 R2' U R2' U2 R U2' R U' R'",
          "R U2' R U2 R' U2' R U2 R2' U R2 U2 R' U2 R U2' R' U2 R'",
          "R U2' R U2 R' U2' R2 U2 R2 U R2' U2 R2' U2 R U2' R' U2 R'",
          "R2 U2' R U2 R U R U2 R' U2 R U2' R2' U2' R' U2 R U2 R2",
          "R2' U R2' U R U' R2 U2 R U2 R2 U R2' U R U' R2' U' R'",
          "R2' U R2' U R U' R2 U' R2' U R2 U2 R U' R U' R2' U' R'",
          "R U' R U R' U2 R2' U2' R2' U' R2 U R2 U' R2' U2' R2 U2 R'",
          "R2 U' R2 U2' R2 U2' R2' U' R' U2' R' U R U R2' U' R U R2'",
          "R2' U2 R2' U2' R2 U' R2' U R2' U2 R' U R U2 R2 U2' R2 U R2",
          "R' U2 R2 U2' R2' U' R2 U R' U2 R' U R U2 R U2' R2' U R",
          "R U R U2 R2' U2' R2 U' R2' U R2 U' R' U2 R' U2' R U R'",
          "R U R2 U' R2 U2' R2 U2' R U2' R' U' R U R2 U' R U2' R'",
          "R U R' U R' U' R2 U' R2' U2 R U R U R' U2 R U2 R'",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          5,
          1,
          1,
          2,
          5,
          3,
          4,
          3,
          2,
          3,
          2,
          5,
          1,
          4,
          4,
        ],
      },
      {
        name: 'C6-',
        scr: [
          "R' U' R' U' R U' R' U' R U2 R' U R2 U2 R' U' R",
          "R2 U R' U2 R2' U2 R2 U R2' U R2' U' R2' U R' U R",
          "R' U2' R' U2 R U R U R U2' R2 U2' R U2 R2 U2 R'",
          "R' U2' R' U2 R U R U R U' R2 U2 R U2' R2 U R'",
          "R' U2 R U2 R' U' R U R' U R U' R U R' U R U2' R'",
          "R U2' R2' U2 R2 U R2' U' R U2' R U' R' U2' R' U2 R2 U' R'",
          "R2 U2' R2 U2 R2' U R2 U' R2 U2' R U' R' U2' R2' U2 R2' U' R2'",
          "R2' U R2' U2 R2' U2 R2 U R U2 R U' R' U' R2 U R' U' R2",
          "R' U R' U' R U2' R2 U2 R2 U R2' U' R2' U R2 U2 R2' U2' R",
          "R2 U' R2 U' R' U R2' U R2 U' R2' U2' R' U R' U R2 U R",
          "R2 U' R2 U' R' U R2' U2' R' U2' R2' U' R2 U' R' U R2 U R",
          "R2' U2 R' U2' R' U' R' U2' R U2' R' U2 R2 U2 R U2' R' U2' R2'",
          "R' U2 R' U2' R U2 R2' U2' R2' U' R2 U2' R2 U2' R' U2 R U2' R",
          "R' U2 R' U2' R U2 R' U2' R2 U' R2' U2' R U2' R' U2 R U2' R",
          "R U2' R' U' R2 U2' R2' U' R2 U2' R2 U' R2 U2' R' U2 R' U R",
          "R U2' R' U' R2' U2' R2 U' R2' U2' R U' R2 U2' R' U2 R' U R",
          "R' U' R' U' R U' R U2 R' U' R2 U2 R U' R2 U R' U2' R'",
          "R U R' U2 R2 U2 R2' U R2 U2 R2 U' R2 U' R' U R' U R",
          "R U R' U2 R2' U2 R2 U R2' U2 R U' R2 U' R' U R' U R",
          "R U2' R2' U2' R U' R2' U2' R U' R' U2' R U2 R U2' R U2 R'",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          2,
          3,
          3,
          1,
          2,
          5,
          4,
          5,
          4,
          3,
          4,
          2,
          5,
        ],
      },
    ],
  },
  {
    cat: 'D',
    cases: [
      {
        name: 'D+',
        scr: [
          "R' U2' R U R' U' R U' R' U2 R U2' R' U2' R",
          "R2' U' R U R2 U R2' U2 R2 U2 R2 U2' R U R' U2 R2",
          "R2' U R2 U R2 U' R2 U' R2' U2 R U R U2' R' U2 R2",
          "R U R2' U2 R2 U2 R2' U R U R' U' R U' R' U2 R",
          "R U2 R' U' R U' R' U R U R2' U2 R2 U2 R2'",
          "R2 U2 R' U R U2' R2 U2 R2 U2 R2' U R2 U R U' R2'",
          "R2 U2 R' U2' R U R U2 R2' U' R2 U' R2 U R2 U R2'",
          "R U R2 U2 R U' R2' U' R' U' R U R2 U2 R2' U' R U2' R2",
          "R U R' U R U R' U' R U' R' U2 R U2' R' U2 R U2 R'",
          "R U2' R2 U R2 U2 R U2' R2 U' R2 U' R U' R' U R U2' R'",
          "R U2' R2' U2' R U R' U' R2 U R2' U R2 U2' R' U R U2' R'",
          "R2 U2' R2' U' R2 U2 R2' U' R2 U' R2' U2' R2 U2' R2' U' R2 U R2'",
          "R2' U2 R U2' R2 U R U2 R' U R2' U2' R2' U' R U2' R2' U R'",
          "R2' U2' R2 U' R2' U2 R2 U' R2' U' R2 U2' R2' U2' R2 U' R2' U R2",
          "R2' U' R U' R' U2 R2' U R2 U2 R2' U2 R2 U2' R U R' U2 R2",
          "R2' U' R2' U R2' U R2 U2' R' U' R' U2 R' U2' R2 U R2' U2 R2",
          "R' U2' R U2 R' U R2 U2 R2' U' R2 U' R2' U' R U2 R' U2' R",
          "R' U' R2' U' R' U2' R' U R' U2 R U2 R U2 R2' U2 R2' U2' R2'",
          "R2 U2 R2' U2 R U R U2' R2 U2 R2 U2 R2' U R2 U R U R2'",
          "R2 U2 R2' U2' R2 U2' R' U2 R' U' R' U2' R2 U R2' U R2' U R2'",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          3,
          4,
          4,
          4,
          5,
          2,
          1,
          2,
          3,
          2,
          3,
          5,
          5,
        ],
      },
      {
        name: 'D-',
        scr: [
          "R U2 R' U' R U R' U R U2' R' U2 R U2 R'",
          "R2 U R' U' R2' U' R2 U2' R2' U2' R2' U2 R' U' R U2' R2'",
          "R2 U' R2' U' R2' U R2' U R2 U2' R' U' R' U2 R U2' R2'",
          "R' U' R2 U2' R2' U2' R2 U' R' U' R U R' U R U2' R'",
          "R2' U2' R U2 R' U' R' U2' R2 U R2' U R2' U' R2' U' R2",
          "R2' U2' R U' R' U2 R2' U2' R2' U2' R2 U' R2' U' R' U R2",
          "R' U2' R U R' U R U' R' U' R2 U2' R2' U2' R2 U' R'",
          "R U R2 U R U2 R U' R U2' R' U2' R' U2' R2 U2' R2 U2 R2",
          "R U2 R' U2' R U' R2' U2' R2 U R2' U R2 U R' U2' R U2 R'",
          "R2 U R2 U' R2 U' R2' U2 R U R U2' R U2 R2' U' R2 U2' R2'",
          "R2 U R' U R U2' R2 U' R2' U2' R2 U2' R2' U2 R' U' R U2' R2'",
          "R2 U2 R2' U R2 U2' R2' U R2 U R2' U2 R2 U2 R2' U R2 U' R2'",
          "R2 U2' R' U2 R2' U' R' U2' R U' R2 U2 R2 U R' U2 R2 U' R",
          "R2' U2 R2 U R2' U2' R2 U R2' U R2 U2 R2' U2 R2 U R2' U' R2",
          "R' U2 R2 U2 R' U' R U R2' U' R2 U' R2' U2 R U' R' U2 R",
          "R' U2 R2' U' R2' U2' R' U2 R2' U R2' U R' U R U' R' U2 R",
          "R' U' R U' R' U' R U R' U R U2' R' U2 R U2' R' U2' R",
          "R' U' R2' U2' R' U R2 U R U R' U' R2' U2' R2 U R' U2 R2'",
          "R U R U2 R U R' U2 R' U2 R U R2 U R2' U' R2' U' R2'",
          "R U R U2' R2 U2 R2 U2 R2' U R2 U R U' R2' U R2 U2' R2'",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          3,
          4,
          3,
          4,
          5,
          4,
          1,
          2,
          2,
          2,
          3,
          5,
          5,
        ],
      },
    ],
  },
  {
    cat: 'E',
    cases: [
      {
        name: 'E1',
        scr: [
          "R' U2' R U R2' U' R U' R' U R2 U' R' U R' U R",
          "R' U' R' U' R U' R U R2' U' R U R' U R2 U' R' U2 R",
          "R2' U2' R U' R U R2 U2' R U R U2' R2 U R U' R U2' R2'",
          "R2 U R2' U2 R2 U2' R2' U R2 U2' R2' U' R2 U2 R2' U' R2 U' R2'",
          "R2 U2' R2' U2' R2 U2 R2' U' R2 U2' R2' U' R2 U2 R2' U' R2 U' R2'",
          "R2' U R2 U2 R2' U2' R2 U R2' U2' R2 U' R2' U2 R2 U' R2' U' R2",
          "R2' U2' R2 U2' R2' U2 R2 U' R2' U2' R2 U' R2' U2 R2 U' R2' U' R2",
          "R2 U R2' U R2 U2' R2' U R2 U2 R2' U R2 U2' R2' U2 R2 U2 R2'",
          "R2 U R2' U R2 U2' R2' U R2 U2 R2' U' R2 U2 R2' U2' R2 U' R2'",
          "R2 U2 R' U R' U' R2' U2 R' U' R' U2 R2' U' R' U R' U2 R2",
          "R2' U R2 U R2' U2' R2 U R2' U2 R2 U R2' U2' R2 U2 R2' U2 R2",
          "R2' U R2 U R2' U2' R2 U R2' U2 R2 U' R2' U2 R2 U2' R2' U' R2",
          "R U R' U R U' R2' U' R2 U2' R2' U R2 U' R' U2 R'",
          "R U R' U2 R' U' R2 U R2' U2' R2 U' R2' U' R U R'",
          "R' U' R U2' R U R2' U' R2 U2 R2' U R2 U R' U' R U' R'",
          "R' U' R U' R' U R2 U R2' U2 R2 U' R2' U R U2' R U' R'",
          "R U R U R' U R' U' R2 U R' U' R U' R2' U R U2' R'",
          "R U2 R' U' R2 U R' U R U' R2' U R U' R U' R' U' R'",
          "R2 U' R2' U' R2 U2 R2' U' R2 U2' R2' U R2 U2' R2' U2 R2 U R2'",
          "R2 U' R2' U' R2 U2 R2' U' R2 U2' R2' U' R2 U2 R2' U2' R2 U2' R2'",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          2,
          3,
          2,
          1,
          2,
          3,
          4,
          5,
          4,
          3,
          4,
          5,
          5,
        ],
      },
      {
        name: 'E2',
        scr: [
          "R2 U2 R2 U R' U' R U' R2' U R U' R U R' U R' U2 R2'",
          "R2 U2' R U' R U R2' U' R U R' U R2 U' R' U R' U R2'",
          "R2 U2' R U' R U' R' U R' U' R2 U R' U R U' R2' U2' R2'",
          "R2 U' R U' R U R2' U' R U' R' U R2 U' R' U R' U2 R2'",
          "R2' U' R U' R' U' R U R' U2 R2 U2' R' U2' R U' R' U' R",
          "R' U R U R' U2 R U2 R2' U2' R U' R' U R U R' U R2",
          "R' U R2' U2 R U R' U' R U R' U' R U R' U2 R2 U' R",
          "R' U R2' U2' R U' R' U R U' R' U R U' R' U2' R2 U' R",
          "R2 U2' R2' U' R2 U R2' U' R2 U2' R2' U R2 U2 R2' U R2 U2 R2'",
          "R2 U2' R2' U' R2 U R2' U' R2 U2' R2' U R2' U2 R2 U R2' U2 R2",
          "R2' U2' R2 U' R2' U R2 U' R2' U2' R2 U R2 U2 R2' U R2 U2 R2'",
          "R2' U2' R2 U' R2' U R2 U' R2' U2' R2 U R2' U2 R2 U R2' U2 R2",
          "R U2' R' U2' R' U2 R2 U2' R2 U2 R2' U2 R2 U R2 U' R' U2' R",
          "R2 U2' R2' U' R2 U2' R2' U' R2 U2 R2' U R2 U' R2' U R2 U2 R2'",
          "R2 U2' R2' U' R2 U2' R2' U' R2' U2 R2 U R2' U' R2 U R2' U2 R2",
          "R2' U2' R2 U' R2' U2' R2 U' R2 U2 R2' U R2 U' R2' U R2 U2 R2'",
          "R2' U2' R2 U' R2' U2' R2 U' R2' U2 R2 U R2' U' R2 U R2' U2 R2",
          "R' U2 R U R2' U' R2' U2' R2 U2' R2' U2 R2' U2' R U2 R U2 R'",
          "R' U2 R U2 R U2' R2' U2 R2' U2' R2 U2' R2' U' R2' U R U2 R'",
          "R2 U2 R2' U R2 U' R2' U R2 U2 R2' U' R2 U2' R2' U' R2 U2' R2'",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          4,
          5,
          2,
          3,
          4,
          3,
          2,
          3,
          4,
          1,
          2,
          5,
          5,
        ],
      },
      {
        name: 'E3',
        scr: [
          "R' U2 R' U2' R2' U2 R2' U' R2 U' R' U' R2' U2 R U2' R",
          "R' U2 R' U2' R2 U R U R2' U R2 U2' R2 U2 R U2' R",
          "R' U2 R' U2' R2 U R U R2' U2 R2 U2 R2 U2' R U2 R",
          "R U2 R U2' R2 U2 R2 U2 R2' U R U R2 U2' R' U2 R'",
          "R' U2' R' U2 R2' U2' R2' U2' R2 U' R' U' R2' U2 R U2' R",
          "R U2' R U2 R2 U2' R2 U R2' U R U R2 U2' R' U2 R'",
          "R U2' R U2 R2' U' R' U' R2 U2' R2' U2' R2' U2 R' U2' R'",
          "R U2' R U2 R2' U' R' U' R2 U' R2' U2 R2' U2' R' U2 R'",
          "R' U2 R U R' U R U' R' U R U' R' U R U2' R' U2' R",
          "R' U2 R U2 R' U' R U R' U' R U R' U' R U' R' U2' R",
          "R U' R2' U2' R' U2 R2' U2' R2' U' R2 U' R' U' R2' U2 R U2' R",
          "R U2' R2' U2 R' U2 R U2' R2 U2 R' U2' R' U2 R' U2' R U2' R",
          "R2 U2' R2' U' R2 U2' R' U2 R' U R' U' R2 U2' R' U2 R'",
          "R2' U2' R2 U' R2' U2' R2' U2 R' U R' U' R2 U2' R' U2 R'",
          "R' U2 R' U2 R U2' R U2 R U2' R2' U2 R' U2' R U2' R2 U2 R'",
          "R' U2 R' U2' R2 U R U R2' U R2 U2 R2 U2' R U2 R2 U R'",
          "R' U' R U2' R U2 R2' U R U' R U2' R U2 R2' U R2 U2 R2'",
          "R' U' R U2' R U2 R2' U R U' R U2' R2 U2 R2 U R2' U2 R2",
          "R U R' U R U2' R2 U R2 U R' U2' R' U R U R' U' R2",
          "R2 U R2' U' R2 U R2' U2 R2 U R2' U' R2 U R2' U2' R2 U' R2'",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          3,
          4,
          2,
          4,
          5,
          3,
          1,
          2,
          4,
          2,
          3,
          5,
          5,
        ],
      },
    ],
  },
  {
    cat: 'F',
    cases: [
      {
        name: 'F1+',
        scr: [
          "R U R2' U' R2 U2' R2' U2 R U' R' U2 R2 U2 R'",
          "R U R2 U2 R U2' R2 U' R2' U2' R U' R2' U2' R2",
          "R U2' R2 U2 R2' U2' R2 U2 R2' U2' R' U' R2' U2' R2",
          "R U2' R2' U' R2 U2' R U2 R2 U R U' R2 U2' R2'",
          "R2 U R U2 R2 U R2' U2 R' U2' R2' U2' R2 U2' R2'",
          "R2 U R2' U2 R2 U2' R2' U2 R2 U2' R2' U R2 U2' R2'",
          "R2 U2 R2' U2' R' U2 R2' U R2 U2 R U2 R2 U2' R2'",
          "R2 U2 R2' U' R2 U R2' U R2 U' R2' U' R2 U' R2'",
          "R2 U2' R U2 R' U2' R2' U' R2 U2' R U2 R' U2' R2'",
          "R2 U2' R2' U R2 U2' R2' U2 R2 U2' R2' U2 R2 U R2'",
          "R2 U2' R2' U R' U2' R2' U' R2 U2' R U2 R2 U' R2'",
          "R2 U2' R2' U2 R' U2 R2' U R2 U2 R U2' R2 U2 R2'",
          "R2 U2' R2' U2' R2 U2' R U2 R2 U R2' U2 R' U R2'",
          "R2 U2' R2' U' R U2' R2' U' R2 U2' R U2 R2",
          "R2 U2' R2' U' R2 U R U2 R2 U R2' U2 R' U2' R2'",
          "R2 U2' R2' U' R2 U R2' U2 R2 U2' R2' U2 R2 U2' R2'",
          "R2 U2' R2' U' R2 U' R2' U2 R' U2' R2' U' R2 U2' R",
          "R2 U2' R2' U' R' U R2' U2 R' U2' R2' U' R2 U2' R'",
          "R2 U2' R2' U' R' U2' R2' U2 R2 U2' R2' U2 R2 U2' R",
          "R2 U' R2' U2 R' U2' R2' U' R2 U2' R U R2 U2' R2'",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          2,
          2,
          3,
          1,
          3,
          4,
          4,
          1,
          2,
          3,
          4,
          5,
          5,
          5,
        ],
      },
      {
        name: 'F1-',
        scr: [
          "R' U' R2 U R2' U2 R2 U2' R' U R U2' R2' U2' R",
          "R U2 R2 U2' R2' U2 R2 U2' R2' U2 R' U R2' U2 R2",
          "R U2 R2' U R2 U2 R U2' R2 U' R U R2 U2 R2'",
          "R U' R2 U2' R U2 R2 U R2' U2 R U R2' U2 R2",
          "R2 U R2' U R2 U R2' U' R2 U' R2' U R2 U2' R2'",
          "R2 U R2' U2' R' U2 R2' U R2 U2 R U' R2 U2 R2'",
          "R2 U2 R U2' R' U2 R2' U R2 U2 R U2' R' U2 R2'",
          "R2 U2 R2' U R U2 R2' U R2 U2 R U2' R2 U' R",
          "R2 U2 R2' U R2 U R2' U2' R' U2 R2' U R2 U2 R",
          "R2 U2 R2' U R2 U' R U2' R2 U' R2' U2' R' U2 R2'",
          "R2 U2 R2' U R2 U' R2' U2' R2 U2 R2' U2' R2 U2 R2'",
          "R2 U2 R2' U R' U2 R2' U2' R2 U2 R2' U2' R2 U2 R",
          "R2 U2 R2' U R' U' R2' U2' R' U2 R2' U R2 U2 R'",
          "R2 U2 R2' U2 R2 U2 R U2' R2 U' R2' U2' R' U' R2'",
          "R2 U2 R2' U2' R' U2' R2' U' R2 U2' R U2 R2 U2' R2'",
          "R2 U2 R2' U' R2 U2 R2' U2' R2 U2 R2' U2' R2 U' R2'",
          "R2 U2 R2' U' R' U2 R2' U R2 U2 R U2' R2 U R2'",
          "R2 U2' R2' U R2 U' R2' U' R2 U R2' U R2 U R2'",
          "R2 U2' R2' U2 R' U2' R2' U' R2 U2' R U2' R2 U2 R2'",
          "R2 U' R U2' R2 U' R2' U2' R' U2 R2' U2 R2 U2 R2'",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          2,
          3,
          4,
          1,
          1,
          2,
          4,
          2,
          3,
          3,
          4,
          5,
          5,
          5,
        ],
      },
      {
        name: 'F2+',
        scr: [
          "R U' R' U2' R U' R U R2' U2 R U2' R U' R' U' R'",
          "R2 U' R' U2' R U' R U R2' U2 R U2' R U' R' U' R2'",
          "R2' U' R' U2' R U' R U R2' U2 R U2' R U' R' U' R2",
          "R' U' R' U2' R U' R U R2' U2 R U2' R U' R' U' R",
          "R2' U2 R2' U2 R2' U2' R' U' R U2' R2 U2 R' U2 R2' U2 R2",
          "R2 U2 R2' U2 R2' U2 R2' U2' R' U' R U2' R2 U2 R' U2 R2'",
          "R2' U' R2' U R2' U R2' U R2 U' R2 U' R' U R2' U2' R'",
          "R U R' U' R2 U R2 U2 R2' U2 R2 U R U2 R U2' R'",
          "R U2 R U2' R U2 R2' U R2 U2 R2' U R U2 R' U2' R'",
          "R U2 R U2' R2 U2 R2 U R2' U2 R2 U R U2 R' U2' R'",
          "R2 U R U' R' U R2' U2 R2 U2 R2' U2 R2' U R' U' R2'",
          "R U2 R' U2' R' U2 R2 U2 R2' U R2 U2 R' U2 R U2' R'",
          "R U2 R' U2' R' U2 R2' U2 R2 U R2' U2 R2' U2 R U2' R'",
          "R2' U' R U' R U' R U R2' U R' U R2 U2' R U' R'",
          "R' U2' R U' R U R U' R2 U2' R U2 R2 U R' U' R'",
          "R' U2' R U' R' U2' R' U2 R2' U R2 U2 R2 U2' R U' R'",
          "R U2 R2' U2 R2' U2 R2' U2' R' U' R U2' R2 U2 R' U2 R2' U2 R",
          "R2' U2 R2' U2 R2' U2 R2' U2' R' U' R U2' R2 U2 R' U2 R2' U2 R'",
          "R' U2 R2' U2 R2' U2 R2' U2' R' U' R U2' R2 U2 R' U2 R2' U2 R2'",
          "R2 U R2' U2 R2 U2' R2' U' R2 U R2' U2 R2 U' R2' U2 R2 U2 R2'",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          2,
          2,
          3,
          4,
          3,
          4,
          3,
          1,
          2,
          1,
          4,
          5,
          5,
          5,
        ],
      },
      {
        name: 'F2-',
        scr: [
          "R U R U2 R' U R' U' R2 U2' R' U2 R' U R U R'",
          "R2 U R U2 R' U R' U' R2 U2' R' U2 R' U R U R2'",
          "R2' U R U2 R' U R' U' R2 U2' R' U2 R' U R U R2",
          "R' U R U2 R' U R' U' R2 U2' R' U2 R' U R",
          "R2 U2' R2 U2' R2 U2 R U R' U2 R2' U2' R U2' R2 U2' R2'",
          "R2' U2' R2 U2' R2 U2' R2 U2 R U R' U2 R2' U2' R U2' R2",
          "R U2 R' U R U2 R U2' R2 U' R2' U2' R2' U2 R'",
          "R U2 R' U R' U' R' U R2' U2 R' U2' R2' U' R",
          "R2 U R' U R' U R' U' R2 U' R U' R2' U2 R'",
          "R' U2' R U2 R U2' R2 U2' R2' U' R2 U2' R2 U2' R' U2 R",
          "R' U2' R U2 R U2' R2' U2' R2 U' R2' U2' R U2' R' U2 R",
          "R2' U' R' U R U' R2 U2' R2' U2' R2 U2' R2 U' R U R2",
          "R' U2' R' U2 R2' U2' R2' U' R2 U2' R2' U' R' U2' R U2 R",
          "R' U2' R' U2 R' U2' R2 U' R2' U2' R2 U' R' U2' R U2 R",
          "R' U' R U R2' U' R2' U2' R2 U2' R2' U' R' U2' R' U2 R",
          "R2 U R2 U' R2 U' R2 U' R2' U R2' U R U' R2 U2 R",
          "R U2' R2 U2' R2 U2' R2 U2 R U R' U2 R2' U2' R U2' R2 U2' R2",
          "R2 U2' R2 U2' R2 U2' R2 U2 R U R' U2 R2' U2' R U2' R2 U2' R",
          "R' U2' R2 U2' R2 U2' R2 U2 R U R' U2 R2' U2' R U2' R2 U2' R'",
          "R2 U2' R U' R2 U R2 U' R2' U2' R2 U R U R2 U2 R2 U2' R2'",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          4,
          3,
          4,
          2,
          1,
          2,
          1,
          2,
          3,
          3,
          4,
          5,
          5,
          5,
        ],
      },
      {
        name: 'F3+',
        scr: [
          "R U R U R' U2 R' U2' R2 U' R' U R' U2 R U R'",
          "R2 U R U R' U2 R' U2' R2 U' R' U R' U2 R U R2'",
          "R2' U R U R' U2 R' U2' R2 U' R' U R' U2 R U R2",
          "R' U R U R' U2 R' U2' R2 U' R' U R' U2 R",
          "R2 U2' R U2' R2' U2 R' U R U2 R2 U2' R2 U2' R2 U2' R2'",
          "R2' U2' R2 U2' R U2' R2' U2 R' U R U2 R2 U2' R2 U2' R2",
          "R U R U' R2' U2' R' U2 R2' U R' U' R' U R' U2 R",
          "R U R' U2 R2' U2' R2' U' R2 U2' R U2 R U R' U2 R",
          "R U R' U2 R2' U' R U' R2 U' R' U R' U R' U R2",
          "R U2 R U2' R' U' R2 U2' R2' U' R2 U2' R' U2 R' U2' R'",
          "R U2 R U2' R' U' R2' U2' R2 U' R2' U2' R2' U2 R' U2' R'",
          "R U2 R' U2' R' U' R2' U2' R2 U2' R2' U' R2' U R U' R'",
          "R2 U R U' R2 U2' R2 U2' R2' U2' R2 U' R U R' U' R2'",
          "R U2 R2 U' R U R2' U R2' U' R2 U' R2 U' R2 U R2",
          "R U2 R' U2' R U2' R2' U' R2 U2' R2' U2' R U2 R U2' R'",
          "R U2 R' U2' R2 U2' R2 U' R2' U2' R2 U2' R U2 R U2' R'",
          "R U2' R2 U2' R U2' R2' U2 R' U R U2 R2 U2' R2 U2' R2 U2' R2",
          "R2 U2' R2 U2' R U2' R2' U2 R' U R U2 R2 U2' R2 U2' R2 U2' R",
          "R' U2' R2 U2' R U2' R2' U2 R' U R U2 R2 U2' R2 U2' R2 U2' R'",
          "R U R' U2 R2' U2' R2' U' R2 U2' R2 U' R' U2' R U' R' U2' R",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          4,
          3,
          4,
          1,
          1,
          2,
          3,
          2,
          3,
          2,
          4,
          5,
          5,
          5,
        ],
      },
      {
        name: 'F3-',
        scr: [
          "R U' R' U' R U2' R U2 R2' U R U' R U2' R' U' R'",
          "R2 U' R' U' R U2' R U2 R2' U R U' R U2' R' U' R2'",
          "R2' U' R' U' R U2' R U2 R2' U R U' R U2' R' U' R2",
          "R' U' R' U' R U2' R U2 R2' U R U' R U2' R' U' R",
          "R2' U2 R' U2 R2 U2' R U' R' U2' R2' U2 R2' U2 R2' U2 R2",
          "R2 U2 R2' U2 R' U2 R2 U2' R U' R' U2' R2' U2 R2' U2 R2'",
          "R' U2' R U2 R2' U2 R2' U R2 U2 R2' U2 R' U2' R' U2 R",
          "R' U2' R U2 R' U2 R2 U R2' U2 R2 U2 R' U2' R' U2 R",
          "R' U2' R2' U R' U' R2 U' R2 U R2' U R2' U R2' U' R2'",
          "R2' U' R' U R2' U2 R2' U2 R2 U2 R2' U R' U' R U R2",
          "R' U2' R U2 R U R2 U2 R2' U2 R2 U R2 U' R'",
          "R' U2' R' U2 R U R2 U2 R2' U R2 U2 R2 U2' R U2 R",
          "R' U2' R' U2 R U R2' U2 R2 U R2' U2 R U2' R U2 R",
          "R' U' R U2' R2 U R' U R2' U R U' R U' R U' R2'",
          "R' U' R U2' R2 U2 R2 U R2' U2 R' U2' R' U' R U2' R'",
          "R' U' R' U R2 U2 R U2' R2 U' R U R U' R U2' R'",
          "R U2 R2' U2 R' U2 R2 U2' R U' R' U2' R2' U2 R2' U2 R2' U2 R",
          "R2' U2 R2' U2 R' U2 R2 U2' R U' R' U2' R2' U2 R2' U2 R2' U2 R'",
          "R' U2 R2' U2 R' U2 R2 U2' R U' R' U2' R2' U2 R2' U2 R2' U2 R2'",
          "R U R2 U R' U' R' U R' U R U' R U R U' R2' U2' R'",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          3,
          2,
          3,
          2,
          3,
          4,
          4,
          1,
          2,
          1,
          4,
          5,
          5,
          5,
        ],
      },
      {
        name: 'F4+',
        scr: [
          "R U2' R2 U2' R2' U' R2 U2' R2 U2' R U2' R' U' R U2' R'",
          "R U2' R2 U2' R2' U' R2 U2' R2 U' R U2 R' U R U2 R'",
          "R U2' R2' U2' R2 U' R2' U2' R U2' R U2' R' U' R U2' R'",
          "R U2' R2' U2' R2 U' R2' U2' R U' R U2 R' U R U2 R'",
          "R U R U2' R U2 R' U2' R' U R U2 R U2' R2 U' R2 U2' R2'",
          "R U R U2' R U2 R' U2' R' U R' U' R2 U2' R U2 R' U2' R2'",
          "R U2 R U2' R U R2' U2 R' U2' R2' U' R' U2 R2' U' R U' R'",
          "R U2 R U2' R' U2' R' U' R2 U2' R2' U2 R2 U2' R2' U R U' R'",
          "R U2 R' U2 R U2 R U2' R2' U2' R2 U' R' U2 R' U2' R U' R'",
          "R U2 R' U2 R U2 R U2' R' U2 R' U R U2' R' U' R2 U2' R2'",
          "R U2 R' U' R U2' R U2 R' U2' R' U2' R U2' R' U' R2 U2' R2'",
          "R U2' R' U' R' U' R U2 R2' U' R' U' R' U R U R2' U2 R'",
          "R U' R U2 R U2' R' U2 R' U' R U2 R U2' R2 U' R2 U2' R2'",
          "R U' R U2 R U2' R' U2 R' U' R' U' R2 U2' R U2 R' U2' R2'",
          "R2 U R U2' R U2 R' U2' R' U R U2 R U2' R U' R2' U2' R2",
          "R2 U2 R' U2 R U2 R U2' R' U2 R' U R U2' R2' U' R2' U2' R2",
          "R2 U2 R' U2' R U2 R' U2' R' U R U2' R U2 R' U2' R U2' R2'",
          "R2 U2 R' U' R U2' R U2 R' U2' R' U2' R U2' R2' U' R2' U2' R2",
          "R2 U' R U2 R U2' R' U2 R' U' R U2 R U2' R U' R2' U2' R2",
          "R2' U2 R2' U2' R U2 R' U2' R' U R U2' R U2 R' U2' R2 U2' R2",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          3,
          3,
          4,
          2,
          1,
          2,
          4,
          2,
          3,
          1,
          4,
          5,
          5,
          5,
        ],
      },
      {
        name: 'F4-',
        scr: [
          "R' U2 R2 U2 R2' U R2 U2 R' U R' U2' R U' R' U2' R",
          "R' U2 R2 U2 R2' U R2 U2 R' U2 R' U2 R U R' U2 R",
          "R' U2 R2' U2 R2 U R2' U2 R2' U R' U2' R U' R' U2' R",
          "R' U2 R2' U2 R2 U R2' U2 R2' U2 R' U2 R U R' U2 R",
          "R U R2' U2 R' U2' R2' U' R2' U2 R U2' R2' U2' R2 U R' U R",
          "R U2' R U2 R U R' U2' R' U2 R U2' R U R2 U R2 U2 R2'",
          "R U2' R U2 R U' R' U2 R' U2' R U2 R U' R2 U R2 U2 R2'",
          "R2 U R2' U R U' R' U R U R U2 R' U2 R' U2 R U2' R'",
          "R2 U2' R U2 R U R' U2' R' U2 R U2' R U R U R2' U2 R2",
          "R2 U2' R U2 R U' R' U2 R' U2' R U2 R U' R U R2' U2 R2",
          "R2 U2' R2 U2 R' U2' R U2 R U' R' U2 R' U2' R U2 R2' U2 R2'",
          "R2' U R' U2' R' U2 R U2' R U R' U2' R' U2 R' U R2 U2 R2'",
          "R2' U2' R U R' U2 R' U2' R U2 R U2 R' U2 R2 U R2 U2 R2'",
          "R2' U2' R U2 R' U2' R U2 R U' R' U2 R' U2' R U2 R' U2 R2",
          "R2' U2' R U2' R' U2' R' U2 R U2' R U' R' U2 R2 U R2 U2 R2'",
          "R2' U' R' U2 R' U2' R U2 R U' R' U2' R' U2 R' U R2 U2 R2'",
          "R' U R' U2' R' U2 R U2' R U R U R2' U2 R' U2' R U2 R2",
          "R' U R' U2' R' U2 R U2' R U R' U2' R' U2 R2' U R2' U2 R2",
          "R' U2 R U R U R' U2' R2 U R U R U' R' U' R2 U2' R",
          "R' U2' R U R' U2 R' U2' R U2 R U2 R' U2 R U R2' U2 R2",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          4,
          2,
          3,
          1,
          3,
          4,
          3,
          1,
          2,
          2,
          4,
          5,
          5,
          5,
        ],
      },
      {
        name: 'F5+',
        scr: [
          "R U2' R' U' R U2' R' U R2' U2 R2' U R2 U2 R2' U2 R'",
          "R U2' R' U' R U2' R' U R' U2 R2 U R2' U2 R2 U2 R'",
          "R U2 R' U R U2 R' U2 R2' U2 R2' U R2 U2 R2' U2 R'",
          "R U2 R' U R U2 R' U2 R' U2 R2 U R2' U2 R2 U2 R'",
          "R U R' U R2 U2' R U R2 U2 R U2' R2 U' R' U2 R' U2' R'",
          "R U R' U R2 U2' R2' U2' R U2 R2' U' R2' U2' R' U2 R2'",
          "R U R' U2 R U2' R U R2' U2 R2 U2 R' U2' R' U2' R U2' R'",
          "R U R' U' R2 U2 R2' U2' R2 U2 R2' U R U2 R U2 R' U2' R'",
          "R U2' R2 U' R' U' R U R U R2 U2' R' U R U R U2 R'",
          "R2 U2 R U2' R' U2 R2' U R U R U2' R U2 R' U2' R' U R'",
          "R2 U2 R U2' R' U2 R2' U R U' R U2 R U2' R' U2 R' U' R'",
          "R2 U2 R2' U R U R U2' R U2 R' U2' R' U R U2 R U2' R2",
          "R2 U2 R2' U R U2 R' U2 R U2 R U2' R' U2 R' U R U2' R'",
          "R2 U2 R2' U R U2 R' U' R U2' R U2 R' U2' R' U2' R U2' R'",
          "R2 U2 R2' U R U' R U2 R U2' R' U2 R' U' R U2 R U2' R2",
          "R2 U2 R2' U R2' U2 R' U2' R' U R U2' R U2 R' U2' R' U R'",
          "R2 U2 R2' U R2' U2 R' U2' R' U' R U2 R U2' R' U2 R' U' R'",
          "R2 U2 R' U2 R U2' R' U2 R' U' R U2 R U2' R' U2 R U2' R2'",
          "R2' U2 R2 U R2 U R U2' R U2 R' U2' R' U R U2 R U2' R",
          "R2' U2 R2 U R2 U2 R' U2 R U2 R U2' R' U2 R' U R U2' R2'",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          4,
          2,
          3,
          2,
          3,
          4,
          1,
          1,
          2,
          3,
          4,
          5,
          5,
          5,
        ],
      },
      {
        name: 'F5-',
        scr: [
          "R' U2' R U' R' U2' R U2' R U2' R2' U' R2 U2' R2' U2' R",
          "R' U2' R U' R' U2' R U2' R2 U2' R2 U' R2' U2' R2 U2' R",
          "R' U2 R U R' U2 R U' R U2' R2' U' R2 U2' R2' U2' R",
          "R' U2 R U R' U2 R U' R2 U2' R2 U' R2' U2' R2 U2' R",
          "R U2 R' U2' R U2' R U2' R' U' R' U' R U R' U' R2 U' R2'",
          "R2 U2' R2 U2' R' U2 R U2' R U R' U2' R' U2 R U2' R2' U2 R2'",
          "R2 U2' R2' U' R U2' R U2 R U R' U2' R' U2 R U2' R U R2",
          "R2 U2' R2' U' R U2' R U2 R U' R' U2 R' U2' R U2 R U' R2",
          "R2 U2' R2' U' R2' U R' U2' R' U2 R U2' R U R' U2' R' U2 R'",
          "R2 U2' R2' U' R2' U2' R U R' U2 R' U2' R U2 R U2 R' U2 R2",
          "R2 U2' R2' U' R2' U2' R U2' R' U2' R' U2 R U2' R U' R' U2 R2",
          "R2 U2' R2' U' R2' U' R' U2 R' U2' R U2 R U' R' U2' R' U2 R'",
          "R2' U2' R U2' R' U2 R U2' R U R' U2' R' U2 R U2' R' U2 R2",
          "R2' U2' R2 U' R2 U2' R U2 R U R' U2' R' U2 R U2' R U R",
          "R2' U2' R2 U' R2 U2' R U2 R U' R' U2 R' U2' R U2 R U' R",
          "R2' U2' R2 U' R' U R' U2' R' U2 R U2' R U R' U2' R' U2 R2'",
          "R2' U2' R2 U' R' U2' R U R' U2 R' U2' R U2 R U2 R' U2 R",
          "R2' U2' R2 U' R' U2' R U2' R' U2' R' U2 R U2' R U' R' U2 R",
          "R2' U2' R2 U' R' U' R' U2 R' U2' R U2 R U' R' U2' R' U2 R2'",
          "R2' U2' R' U2 R U2' R2 U' R' U R' U2' R' U2 R U2' R U R",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          2,
          3,
          4,
          4,
          1,
          2,
          3,
          2,
          3,
          1,
          4,
          5,
          5,
          5,
        ],
      },
    ],
  },
  {
    cat: 'G',
    cases: [
      {
        name: 'G1+',
        scr: [
          "R2' U2 R2' U2' R2 U' R U2' R' U' R U2' R2 U2 R2 U2' R2",
          "R2' U2 R2' U2' R2' U2 R' U R U2 R' U R2' U2 R2 U2' R2",
          "R' U2 R2 U2' R2' U' R U2' R' U' R U2' R U2 R2' U2' R",
          "R' U2 R2 U2' R' U2 R' U R U2 R' U R2 U2 R2' U2' R",
          "R U R U2' R2' U2' R2' U R U R2' U' R' U' R' U' R' U' R'",
          "R U R2 U R2' U R' U' R2' U' R U' R2 U2' R2' U2' R2 U2 R'",
          "R U R' U2' R' U2' R' U2 R U2 R2 U' R2 U2 R2 U2 R' U R",
          "R U2 R2 U2' R2' U2 R2 U2 R U2' R' U' R U2' R2 U2 R2 U2' R2",
          "R U2 R2' U2' R2 U2 R2' U2 R U2' R' U' R U2' R U2 R2' U2' R",
          "R U' R2' U2 R' U R2 U' R2' U R2' U2 R2 U R' U R2 U' R2'",
          "R2' U2 R2' U2' R2' U2 R' U R U2 R' U2' R2' U2' R2 U2 R2' U2' R'",
          "R2' U2 R' U R2' U' R U2' R2 U R U2 R2' U R2 U2' R2' U' R",
          "R2' U2 R' U' R' U' R2 U R2 U2' R U2 R2 U2' R2' U2 R U R2'",
          "R2' U2 R' U' R' U' R2 U R2 U2' R2' U2 R2' U2' R2 U2 R' U R2'",
          "R2' U2 R' U' R' U' R2 U2 R2 U2 R U2' R2 U2 R2' U2 R U R2'",
          "R2' U2' R' U' R2' U' R U R U' R U' R' U R' U' R U2' R2'",
          "R' U2 R2 U2' R' U2 R' U R U2 R' U2' R2 U2' R2' U2 R2 U2' R'",
          "R' U2' R2' U2 R2 U R2' U2' R2 U R U' R2 U' R2' U2 R' U R",
          "R' U' R U2' R2 U R2' U R' U R U2' R2 U2 R2' U' R2 U2' R2'",
          "R' U' R U2' R2 U R2' U R' U' R2' U2 R2 U' R2' U2' R2 U2 R",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          4,
          1,
          1,
          2,
          3,
          4,
          5,
          2,
          5,
          1,
          5,
          2,
          3,
          4,
          3,
        ],
      },
      {
        name: 'G1-',
        scr: [
          "R U2' R2' U2 R U2' R U' R' U2' R U' R2' U2' R2 U2 R'",
          "R U2' R2' U2 R2 U R' U2 R U R' U2 R' U2' R2 U2 R'",
          "R2 U2' R2 U2 R2 U2' R U' R' U2' R U' R2 U2' R2' U2 R2'",
          "R2 U2' R2 U2 R2' U R' U2 R U R' U2 R2' U2' R2' U2 R2'",
          "R' U' R' U2 R2 U2 R2 U' R' U' R2 U R U R U R",
          "R U R' U2 R2' U' R2 U' R U R2 U2' R2' U R2 U2 R2' U2' R'",
          "R U R' U2 R2' U' R2 U' R U' R' U2 R2' U2' R2 U R2' U2 R2",
          "R U2 R2 U2' R2' U' R2 U2 R2' U' R' U R2' U R2 U2' R U' R'",
          "R U2' R2' U2 R U2' R U' R' U2' R U2 R2' U2 R2 U2' R2' U2 R",
          "R2 U2 R U R2 U R' U' R' U R' U R U' R U R' U2 R2",
          "R2 U2' R U R U R2' U2' R2' U2' R' U2 R2' U2' R2 U2' R' U' R2",
          "R2 U2' R U R U R2' U' R2' U2 R2 U2' R2 U2 R2' U2' R U' R2",
          "R2 U2' R U R U R2' U' R2' U2 R' U2' R2' U2 R2 U2' R' U' R2",
          "R2 U2' R U' R2 U R' U2 R2' U' R' U2' R2 U' R2' U2 R2 U R'",
          "R2 U2' R2 U2 R2 U2' R U' R' U2' R U2 R2 U2 R2' U2' R2 U2 R",
          "R' U R2 U2' R U' R2' U R2 U' R2 U2' R2' U' R U' R2' U R2",
          "R' U2' R2 U2 R2' U2' R2 U2' R' U2 R U R' U2 R' U2' R2 U2 R'",
          "R' U2' R2' U2 R2 U2' R2' U2' R' U2 R U R' U2 R2' U2' R2' U2 R2'",
          "R' U' R U2 R U2 R U2' R' U2' R2' U R2' U2' R2' U2' R U' R'",
          "R' U' R2' U' R2 U' R U R2 U R' U R2' U2 R2 U2 R2' U2' R",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          3,
          4,
          3,
          4,
          5,
          2,
          1,
          2,
          5,
          2,
          3,
          4,
          5,
        ],
      },
      {
        name: 'G2+',
        scr: [
          "R U2' R' U2' R2' U R' U' R2' U R' U2' R2 U R U R' U' R2",
          "R U2' R' U' R U' R2 U R U' R2 U' R2 U R U R' U' R2",
          "R U2 R U R2 U' R' U2' R U2' R U' R' U2' R2' U R'",
          "R2 U R' U R' U R' U' R' U' R2' U' R' U2 R U R2' U' R2'",
          "R2 U2 R2' U R2 U2 R2' U R2 U2' R2' U2 R2 U R2' U2' R2 U2 R2'",
          "R2 U2 R2' U R2 U2 R2' U R2 U2' R2' U2 R2 U' R2' U2 R2 U2' R2'",
          "R2 U2 R2' U R2 U2 R2' U R2' U2' R2 U2 R2' U R2 U2' R2' U2 R2",
          "R2 U2 R2' U R2 U2 R2' U R2' U2' R2 U2 R2' U' R2 U2 R2' U2' R2",
          "R2 U2 R2' U R2 U2 R2' U' R2 U2 R2' U2' R2 U R2' U2 R2 U2' R2'",
          "R2 U2 R2' U R2 U2 R2' U' R2 U2 R2' U2' R2 U2' R2' U2' R2 U2 R2'",
          "R2 U2 R2' U R2 U2 R2' U' R2' U2 R2 U2' R2' U R2 U2 R2' U2' R2",
          "R2 U2 R2' U R2 U2 R2' U' R2' U2 R2 U2' R2' U2' R2 U2' R2' U2 R2",
          "R2 U2' R2' U2 R2 U2 R2' U2 R2 U2' R2' U R2 U2' R2' U' R2 U2' R2'",
          "R2 U2' R2' U2 R2 U2 R2' U2 R2 U2' R2' U R2' U2' R2 U' R2' U2' R2",
          "R2 U2' R2' U2 R2 U' R2' U2' R2 U2 R2' U' R2 U2' R2' U' R2 U2' R2'",
          "R2 U2' R2' U2 R2 U' R2' U2' R2 U2 R2' U' R2' U2' R2 U' R2' U2' R2",
          "R2' U2 R2 U R2' U2 R2 U R2 U2' R2' U2 R2 U R2' U2' R2 U2 R2'",
          "R2' U2 R2 U R2' U2 R2 U R2 U2' R2' U2 R2 U' R2' U2 R2 U2' R2'",
          "R2' U2 R2 U R2' U2 R2 U R2' U2' R2 U2 R2' U R2 U2' R2' U2 R2",
          "R2' U2 R2 U R2' U2 R2 U R2' U2' R2 U2 R2' U' R2 U2 R2' U2' R2",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          4,
          1,
          1,
          2,
          5,
          4,
          5,
          4,
          5,
          1,
          3,
          2,
          3,
          2,
          3,
        ],
      },
      {
        name: 'G2-',
        scr: [
          "R' U2 R U R' U R2' U' R' U R2' U R2' U' R' U' R U R2'",
          "R' U2 R U2 R2 U' R U R2 U' R U2 R2' U' R' U' R U R2'",
          "R2' U' R U' R U' R U R U R2 U R U2' R' U' R2 U R2",
          "R' U2' R' U' R2' U R U2 R' U2 R' U R U2 R2 U' R U' R'",
          "R2 U R2 U2 R' U' R2' U' R' U' R' U R' U R2 U R' U' R2'",
          "R2 U2' R2' U2 R2 U R2' U2' R2 U2 R2' U' R2 U2 R2' U R2 U2 R2'",
          "R2 U2' R2' U2 R2 U R2' U2' R2 U2 R2' U' R2' U2 R2 U R2' U2 R2",
          "R2 U2' R2' U2 R2 U' R2' U2 R2 U2' R2' U R2 U2 R2' U R2 U2 R2'",
          "R2 U2' R2' U2 R2 U' R2' U2 R2 U2' R2' U R2' U2 R2 U R2' U2 R2",
          "R2' U2' R2 U2 R2' U R2 U2' R2' U2 R2 U' R2 U2 R2' U R2 U2 R2'",
          "R2' U2' R2 U2 R2' U R2 U2' R2' U2 R2 U' R2' U2 R2 U R2' U2 R2",
          "R2' U2' R2 U2 R2' U' R2 U2 R2' U2' R2 U R2 U2 R2' U R2 U2 R2'",
          "R2' U2' R2 U2 R2' U' R2 U2 R2' U2' R2 U R2' U2 R2 U R2' U2 R2",
          "R U R' U R2' U2' R' U' R U2' R U2' R' U' R2 U R U2 R",
          "R2 U' R' U R U R2 U2' R' U R2' U' R' U R2' U2' R' U2' R",
          "R2 U' R' U R U R2 U' R2 U' R U R2 U' R U' R' U2' R",
          "R2' U' R2' U R U2 R' U' R2' U' R' U' R' U R' U R' U R2",
          "R2 U R U' R2' U' R U' R U R U R2 U R U2' R2' U' R2'",
          "R2 U2 R2' U2' R2 U R2' U2 R2 U2' R2' U R2 U2 R2' U R2 U2 R2'",
          "R2 U2 R2' U2' R2 U R2' U2 R2 U2' R2' U R2' U2 R2 U R2' U2 R2",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          3,
          4,
          5,
          4,
          5,
          4,
          1,
          2,
          3,
          2,
          3,
          2,
          5,
        ],
      },
    ],
  },
  {
    cat: 'H',
    cases: [
      {
        name: 'H1+',
        scr: [
          "R U2 R2 U2 R U' R U R U' R U R2 U2' R2' U2' R' U' R2 U' R2'",
          "R2' U' R2 U' R' U2' R2' U2' R2 U R U' R U R U' R U2 R2 U2 R",
          "R U R2' U2 R2 U2 R2' U R U R U2' R' U' R U R' U2' R U' R'",
          "R U2' R U2' R2' U2 R2 U2 R2' U2 R2 U2' R2' U' R U R' U2' R U' R'",
          "R U2' R U2' R2' U2 R2 U' R2' U2' R2 U2 R2' U2 R U R' U2' R U' R'",
          "R U2' R2 U2' R2 U2 R2' U2 R2 U2 R2' U2' R2 U' R U R' U2' R U' R'",
          "R U2' R2 U2' R2 U2 R2' U' R2 U2' R2' U2 R2 U2 R U R' U2' R U' R'",
          "R' U' R U2' R' U R U2 R2 U2 R2' U2' R2 U' R2' U2 R2 U2' R2 U2' R",
          "R' U' R U2' R' U R U2 R2' U2 R2 U2' R2' U' R2 U2 R2' U2' R U2' R",
          "R' U' R U2' R' U R U' R2 U2' R2' U2 R2 U2 R2' U2 R2 U2' R2 U2' R",
          "R' U' R U2' R' U R U' R2' U2' R2 U2 R2' U2 R2 U2 R2' U2' R U2' R",
          "R' U' R U2' R' U R U' R' U2' R U R U R2' U2 R2 U2 R2'",
          "R U2' R2' U2' R U R2 U R U2' R' U2 R U2' R U2 R2 U' R' U2' R'",
          "R U2' R2' U2' R U R2 U R2 U2' R' U2 R' U2' R U2 R2' U' R' U2' R'",
          "R U' R2' U' R2 U2' R2' U2' R2' U2 R' U' R' U2 R2 U' R2' U' R2 U' R2'",
          "R2 U2 R2 U R' U2' R2' U R U' R U2 R' U' R' U R2' U' R2' U2' R2'",
          "R2 U2 R2 U2 R2 U2' R U' R2' U2' R' U' R U2' R U2 R2' U2' R2' U' R2'",
          "R2 U2 R' U R' U' R' U2 R2' U2 R2 U R U2' R U2 R' U R2 U' R2'",
          "R2 U2' R2' U2' R2' U2 R' U R U2 R U2 R U R2 U' R2 U2' R2' U' R2'",
          "R2 U2' R' U2 R' U' R U R U' R' U2' R' U2' R U R' U2' R U' R'",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          2,
          1,
          2,
          3,
          2,
          3,
          4,
          3,
          4,
          5,
          4,
          5,
          1,
          5,
          1,
        ],
      },
      {
        name: 'H1-',
        scr: [
          "R2 U R2' U R U2 R2 U2 R2' U' R' U R' U' R' U R' U2' R2' U2' R'",
          "R' U2' R2' U2' R' U R' U' R' U R' U' R2' U2 R2 U2 R U R2' U R2",
          "R U R2' U2 R U' R' U R' U2 R' U2 R U2' R U2' R2' U' R2' U' R",
          "R U2 R' U2 R U' R' U' R U2 R2 U R2 U R U' R2 U' R2' U R'",
          "R U' R2' U' R2' U2' R U2' R U2 R' U2 R' U R' U' R U2 R2'",
          "R U' R' U' R U2 R2' U2 R U R' U2 R U2 R U2 R' U2 R U R'",
          "R2' U R' U' R' U2 R U2 R2 U R2' U' R' U R' U' R U2' R' U' R2'",
          "R2' U R' U' R' U' R2' U R2 U2 R U2 R' U R' U' R U2' R' U' R2'",
          "R2' U2' R2 U2 R' U2 R U2' R' U2 R2' U2 R' U2' R U2 R' U2 R2 U2' R2'",
          "R2' U2' R2' U' R U' R2 U R2 U' R U' R2' U2' R2 U2' R2' U2 R2' U2' R'",
          "R2' U' R' U2' R U' R' U R' U2 R U2 R2 U R2' U' R' U' R' U R2'",
          "R2' U' R' U2' R U' R' U R' U' R2' U R2 U2 R U2 R' U' R' U R2'",
          "R' U R U2 R' U2 R U2 R U2 R' U R U2 R2' U2 R U' R' U' R",
          "R' U R2' U' R2 U' R U R2 U R2 U2 R U' R' U' R U2 R' U2 R",
          "R' U2' R2' U2 R2' U2' R2 U2' R2' U' R U' R2 U R2 U' R U' R2' U2' R2'",
          "R U R2' U R2 U2' R' U' R' U2 R' U2' R2 U' R2' U R2 U R2' U R2",
          "R U R2' U R2 U2' R' U' R' U2 R' U' R2 U' R2' U' R2 U R2' U2 R2",
          "R U R' U2 R U' R' U2 R U2 R U R' U' R' U R U2' R U2 R2'",
          "R U2 R U R2 U2' R' U2 R U2' R U2 R2' U' R2' U' R' U2 R2 U2 R'",
          "R U2 R U R2' U2' R' U2 R' U2' R U2 R' U' R2' U' R' U2 R2 U2 R'",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          5,
          1,
          5,
          1,
          2,
          1,
          2,
          3,
          2,
          3,
          4,
          3,
          4,
          5,
          4,
        ],
      },
      {
        name: 'H2+',
        scr: [
          "R2 U2 R U2' R2' U2 R2' U2' R U2' R' U' R2 U R2 U' R' U R2'",
          "R2' U R' U' R2 U R2 U' R' U2' R U2' R2' U2 R2' U2' R U2 R2",
          "R2' U R' U2 R2' U2 R2' U' R2 U2 R2 U' R2' U2 R2' U2 R' U R2'",
          "R U' R U R U2' R2' U' R' U R2' U2 R' U' R2' U2' R U2' R'",
          "R' U2' R U2' R2' U' R' U2 R2' U R' U' R2' U2' R U R U' R",
          "R U' R U R U2' R2' U' R' U R2' U2 R' U' R2' U2' R U2' R'",
          "R2' U R' U2 R2' U2 R2' U' R2 U2 R2 U' R2' U2 R2' U2 R' U R2'",
          "R' U2' R U2' R2' U' R' U2 R2' U R' U' R2' U2' R U R U' R",
          "R U' R U R U2' R2' U' R' U R2' U2 R' U' R2' U2' R U2' R'",
          "R2 U2 R U2' R2' U2 R2' U2' R U2' R' U' R2 U R2 U' R' U R2'",
          "R2' U R' U' R2 U R2 U' R' U2' R U2' R2' U2 R2' U2' R U2 R2",
          "R' U2' R U2' R2' U' R' U2 R2' U R' U' R2' U2' R U R U' R",
          "R U' R U R U2' R2' U' R' U R2' U2 R' U' R2' U2' R U2' R'",
          "R2 U2 R U2' R2' U2 R2' U2' R U2' R' U' R2 U R2 U' R' U R2'",
          "R2' U R' U2 R2' U2 R2' U' R2 U2 R2 U' R2' U2 R2' U2 R' U R2'",
          "R2' U R' U' R2 U R2 U' R' U2' R U2' R2' U2 R2' U2' R U2 R2",
          "R' U2' R U2' R2' U' R' U2 R2' U R' U' R2' U2' R U R U' R",
          "R2 U2 R U2' R2' U2 R2' U2' R U2' R' U' R2 U R2 U' R' U R2'",
          "R2' U R' U2 R2' U2 R2' U' R2 U2 R2 U' R2' U2 R2' U2 R' U R2'",
          "R2' U R' U' R2 U R2 U' R' U2' R U2' R2' U2 R2' U2' R U2 R2",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          3,
          1,
          3,
          4,
          2,
          4,
          5,
          3,
          5,
          1,
          4,
          1,
          2,
          5,
          2,
        ],
      },
      {
        name: 'H2-',
        scr: [
          "R2 U' R U R2' U' R2' U R U2 R' U2 R2 U2' R2 U2 R' U2' R2'",
          "R2' U2' R' U2 R2 U2' R2 U2 R' U2 R U R2' U' R2' U R U' R2",
          "R U2 R' U2 R2 U R U2' R2 U' R U R2 U2 R' U' R' U R'",
          "R' U R' U' R' U2 R2 U R U' R2 U2' R U R2 U2 R' U2 R",
          "R2 U' R U2' R2 U2' R2 U R2' U2' R2' U R2 U2' R2 U2' R U' R2",
          "R U2 R' U2 R2 U R U2' R2 U' R U R2 U2 R' U' R' U R'",
          "R2 U' R U2' R2 U2' R2 U R2' U2' R2' U R2 U2' R2 U2' R U' R2",
          "R' U R' U' R' U2 R2 U R U' R2 U2' R U R2 U2 R' U2 R",
          "R U2 R' U2 R2 U R U2' R2 U' R U R2 U2 R' U' R' U R'",
          "R2 U' R U R2' U' R2' U R U2 R' U2 R2 U2' R2 U2 R' U2' R2'",
          "R2 U' R U2' R2 U2' R2 U R2' U2' R2' U R2 U2' R2 U2' R U' R2",
          "R2' U2' R' U2 R2 U2' R2 U2 R' U2 R U R2' U' R2' U R U' R2",
          "R' U R' U' R' U2 R2 U R U' R2 U2' R U R2 U2 R' U2 R",
          "R2 U' R U R2' U' R2' U R U2 R' U2 R2 U2' R2 U2 R' U2' R2'",
          "R2 U' R U2' R2 U2' R2 U R2' U2' R2' U R2 U2' R2 U2' R U' R2",
          "R2' U2' R' U2 R2 U2' R2 U2 R' U2 R U R2' U' R2' U R U' R2",
          "R U2 R' U2 R2 U R U2' R2 U' R U R2 U2 R' U' R' U R'",
          "R2 U' R U R2' U' R2' U R U2 R' U2 R2 U2' R2 U2 R' U2' R2'",
          "R2 U' R U2' R2 U2' R2 U R2' U2' R2' U R2 U2' R2 U2' R U' R2",
          "R2' U2' R' U2 R2 U2' R2 U2 R' U2 R U R2' U' R2' U R U' R2",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          4,
          1,
          4,
          5,
          2,
          5,
          1,
          3,
          1,
          2,
          4,
          2,
          3,
          5,
          3,
        ],
      },
    ],
  },

  {
    cat: 'I',
    cases: [
      {
        name: 'I1+',
        scr: [
          "R' U2 R' U2 R' U2 R2 U2 R2 U2' R U R2' U R U R2",
          "R U2 R2 U R U' R2' U2' R2 U2 R2 U R U2' R2' U' R2' U2' R'",
          "R U R2' U R2' U R U2' R U2 R U2' R2' U R2 U' R2 U' R'",
          "R U R' U' R2 U R2 U' R2' U2' R2 U2' R2' U2 R2' U2 R U2' R'",
          "R2 U R2' U R2 U' R2' U2 R2 U2 R2' U2 R2 U2 R2' U' R2 U' R2'",
          "R2 U2 R2' U2' R2 U2' R2' U R2 U2 R2' U2 R2 U2' R2' U R2 U' R2'",
          "R2 U2 R2' U2' R2 U2' R2' U R2 U' R2' U2' R2 U2 R2' U' R2 U' R2'",
          "R2 U2' R U R U' R2 U' R2 U R2' U' R2' U2' R2 U' R' U2' R2",
          "R2' U R2 U R2' U' R2 U2 R2' U2 R2 U2 R2' U2 R2 U' R2' U' R2",
          "R2' U2 R2 U R U2 R2 U R2' U2' R' U' R2' U2' R2 U R U' R'",
          "R2' U2 R2 U2' R2' U R2 U2 R U R' U' R2' U2' R2 U R U' R'",
          "R2' U2 R2 U2' R2' U2' R2 U R2' U2 R2 U2 R2' U2' R2 U R2' U' R2",
          "R2' U2 R2 U2' R2' U2' R2 U R2' U' R2 U2' R2' U2 R2 U' R2' U' R2",
          "R' U2 R' U2 R2' U2 R2 U R U2' R U R' U R2 U2 R2' U2 R",
          "R2 U R2' U' R2 U2 R2' U2 R2 U2' R2' U' R2 U2 R2' U' R2 U' R2'",
          "R2 U R2' U' R2 U' R2' U2' R2 U2 R2' U2 R2 U2 R2' U' R2 U' R2'",
          "R2 U' R2' U2 R2 U R2' U2' R2 U' R2' U' R2 U' R2' U2' R2 U' R2'",
          "R2' U R2 U' R2' U2 R2 U2 R2' U2' R2 U' R2' U2 R2 U' R2' U' R2",
          "R2' U R2 U' R2' U' R2 U2' R2' U2 R2 U2 R2' U2 R2 U' R2' U' R2",
          "R2' U' R2 U2 R2' U R2 U2' R2' U' R2 U' R2' U' R2 U2' R2' U' R2",
        ],
      },
      {
        name: 'I1-',
        scr: [
          "R U2' R U2' R U2' R2' U2' R2' U2 R' U' R2 U' R' U' R2' U' R'",
          "R' U2' R2' U' R' U R2 U2 R2' U2' R2' U' R' U2 R2 U R2 U2 R",
          "R U R2' U R' U' R2' U R2' U R2 U' R2 U R2' U2 R2' U2 R",
          "R2 U2 R2' U R2 U' R2 U2' R2 U2 R U R' U2 R2' U2' R2' U2 R2'",
          "R2' U2 R2 U2 R2 U' R2 U R2 U2' R2' U2 R U2' R U2' R U2' R",
          "R U2 R' U' R2' U' R2' U' R' U R2' U R U2 R2 U2 R2'",
          "R2 U2 R2' U2 R2 U' R2' U R2 U R2' U R2 U2' R2' U R2 U R2'",
          "R2 U2 R2' U2' R2 U R2' U2' R' U' R U R2 U2 R2' U' R'",
          "R2 U2 R2' U2' R2 U' R2' U' R2 U R2' U2 R2 U2' R2' U R2 U R2'",
          "R2 U2 R2' U2' R2 U' R2' U' R2 U2' R2' U2' R2 U2 R2' U' R2 U R2'",
          "R2' U2 R2 U2 R2' U' R2 U R2' U R2 U R2' U2' R2 U R2' U R2",
          "R2' U2 R2 U2 R' U' R U2 R2' U R2 U2' R2' U2 R2 U' R'",
          "R2' U2 R2 U2 R' U' R U2 R2' U' R2 U2 R2' U2' R2 U R'",
          "R2' U2 R2 U2' R2' U' R2 U' R2' U R2 U2 R2' U2' R2 U R2' U R2",
          "R2' U2 R2 U2' R2' U' R2 U' R2' U2' R2 U2' R2' U2 R2 U' R2' U R2",
          "R' U2 R U' R' U' R2 U2 R' U' R2' U' R2' U' R2 U2 R2' U2' R'",
          "R' U2 R' U2' R2 U R U R2' U2 R2 U2 R2' U R' U2 R U2' R",
          "R' U2 R' U2' R2 U R U2' R2 U2' R U' R2 U R2' U2 R2 U2' R'",
          "R U R2' U' R U R2 U2' R2' U' R2 U2' R2 U2' R U2' R U' R'",
          "R U R2' U' R U R2' U2' R2 U' R2' U2' R U2' R U2' R U' R'",
        ],
      },
      {
        name: 'I2+',
        scr: [
          "R' U' R2' U' R' U' R2 U' R' U2 R2' U2' R2' U2' R U2' R U2' R",
          "R U2 R2 U R2 U2 R' U' R2' U2' R2' U2 R2 U R' U' R2' U2' R'",
          "R U R2' U2 R2 U2 R U R2' U R' U' R2' U' R2' U' R' U2 R",
          "R U R' U R2 U2' R2' U2 R2 U' R2' U2 R U' R' U2 R2 U2 R2'",
          "R U R' U' R2 U2 R2' U2' R2 U R2' U2 R U' R' U2 R2 U2 R2'",
          "R U R' U' R2' U2 R2 U R U2 R2 U' R2' U2' R' U' R2' U2' R2",
          "R U R' U' R2' U2 R2 U R U' R' U2' R2' U R2 U2' R2' U2 R2",
          "R U R' U' R2' U2 R2 U R U' R' U2' R2' U' R2 U2 R2' U2' R2",
          "R U2 R' U2' R2 U2' R2 U2 R2' U2 R2 U R2' U' R2' U R U' R'",
          "R2 U R2' U R2 U2' R2' U R2 U R2' U R2 U' R2' U2 R2 U2 R2'",
          "R2 U R2' U R2 U2' R2' U R2 U2 R2' U2' R2 U2' R2' U R2 U' R2'",
          "R2 U R2' U R2 U2' R2' U2 R2 U R2' U' R2 U2 R2' U2 R2 U2' R2'",
          "R2 U R2' U R2 U2' R2' U2 R2 U R2' U' R2 U' R2' U2' R2 U2 R2'",
          "R2 U R2' U R2 U2' R2' U2' R2 U2' R2' U2 R2 U R2' U R2 U' R2'",
          "R2 U R2' U R2 U2' R2' U2' R2 U2' R2' U2' R2 U R2' U' R2 U' R2'",
          "R2 U R2' U' R2 U2 R2' U2' R2 U2' R2' U' R2 U2 R2' U2 R2 U2' R2'",
          "R2 U R2' U' R2 U2 R2' U2' R2 U2' R2' U' R2 U' R2' U2' R2 U2 R2'",
          "R2' U R2 U R2' U2' R2 U R2' U R2 U R2' U' R2 U2 R2' U2 R2",
          "R2' U R2 U R2' U2' R2 U R2' U2 R2 U2' R2' U2' R2 U R2' U' R2",
          "R2' U R2 U R2' U2' R2 U2 R2' U R2 U' R2' U2 R2 U2 R2' U2' R2",
        ],
      },
      {
        name: 'I2-',
        scr: [
          "R U R2 U R U R2' U R U2' R2 U2 R2 U2 R' U2 R' U2 R'",
          "R' U2' R2' U' R2' U2' R U R2 U2 R2 U2' R2' U' R U R2 U2 R",
          "R2 U2' R' U' R2 U2' R2' U' R2' U R2 U' R2 U' R U R U2' R2",
          "R2 U' R2' U2' R2 U' R2' U' R2 U' R2' U2' R2 U R2' U2 R2 U' R2'",
          "R2' U' R2 U2' R2' U' R2 U' R2' U' R2 U2' R2' U R2 U2 R2' U' R2",
          "R' U2' R2 U2' R2 U' R2' U R2' U' R2 U' R2 U R U' R2 U' R'",
          "R U2 R2' U2' R2 U' R2' U R' U2 R2' U2 R' U' R2' U2 R U2' R",
          "R U' R' U2' R U2 R' U' R U2 R' U' R U R' U2' R U R'",
          "R' U2 R' U2 R' U2 R' U2' R2 U2 R2' U' R2' U R2' U2' R2' U2' R2",
          "R' U2 R' U2' R U' R2 U2' R2' U2' R2 U' R' U' R2' U2 R U2' R",
          "R' U' R2 U' R2 U R2' U2' R U2 R U2' R U R2' U R2'",
          "R U R' U2 R' U2 R2' U2 R2' U R2 U2 R2' U' R' U R2 U' R'",
          "R U R' U2 R' U2 R' U2 R2 U R2' U2 R2 U' R' U R2 U' R'",
          "R U2 R2' U2 R2 U R' U R U2' R U R2 U2 R2' U2 R' U2 R'",
          "R U2 R2 U2' R2' U R2 U R2 U R U2' R2' U R U R' U2' R",
          "R2 U2' R2 U2 R2 U2' R U' R' U2' R2' U2 R2' U R2' U' R2 U2' R2'",
          "R2 U' R2' U R2 U2' R2' U2 R2 U2 R2' U R2 U R2' U2 R2 U2' R2'",
          "R2 U' R2' U R2 U2' R2' U2 R2 U2 R2' U R2 U2' R2' U2' R2 U2 R2'",
          "R2 U' R2' U' R2 U2 R2' U2 R2 U2 R2' U2 R2 U' R2' U R2 U R2'",
          "R2 U' R2' U' R2 U2 R2' U2 R2 U2 R2' U2' R2 U' R2' U' R2 U R2'",
        ],
      },
      {
        name: 'I3+',
        scr: [
          "R U R' U2 R U' R' U2' R' U2 R U2 R U2' R2' U2' R",
          "R' U2 R2 U2 R' U2' R' U2' R U2 R U R' U2' R U' R'",
          "R' U R2 U R U R' U R U2' R' U' R2' U2 R U R'",
          "R' U' R U' R' U2' R2 U R U2 R' U' R U' R' U' R2' U' R",
          "R U2' R2' U2 R2 U2 R2' U R U2 R U2 R2' U2 R U R' U2 R",
          "R2 U R' U2 R2 U2 R2' U' R' U2 R2' U2 R2 U' R2 U' R' U2 R'",
          "R U R' U2 R U2 R' U2' R' U2 R2 U2 R' U' R' U2 R2 U2 R'",
          "R2 U2 R2' U R2 U' R2' U R2 U' R2' U2' R2 U R2' U2' R2 U2 R2'",
          "R2' U2 R2 U R2' U' R2 U R2' U' R2 U2' R2' U R2 U2' R2' U2 R2",
          "R' U2 R U2 R' U2' R U R' U2 R U R U2' R' U2' R U' R'",
          "R U R' U2 R U2 R' U' R' U2' R U' R' U2 R U2' R' U2' R",
          "R U2' R U R2' U R2' U2' R2 U2' R U R2 U2' R2' U2' R U' R2'",
          "R U2' R2' U2' R U R U2' R2' U2' R U2 R U2' R' U2' R U' R'",
          "R2 U2' R2' U2 R2 U' R2' U2 R2 U R2' U' R2 U R2' U' R2 U2' R2'",
          "R2' U2' R2 U2 R2' U' R2 U2 R2' U R2 U' R2' U R2 U' R2' U2' R2",
          "R' U2' R U' R' U2' R2 U2' R' U2' R' U' R2 U2' R2' U2' R2 U2 R'",
          "R U2 R' U' R2 U R2' U R2 U2' R2 U2 R2 U2 R' U' R' U2 R",
          "R U' R' U2' R2 U R' U2 R U2 R2' U2' R' U' R U' R' U2 R",
          "R2' U2 R2 U2 R2' U R' U R U' R2 U' R2' U2 R2 U' R2 U' R2'",
          "R U2' R' U' R U2' R2' U2 R U2 R' U R2 U2 R' U R U2 R'",
        ],
      },
      {
        name: 'I3-',
        scr: [
          "R U2' R2' U2' R U2 R U2 R' U2' R' U' R U2 R' U R",
          "R' U' R U2' R' U R U2 R U2' R' U2' R' U2 R2 U2 R'",
          "R U R' U R U2 R2' U' R' U2' R U R' U R U R2 U R'",
          "R U' R2' U' R' U' R U' R' U2 R U R2 U2' R' U' R U' R'",
          "R U2' R' U2' R U2 R' U' R U2' R' U' R' U2 R U2 R'",
          "R2 U2' R2' U' R2 U R2' U' R2 U R2' U2 R2 U' R2' U2 R2 U2' R2'",
          "R2' U2' R2 U' R2' U R2 U' R2' U R2 U2 R2' U' R2 U2 R2' U2' R2",
          "R' U' R U2' R' U2' R U2 R U2' R2' U2' R U R U2' R2' U2' R",
          "R2' U' R U2' R2' U2' R2 U R U2' R2 U2' R2' U R2' U R U2' R",
          "R' U2 R2 U2' R2' U2' R2 U' R' U2' R' U2' R2 U2' R' U' R U2' R'",
          "R U2 R' U R U2 R2' U2 R U2 R U R2' U2 R2 U2 R2' U2' R",
          "R2 U2 R2' U2' R2 U R2' U2' R2 U' R2' U R2 U' R2' U R2 U2 R2'",
          "R2' U2 R2 U2' R2' U R2 U2' R2' U' R2 U R2' U' R2 U R2' U2 R2",
          "R' U2 R2 U2 R' U' R' U2 R2 U2 R' U2' R' U2 R U2 R' U R",
          "R' U2 R' U' R2 U' R2 U2 R2' U2 R' U' R2' U2 R2 U2 R' U R2",
          "R' U' R U2' R' U2' R U R U2 R' U R U2' R' U2 R U2 R'",
          "R2 U2' R2' U' R2 U R2' U' R2 U R2' U2 R2 U R2' U2' R2 U2 R2'",
          "R2 U' R2 U2' R' U2 R2 U2' R U R2 U2 R2' U2' R2 U' R U R2'",
          "R2 U' R2 U2' R' U2 R2 U2' R U2' R2 U2' R2' U2 R2 U2 R U R2'",
          "R2' U2' R2 U' R2' U R2 U' R2' U R2 U2 R2' U R2 U2' R2' U2 R2",
        ],
      },
      {
        name: 'I4+',
        scr: [
          "R U2 R' U' R2 U R' U R U2' R' U R' U R U2 R'",
          "R U2 R2 U R U' R' U R2' U' R2 U' R U R' U' R2' U' R'",
          "R' U R2 U2' R' U2' R2 U R U R2' U' R' U' R' U' R2' U' R",
          "R U2' R' U R U' R U R2' U R2 U R2' U2' R2 U' R' U2' R'",
          "R2' U2' R U2 R' U2' R U2' R2 U2' R U' R' U R2' U' R U2' R'",
          "R2 U2 R2' U' R2 U R2' U2' R2 U R2' U2 R2 U R2' U2' R2 U' R2'",
          "R2' U2 R2 U' R2' U R2 U2' R2' U R2 U2 R2' U R2 U2' R2' U' R2",
          "R' U2' R2' U2 R' U' R' U R2 U2' R2 U' R U' R U R2' U2' R",
          "R2 U R2' U R2 U2' R2' U2 R2 U R2' U R2 U R2' U' R2 U2' R2'",
          "R2 U R2' U R2 U2' R2' U2 R2 U2 R2' U R2 U' R2' U' R2 U' R2'",
          "R2 U R2' U' R2 U2 R2' U2' R2 U2' R2' U R2 U R2' U' R2 U2' R2'",
          "R2 U R2' U' R2 U2 R2' U2' R2 U' R2' U R2 U' R2' U' R2 U' R2'",
          "R2 U2 R2' U' R2 U2 R2' U2 R2 U2' R2' U R2 U2 R2' U' R2 U2' R2'",
          "R2 U2 R2' U' R2 U' R2' U2' R2 U2 R2' U' R2 U2 R2' U' R2 U2' R2'",
          "R2' U R2 U R2' U2' R2 U2 R2' U R2 U R2' U R2 U' R2' U2' R2",
          "R2' U R2 U R2' U2' R2 U2 R2' U2 R2 U R2' U' R2 U' R2' U' R2",
          "R2' U R2 U' R2' U2 R2 U2' R2' U2' R2 U R2' U R2 U' R2' U2' R2",
          "R2' U R2 U' R2' U2 R2 U2' R2' U' R2 U R2' U' R2 U' R2' U' R2",
          "R2' U2 R2 U' R2' U2 R2 U2 R2' U2' R2 U R2' U2 R2 U' R2' U2' R2",
          "R2' U2 R2 U' R2' U' R2 U2' R2' U2 R2 U' R2' U2 R2 U' R2' U2' R2",
        ],
      },
      {
        name: 'I4-',
        scr: [
          "R' U2' R U R2' U' R U' R' U2 R U' R U' R' U2' R",
          "R U' R2' U2 R U2 R2' U' R' U' R2 U R U R U R2 U R'",
          "R' U2' R2' U' R' U R U' R2 U R2' U R' U' R U R2",
          "R U2 R2 U2' R U R U' R2' U2 R2' U R' U R' U' R2 U2 R'",
          "R2 U2' R2' U R2 U' R2' U2 R2 U' R2' U2' R2 U' R2' U2 R2 U R2'",
          "R2' U2' R2 U R2' U' R2 U2 R2' U' R2 U2' R2' U' R2 U2 R2' U R2",
          "R2 U2 R' U2' R U2 R' U2 R2' U2 R' U R U' R2 U R' U2 R",
          "R' U2 R U' R' U R' U' R2 U' R2' U' R2 U2 R2' U R U2 R",
          "R U2 R' U' R U2 R' U' R U R2' U2' R U R U2' R2' U2' R",
          "R2 U2' R2' U R2 U R2' U2 R2 U2' R2' U R2 U2' R2' U R2 U2 R2'",
          "R2 U2' R2' U R2 U2' R2' U2' R2 U2 R2' U' R2 U2' R2' U R2 U2 R2'",
          "R2 U' R2' U R2 U2' R2' U2 R2 U R2' U' R2 U R2' U R2 U R2'",
          "R2 U' R2' U R2 U2' R2' U2 R2 U2 R2' U' R2 U' R2' U R2 U2 R2'",
          "R2 U' R2' U' R2 U2 R2' U2' R2 U2' R2' U' R2 U R2' U R2 U R2'",
          "R2 U' R2' U' R2 U2 R2' U2' R2 U' R2' U' R2 U' R2' U R2 U2 R2'",
          "R2' U2' R2 U R2' U R2 U2 R2' U2' R2 U R2' U2' R2 U R2' U2 R2",
          "R2' U2' R2 U R2' U2' R2 U2' R2' U2 R2 U' R2' U2' R2 U R2' U2 R2",
          "R2' U' R2 U R2' U2' R2 U2 R2' U R2 U' R2' U R2 U R2' U R2",
          "R2' U' R2 U R2' U2' R2 U2 R2' U2 R2 U' R2' U' R2 U R2' U2 R2",
          "R2' U' R2 U' R2' U2 R2 U2' R2' U2' R2 U' R2' U R2 U R2' U R2",
        ], // I4-
      },
      {
        name: 'I5+',
        scr: [
          "R U2' R' U' R U' R U2 R' U' R U' R2' U R U2' R'",
          "R U R2 U R U' R' U R2' U R2 U' R U R' U' R2' U2' R'",
          "R' U R2 U R U R U R2 U' R' U' R2' U2 R U2 R2' U' R",
          "R2 U R2' U R2 U R2' U' R2 U R2' U2 R2 U2' R2' U R2 U' R2'",
          "R2 U R2' U R2 U R2' U' R2 U2' R2' U2' R2 U2 R2' U' R2 U' R2'",
          "R2 U2 R2' U R2 U2' R2' U R2 U2' R2' U2 R2 U R2' U R2 U2' R2'",
          "R2 U2 R2' U R2 U2' R2' U' R2 U2 R2' U2' R2 U2' R2' U R2 U2' R2'",
          "R2 U2 R2' U R2 U' R2' U' R2 U2 R2' U2 R2 U2' R2' U R2 U' R2'",
          "R2 U2 R2' U R2 U' R2' U' R2 U' R2' U2' R2 U2 R2' U' R2 U' R2'",
          "R2' U R2 U R2' U R2 U' R2' U R2 U2 R2' U2' R2 U R2' U' R2",
          "R2' U R2 U R2' U R2 U' R2' U2' R2 U2' R2' U2 R2 U' R2' U' R2",
          "R2' U2 R2 U R2' U2' R2 U R2' U2' R2 U2 R2' U R2 U R2' U2' R2",
          "R2' U2 R2 U R2' U2' R2 U' R2' U2 R2 U2' R2' U2' R2 U R2' U2' R2",
          "R2' U2 R2 U R2' U' R2 U' R2' U2 R2 U2 R2' U2' R2 U R2' U' R2",
          "R2' U2 R2 U R2' U' R2 U' R2' U' R2 U2' R2' U2 R2 U' R2' U' R2",
          "R U2' R2' U2' R U R U2' R2' U R U' R' U2 R U' R' U2 R",
          "R U2 R U R2' U2 R2 U' R2' U' R2 U' R' U R' U' R U2 R'",
          "R U2 R' U R2 U' R U R' U2 R2' U2 R' U2 R U2' R' U2 R2",
          "R2 U R2' U2 R2 U' R2' U2' R2 U' R2' U2 R2 U' R2' U R2 U2' R2'",
          "R2' U R2 U2 R2' U' R2 U2' R2' U' R2 U2 R2' U' R2 U R2' U2' R2",
        ],
      },
      {
        name: 'I5-',
        scr: [
          "R' U2 R U R' U R' U2' R U R' U R2 U' R' U2 R",
          "R U' R2' U' R' U' R' U' R2' U R U R2 U2' R' U2' R2 U R'",
          "R' U' R2' U' R' U R U' R2 U' R2' U R' U' R U R2 U2 R",
          "R' U2 R2 U2 R' U' R' U2 R2 U' R' U R U2' R' U R U2' R'",
          "R2 U2' R2' U' R2 U R2' U R2 U R2' U2 R2 U2' R2' U R2 U R2'",
          "R2 U2' R2' U' R2 U R2' U R2 U2' R2' U2' R2 U2 R2' U' R2 U R2'",
          "R2 U2' R2' U' R2 U2 R2' U R2 U2' R2' U2 R2 U2 R2' U' R2 U2 R2'",
          "R2 U2' R2' U' R2 U2 R2' U' R2 U2 R2' U2' R2 U' R2' U' R2 U2 R2'",
          "R2 U' R2' U' R2 U' R2' U R2 U2 R2' U2 R2 U2' R2' U R2 U R2'",
          "R2 U' R2' U' R2 U' R2' U R2 U' R2' U2' R2 U2 R2' U' R2 U R2'",
          "R2' U2' R2 U' R2' U R2 U R2' U R2 U2 R2' U2' R2 U R2' U R2",
          "R2' U2' R2 U' R2' U R2 U R2' U2' R2 U2' R2' U2 R2 U' R2' U R2",
          "R2' U2' R2 U' R2' U2 R2 U R2' U2' R2 U2 R2' U2 R2 U' R2' U2 R2",
          "R2' U2' R2 U' R2' U2 R2 U' R2' U2 R2 U2' R2' U' R2 U' R2' U2 R2",
          "R2' U' R2 U' R2' U' R2 U R2' U2 R2 U2 R2' U2' R2 U R2' U R2",
          "R2' U' R2 U' R2' U' R2 U R2' U' R2 U2' R2' U2 R2 U' R2' U R2",
          "R U2' R2' U R U' R U' R2 U2' R2 U R' U' R' U2 R2' U2' R'",
          "R2 U' R2' U2' R2 U R2' U2 R2 U R2' U2' R2 U R2' U' R2 U2 R2'",
          "R2' U' R2 U2' R2' U R2 U2 R2' U R2 U2' R2' U R2 U' R2' U2 R2",
          "R' U2' R U' R2' U R' U' R U2' R2 U2' R U2' R' U2 R U2' R2'",
        ],
      },
      {
        name: 'I6+',
        scr: [
          "R U' R' U2 R U2 R' U2' R' U2' R2 U R U2' R2 U2' R2' U' R2'",
          "R U R' U R2 U2' R2' U' R2 U2' R2 U2' R2 U' R' U R' U2 R",
          "R U R' U R2' U2' R2 U' R2' U2' R U2' R2 U' R' U R' U2 R",
          "R2' U2 R' U' R2 U2' R2 U2 R' U2' R' U2 R U' R2' U R U R2'",
          "R' U2 R2' U2 R' U' R2 U' R2 U R2' U R2' U R U R2 U2 R2'",
          "R U2' R2 U2' R' U2' R U' R2' U' R' U' R U' R' U' R2 U R2'",
          "R2 U' R2' U' R2 U2 R U2 R U2' R' U' R U2' R U' R2' U2' R2",
          "R2 U R2 U2 R2' U2 R' U' R2' U2 R U2 R U2' R' U2' R U R'",
          "R2 U2' R2' U' R' U' R2 U' R2 U' R2' U R2' U R U2' R2 U2' R",
          "R2 U' R' U' R2 U R' U2' R U2 R U2' R2' U2 R2' U R U2' R2",
          "R' U2' R U' R U R2' U2 R2' U2 R2' U R2 U2 R2' U' R U' R'",
          "R' U2' R U' R U R2' U2 R' U2 R2 U R2' U2 R2 U' R U' R'",
          "R U2' R2 U R' U2 R' U R2' U' R' U R2' U2 R U' R2' U2 R'",
          "R U2' R2 U R' U2' R2 U' R U R2 U' R U2' R U' R2' U2 R'",
          "R U' R U R U2 R2 U' R2' U' R' U' R' U' R' U R U R'",
          "R2 U2 R2' U R2 U' R2 U R2' U' R2' U R2 U2 R2' U' R' U' R",
          "R2 U' R2' U R U R' U R U R2 U R' U2 R U2 R2' U2 R'",
          "R2' U2 R2 U R' U2 R' U R U2 R' U2' R' U2' R2' U R2 U R2'",
          "R U' R' U' R U R U R U R2 U R2' U2' R' U' R' U R'",
          "R' U R U R2 U2' R2' U' R2 U R2 U' R2' U R2' U' R2 U2' R2'",
        ],
      },
      {
        name: 'I6-',
        scr: [
          "R' U R U2' R' U2' R U2 R U2 R2' U' R' U2 R2' U2 R2 U R2",
          "R U2' R2 U2' R U R2' U R2' U' R2 U' R2 U' R' U' R2' U2' R2",
          "R2 U2' R U R2' U2 R2' U2' R U2 R U2' R' U R2 U' R' U' R2",
          "R' U' R U' R2 U2 R2' U R2 U2 R' U2 R2' U R U' R U2' R'",
          "R' U' R U' R2' U2 R2 U R2' U2 R2' U2 R2' U R U' R U2' R'",
          "R2' U R2 U R2' U2' R' U2' R' U2 R U R' U2 R' U R2 U2 R2'",
          "R' U2 R2' U2 R U2 R' U R2 U R U R' U R U R2' U' R2",
          "R U' R' U' R2' U2 R2 U R2' U' R2' U R2 U' R2 U R2' U2 R2",
          "R' U R U R' U' R' U' R' U' R2' U' R2 U2 R U R U' R",
          "R2 U2' R2' U' R U2' R U' R' U2' R U2 R U2 R2 U' R2' U' R2",
          "R2' U R2 U' R' U' R U' R' U' R2' U' R U2' R' U2' R2 U2' R",
          "R2' U2' R2 U' R2' U R2' U' R2 U R2 U' R2' U2' R2 U R U R'",
          "R' U R' U' R' U2' R2' U R2 U R U R U R U' R' U' R",
          "R' U2 R2' U' R U2 R2' U R' U' R2' U R' U2 R' U R2 U2' R",
          "R' U2 R2' U' R U2' R U' R2 U R U' R2 U2' R' U R2 U2' R",
          "R U2 R' U R' U' R2 U2' R U2' R2' U' R2 U2' R2' U R'",
          "R U2 R' U R' U' R2 U2' R2 U2' R2 U' R2' U2' R2 U R'",
          "R2' U R U R2' U' R U2 R' U2' R' U2 R2 U2' R2 U' R' U2 R2'",
          "R2' U2 R2 U R U R2' U R2' U R2 U' R2 U' R' U2 R2' U2 R'",
          "R2' U' R2' U2' R2 U2' R U R2 U2' R' U2' R' U2 R U2 R' U' R",
        ],
      },
    ],
  }, //B

  {
    cat: 'J',
    cases: [
      {
        name: 'J1+',
        scr: [
          "R U2' R U2 R' U2' R' U R U2 R U2' R' U2 R'",
          "R U2' R U2 R' U2' R' U2' R U2' R U2 R' U2' R'",
          "R U2' R U2 R' U2' R' U R U2' R U2 R' U2' R'",
          "R U2' R U2 R' U2' R' U' R U2 R U2' R' U2 R'",
          "R U2' R' U2 R' U2 R U2 R U2' R' U2 R'",
          "R U2' R' U2 R' U' R U2' R U2 R' U2' R' U2' R",
          "R' U2 R U2 R U2' R' U2 R' U R U2' R U2 R'",
          "R' U2' R' U R U2' R U2 R' U2' R' U R U2 R",
          "R' U2' R' U' R U2 R U2' R' U2 R' U' R U2 R",
          "R' U' R U2' R U2 R' U2' R' U2' R U2' R U2 R'",
          "R U2 R U2 R' U2' R' U' R U2' R U2 R' U' R'",
          "R2 U2 R U2 R2' U2' R' U' R U2' R2 U2 R' U' R2'",
          "R U2 R U2' R' U2 R' U R U2' R U2 R' U2' R'",
          "R U2 R U2' R' U2 R' U' R U2 R U2' R' U2 R'",
          "R U2 R U2' R' U2 R' U2 R U2 R U2' R' U2 R'",
          "R U2 R U2' R' U2 R' U' R U2' R U2 R' U2' R'",
          "R U2 R' U2' R' U R U2' R U2 R' U2' R' U R",
          "R U2 R' U2' R' U' R U2 R U2' R' U2 R' U' R",
          "R' U R U2' R U2 R' U2' R' U R U2 R U2' R'",
          "R' U2 R' U2 R U2 R U2' R' U2 R' U R U2' R",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          1,
          2,
          4,
          4,
          5,
          2,
          2,
          3,
          3,
          3,
          4,
          5,
          5,
        ],
      },
      {
        name: 'J1-',
        scr: [
          "R' U2 R' U2' R U2 R U2 R' U2 R' U2' R U2 R",
          "R' U2 R' U2' R U2 R U' R' U2' R' U2 R U2' R",
          "R U R' U2' R' U2 R U2' R U R' U2' R' U2 R",
          "R U2' R U R' U2 R' U2' R U2 R U2 R' U2 R'",
          "R U2' R U2' R' U2' R' U2 R U2' R U' R' U2 R'",
          "R U' R' U2 R' U2' R U2 R U' R' U2' R' U2 R",
          "R' U2' R U2 R U R' U2' R' U2 R U2' R U R'",
          "R' U2' R U2 R U' R' U2 R' U2' R U2 R U' R'",
          "R' U2' R' U2 R U2' R U R' U2 R' U2' R U2 R",
          "R' U2' R' U2 R U2' R U2' R' U2' R' U2 R U2' R",
          "R' U2' R' U2 R U2' R U R' U2' R' U2 R U2' R",
          "R' U2' R' U2 R U2' R U' R' U2 R' U2' R U2 R",
          "R2' U2' R' U2' R2 U2 R U R' U2 R2' U2' R U R2",
          "R' U2' R' U2' R U2 R U R' U2 R' U2' R U R",
          "R U R' U2 R' U2' R U2 R U2 R' U2 R' U2' R",
          "R U2 R U R' U2' R' U2 R U2' R U R' U2' R'",
          "R U2 R U' R' U2 R' U2' R U2 R U' R' U2' R'",
          "R U2' R' U2' R' U2 R U2' R U' R' U2 R' U2' R",
          "R' U2 R U2' R U R' U2 R' U2' R U2 R U2 R'",
          "R' U2 R U2' R U2' R' U2' R' U2 R U2' R U' R'",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          1,
          2,
          2,
          3,
          4,
          4,
          4,
          5,
          5,
          2,
          3,
          3,
          5,
        ],
      },
      {
        name: 'J2+',
        scr: [
          "R2 U R2' U2 R2 U2 R2' U2' R2 U R2' U2 R2 U2 R2'",
          "R2 U R2' U' R2 U2' R2' U2 R2 U' R2' U2 R2 U2 R2'",
          "R2' U R2 U2 R2' U2 R2 U2' R2' U R2 U2 R2' U2 R2",
          "R2' U R2 U' R2' U2' R2 U2 R2' U' R2 U2 R2' U2 R2",
          "R U2 R2 U R2' U2 R2 U2 R2 U2' R2' U R2 U2 R2' U2 R2",
          "R U2 R' U' R2 U R2' U R U' R U' R2' U2 R U2 R'",
          "R2 U2 R U R' U' R2' U2' R2 U R U' R2 U2' R2 U2 R2'",
          "R2 U2 R2' U R2 U2 R' U2 R U2' R' U' R U2' R' U2 R'",
          "R2 U2 R2' U R2 U2 R' U2' R U2 R' U R U2 R' U2' R'",
          "R2' U2 R2 U R2' U2 R2' U2 R U2' R' U' R U2' R' U2 R'",
          "R2' U2 R2 U R2' U2 R2' U2' R U2 R' U R U2 R' U2' R'",
          "R2' U2 R' U R U' R2 U2' R2' U2' R2 U2' R2 U' R U2' R2",
          "R' U2 R2' U R2 U2 R2' U2 R2' U2' R2 U R2' U2 R2 U2 R2'",
          "R U R' U2 R2' U2 R2 U2' R2' U2' R2 U2' R U' R2 U2' R2",
          "R U R' U' R2' U2' R2 U2 R2' U R2 U2' R U' R2 U2' R2",
          "R U R' U' R' U2' R U R U R2' U R2 U2 R2' U2' R",
          "R2 U R2' U2 R2 U2 R2' U R' U2 R2' U R2 U2 R2' U2 R2'",
          "R2 U R2' U2 R2' U2 R2 U2' R2' U R2 U2 R2' U2' R' U' R2'",
          "R2 U R2' U' R2' U2' R2 U2 R2' U' R2 U2 R2' U2' R' U' R2'",
          "R2 U2' R U2' R2 U' R2' U2' R2 U2 R2 U' R2' U2 R2 U2 R2'",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          1,
          2,
          3,
          4,
          5,
          4,
          2,
          3,
          2,
          3,
          4,
          5,
          5,
        ],
      },
      {
        name: 'J2-',
        scr: [
          "R2 U' R2' U R2 U2 R2' U2' R2 U R2' U2' R2 U2' R2'",
          "R2 U' R2' U2' R2 U2' R2' U2 R2 U' R2' U2' R2 U2' R2'",
          "R2' U' R2 U R2' U2 R2 U2' R2' U R2 U2' R2' U2' R2",
          "R2' U' R2 U2' R2' U2' R2 U2 R2' U' R2 U2' R2' U2' R2",
          "R U2' R2 U2' R2' U' R2 U2' R2 U2 R' U2' R U' R' U2' R",
          "R U2' R2 U2' R2' U' R2 U2' R2 U2' R' U2 R U R' U2 R",
          "R U2' R2' U2' R2 U' R2' U2' R U2 R' U2' R U' R' U2' R",
          "R U2' R2' U2' R2 U' R2' U2' R U2' R' U2 R U R' U2 R",
          "R U' R2' U' R U' R' U2 R U R U R' U2 R U2' R'",
          "R U' R' U R2 U2 R2' U2' R2 U R2' U2' R2 U2 R' U R'",
          "R U' R' U R2' U2 R2 U2' R2' U R2 U2' R2' U2 R2' U R'",
          "R U' R' U2' R2 U2' R2' U2 R2 U' R2' U2' R2 U2 R' U R'",
          "R U' R' U2' R2' U2' R2 U2 R2' U' R2 U2' R2' U2 R2' U R'",
          "R2 U2 R U2 R2 U R2' U2 R2 U2' R2 U R2' U2' R2 U2' R2'",
          "R2 U2 R2 U2 R U R2 U2 R2' U' R' U2' R2' U2' R2 U2 R",
          "R2 U' R2' U R2' U2 R2 U2' R2' U R2 U2' R2' U2 R' U R2'",
          "R2 U' R2' U2' R2 U2' R2' U' R' U2' R2' U' R2 U2' R2' U2' R2'",
          "R2 U' R2' U2' R2' U2' R2 U2 R2' U' R2 U2' R2' U2 R' U R2'",
          "R2' U2 R2' U2 R' U R2' U2 R2 U2 R2' U2 R2' U2' R2 U2' R2",
          "R2' U2 R' U2 R2' U R2 U2 R2' U2' R2' U R2 U2' R2' U2' R2",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          1,
          2,
          2,
          3,
          4,
          5,
          4,
          5,
          3,
          2,
          3,
          4,
          5,
        ],
      },
      {
        name: 'J3+',
        scr: [
          "R2 U2' R2' U2' R2 U R2' U2' R2 U2 R2' U R2 U' R2'",
          "R2 U2' R2' U2' R2 U' R2' U2 R2 U2' R2' U2' R2 U' R2'",
          "R2' U2' R2 U2' R2' U R2 U2' R2' U2 R2 U R2' U' R2",
          "R2' U2' R2 U2' R2' U' R2 U2 R2' U2' R2 U2' R2' U' R2",
          "R U2 R2 U2' R2' U2' R' U' R2' U2 R2 U R U2 R2 U2 R2",
          "R U2' R' U' R U2' R' U2 R U2' R2' U' R2 U2' R2' U2' R",
          "R U2' R' U' R U2' R' U2 R2 U2' R2 U' R2' U2' R2 U2' R",
          "R2' U2 R2' U R' U2 R2' U2 R2 U2 R2' U2' R2 U2' R U' R'",
          "R2' U2 R2' U R' U2 R2' U' R2 U2' R2' U2 R2 U R U' R'",
          "R2' U2 R' U R2' U2 R2' U2 R2 U2 R2' U R' U' R U2' R2",
          "R' U2 R2 U2' R2' U' R2 U' R' U' R' U2 R U R U' R'",
          "R U2 R' U R U2 R' U2' R U2' R2' U' R2 U2' R2' U2' R",
          "R U2 R' U R U2 R' U2' R2 U2' R2 U' R2' U2' R2 U2' R",
          "R U2' R' U2' R2 U R' U R' U' R2 U' R2' U R U2' R'",
          "R2 U R U2 R2 U2' R2' U R2 U2' R2' U2 R2 U R2 U' R2'",
          "R2 U R U2 R2 U2' R2' U' R2 U2 R2' U2' R2 U2' R2 U' R2'",
          "R2 U2' R2 U2' R2' U2 R2' U2 R2 U2 R2' U R' U2 R2' U2 R2'",
          "R2 U2' R2 U2' R2' U' R2 U2' R U' R2 U2' R2' U2' R2 U' R2'",
          "R2 U2' R2' U2 R2' U R' U' R2' U2 R2 U R U' R' U2' R2'",
          "R2 U2' R2' U2' R2 U R2' U2' R2' U2 R2 U R2' U2 R' U2 R2'",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          1,
          2,
          4,
          3,
          4,
          2,
          4,
          5,
          3,
          2,
          3,
          5,
          5,
        ],
      },
      {
        name: 'J3-',
        scr: [
          "R2 U2 R2' U2 R2 U R2' U2' R2 U2 R2' U2 R2 U R2'",
          "R2 U2 R2' U2 R2 U' R2' U2 R2 U2' R2' U' R2 U R2'",
          "R2' U2 R2 U2 R2' U R2 U2' R2' U2 R2 U2 R2' U R2",
          "R2' U2 R2 U2 R2' U' R2 U2 R2' U2' R2 U' R2' U R2",
          "R' U2 R' U2' R U' R' U2' R U2 R2' U2 R2' U R2 U2 R2'",
          "R' U2 R' U2' R U' R' U2' R U2 R' U2 R2 U R2' U2 R2",
          "R' U2' R' U2 R U R' U2 R U2' R2' U2 R2' U R2 U2 R2'",
          "R' U2' R' U2 R U R' U2 R U2' R' U2 R2 U R2' U2 R2",
          "R U2 R' U2' R U' R' U' R' U2' R U R' U R2 U R'",
          "R U' R U2' R2' U2 R2 U R2' U2' R2 U2 R2' U2 R U R'",
          "R U' R U2' R2' U2 R2 U' R2' U2 R2 U2' R2' U' R U R'",
          "R U' R2 U2' R2 U2 R2' U R2 U2' R2' U2 R2 U2 R U R'",
          "R U' R2 U2' R2 U2 R2' U' R2 U2 R2' U2' R2 U' R U R'",
          "R2 U2 R2 U2 R2' U R2 U2 R U R2 U2 R2' U2 R2 U R2'",
          "R2 U2 R2' U2 R2 U R2' U2' R2 U2 R2 U2 R2' U R2 U2 R",
          "R2 U2 R2' U2 R2 U' R2' U2 R2' U2' R2 U' R2' U2' R' U2' R2'",
          "R2 U' R U2' R2 U2 R2' U R2 U2' R2' U2 R2 U2 R2 U R2'",
          "R2 U' R U2' R2 U2 R2' U' R2 U2 R2' U2' R2 U' R2 U R2'",
          "R2' U2 R2 U2 R2' U R2 U2' R2' U2 R2' U2 R2 U R2' U2 R'",
          "R2' U2 R2 U2 R2' U' R2 U2 R2 U2' R2' U' R2 U2' R U2' R2",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          1,
          2,
          2,
          4,
          5,
          4,
          2,
          3,
          5,
          3,
          4,
          3,
          5,
        ],
      },
    ],
  }, //A
  {
    cat: 'K',
    cases: [
      {
        name: 'K1+',
        scr: [
          "R2 U2' R2' U' R2 U R2' U' R2 U2' R U2' R2 U' R2' U2' R2",
          "R2 U2' R2' U' R2 U2' R U2' R2 U' R2' U R2 U' R2' U2' R2",
          "R2' U2' R2 U' R2' U R2 U' R2' U2' R' U2' R2' U' R2 U2' R2'",
          "R2' U2' R2 U' R2' U2' R' U2' R2' U' R2 U R2' U' R2 U2' R2'",
          "R2 U R2' U2' R2 U R2' U' R2 U R2' U2' R2 U' R2' U' R2 U2' R2'",
          "R2 U2' R2' U R2 U2 R2' U' R2 U R2' U' R2 U2 R2' U R2 U2' R2'",
          "R2 U2' R2' U2 R' U2 R2' U R2 U2 R U2 R2 U R2' U' R2 U2' R2'",
          "R2 U2' R2' U2 R' U2 R2' U R2 U' R2' U R2 U2 R U2 R2 U2' R2'",
          "R2 U2' R2' U2' R2 U R2' U R2 U' R2' U' R2 U2 R2' U' R2 U2' R2'",
          "R2 U2' R2' U' R2 U R2' U2 R' U2 R2' U R2 U2 R U2 R2 U2' R2'",
          "R2 U2' R2' U' R2 U R2' U2' R2 U R2' U R2 U' R2' U' R2 U' R2'",
          "R2 U2' R2' U' R2 U2 R2' U' R2 U' R2' U R2 U R2' U2' R2 U2' R2'",
          "R2 U2' R2' U' R2 U2' R U2' R2 U' R2' U2' R' U2' R2' U' R2 U2' R2'",
          "R2 U2' R2' U' R2 U' R2' U2' R2 U R2' U' R2 U R2' U2' R2 U R2'",
          "R2 U' R2' U' R2 U' R2' U R2 U R2' U2' R2 U R2' U' R2 U2' R2'",
          "R2' U R2 U2' R2' U R2 U' R2' U R2 U2' R2' U' R2 U' R2' U2' R2",
          "R2' U2' R2 U R2' U2 R2 U' R2' U R2 U' R2' U2 R2 U R2' U2' R2",
          "R2' U2' R2 U2 R U2 R2 U R2' U2 R' U2 R2' U R2 U' R2' U2' R2",
          "R2' U2' R2 U2 R U2 R2 U R2' U' R2 U R2' U2 R' U2 R2' U2' R2",
          "R2' U2' R2 U2' R2' U R2 U R2' U' R2 U' R2' U2 R2 U' R2' U2' R2",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          4,
          1,
          5,
          1,
          2,
          4,
          5,
          3,
          2,
          3,
          4,
          1,
          2,
          5,
          3,
        ],
      },
      {
        name: 'K1-',
        scr: [
          "R2 U2 R2' U R2 U2 R U2 R2 U R2' U' R2 U R2' U2 R2",
          "R2 U2 R2' U R2 U' R2' U R2 U2 R U2 R2 U R2' U2 R2",
          "R2' U2 R2 U R2' U2 R' U2 R2' U R2 U' R2' U R2 U2 R2'",
          "R2' U2 R2 U R2' U' R2 U R2' U2 R' U2 R2' U R2 U2 R2'",
          "R2 U R2' U R2 U R2' U' R2 U' R2' U2 R2 U' R2' U R2 U2 R2'",
          "R2 U2 R2' U R2 U R2' U2 R2 U' R2' U R2 U' R2' U2 R2 U' R2'",
          "R2 U2 R2' U R2 U2 R U2 R2 U R2' U2 R' U2 R2' U R2 U2 R2'",
          "R2 U2 R2' U R2 U2' R2' U R2 U R2' U' R2 U' R2' U2 R2 U2 R2'",
          "R2 U2 R2' U R2 U' R2' U2 R2 U' R2' U' R2 U R2' U R2 U R2'",
          "R2 U2 R2' U R2 U' R2' U2' R' U2' R2' U' R2 U2' R U2' R2 U2 R2'",
          "R2 U2 R2' U2 R2 U' R2' U' R2 U R2' U R2 U2' R2' U R2 U2 R2'",
          "R2 U2 R2' U2' R' U2' R2' U' R2 U R2' U' R2 U2' R U2' R2 U2 R2'",
          "R2 U2 R2' U2' R' U2' R2' U' R2 U2' R U2' R2 U' R2' U R2 U2 R2'",
          "R2 U2 R2' U' R2 U2' R2' U R2 U' R2' U R2 U2' R2' U' R2 U2 R2'",
          "R2 U' R2' U2 R2 U' R2' U R2 U' R2' U2 R2 U R2' U R2 U2 R2'",
          "R2' U R2 U R2' U R2 U' R2' U' R2 U2 R2' U' R2 U R2' U2 R2",
          "R2' U2 R2 U R2' U R2 U2 R2' U' R2 U R2' U' R2 U2 R2' U' R2",
          "R2' U2 R2 U R2' U2 R' U2 R2' U R2 U2 R U2 R2 U R2' U2 R2",
          "R2' U2 R2 U R2' U2' R2 U R2' U R2 U' R2' U' R2 U2 R2' U2 R2",
          "R2' U2 R2 U R2' U' R2 U2 R2' U' R2 U' R2' U R2 U R2' U R2",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          3,
          1,
          4,
          5,
          2,
          3,
          4,
          3,
          1,
          2,
          4,
          5,
          1,
          5,
          2,
        ],
      },
      {
        name: 'K2+',
        scr: [
          "R U2' R2 U' R' U R2 U2' R U R2' U' R U' R2' U2' R' U2 R2",
          "R U2' R2 U' R' U R2 U2' R U R2' U' R' U2 R' U2' R2' U' R'",
          "R2 U R2' U R2 U2 R2' U' R2 U2 R2' U2 R2 U R2' U2' R2 U R2'",
          "R2' U R2 U R2 U' R U2' R U2 R2 U2' R2 U2 R U R U2' R2",
          "R2' U R2 U R2' U2 R2 U' R2' U2 R2 U2 R2' U R2 U2' R2' U R2",
          "R' U' R U2 R' U2' R U2' R' U' R U2' R' U2 R U R' U2' R",
          "R' U' R U2 R' U' R U2 R' U R U2 R' U2' R U R' U2' R",
          "R' U' R U2' R' U2' R2' U R' U' R' U2' R U2' R' U2' R2 U' R2'",
          "R' U R U' R' U' R' U' R2 U2' R2' U2' R U R U R' U2 R",
          "R U2 R U R2' U2 R2 U' R' U R' U2' R U2 R' U' R2 U2' R2'",
          "R2' U2' R2 U R' U2' R' U R2 U R2' U R U R U' R' U R",
          "R2 U2 R U2' R2' U2 R2' U2' R U' R' U2' R2 U2 R2 U2' R' U2 R2'",
          "R2' U R U R U2 R' U2' R' U2 R U2 R' U2 R2 U' R2' U2' R2",
          "R2' U R U2' R' U2' R U2 R U2' R' U' R' U2 R2 U' R2' U2' R2",
          "R2' U2 R' U2' R2 U2 R2 U2' R' U' R U2' R2' U2 R2' U2' R U2 R2",
          "R' U2 R U2 R' U2' R U R' U R2 U R2' U R2 U2' R2' U2 R",
          "R U R' U' R2' U' R2 U R U' R' U' R2' U' R2 U' R2' U2' R2",
          "R U2 R2' U2' R2 U R2' U R2 U R' U R U2' R' U2 R U2 R'",
          "R2 U2 R2' U R2 U2 R' U2 R' U R U2 R2' U2 R U R' U2 R",
          "R2' U2 R2 U R2' U2 R2' U2 R' U R U2 R2' U2 R U R' U2 R",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          5,
          1,
          2,
          3,
          2,
          3,
          4,
          3,
          5,
          1,
          4,
          1,
          2,
          5,
          4,
        ],
      },
      {
        name: 'K2-',
        scr: [
          "R U R' U2 R U2 R2 U' R U R U2 R' U2 R U2 R2' U R2",
          "R U R' U2' R U R' U2' R U' R' U2' R U2 R' U' R U2 R'",
          "R U R' U2' R U2 R' U2 R U R' U2 R U2' R' U' R U2 R'",
          "R2 U' R2' U' R2 U2' R2' U R2 U2' R2' U2' R2 U' R2' U2 R2 U' R2'",
          "R2 U' R2' U' R2' U R' U2 R' U2' R2' U2 R2' U2' R' U' R' U2 R2'",
          "R2' U' R2 U' R2' U2' R2 U R2' U2' R2 U2' R2' U' R2 U2 R2' U' R2",
          "R' U2 R2' U R U' R2' U2 R' U' R2 U R U2' R U2 R2 U R",
          "R' U2 R2' U R U' R2' U2 R' U' R2 U R' U R2 U2 R U2' R2'",
          "R2 U2 R2' U' R U2 R U' R2' U' R2 U' R' U' R' U R U' R'",
          "R' U2' R' U' R2 U2' R2' U R U' R U2 R' U2' R U R2' U2 R2",
          "R U' R' U R U R U R2' U2 R2 U2 R' U' R' U' R U2' R'",
          "R U2' R' U2' R U2 R' U' R U' R2' U' R2 U' R2' U2 R2 U2' R'",
          "R2 U2' R U2 R2' U2' R2' U2 R U R' U2 R2 U2' R2 U2 R' U2' R2'",
          "R2 U' R' U2 R U2 R' U2' R' U2 R U R U2' R2' U R2 U2 R2'",
          "R2 U' R' U' R' U2' R U2 R U2' R' U2' R U2' R2' U R2 U2 R2'",
          "R2' U2' R' U2 R2 U2' R2 U2 R' U R U2 R2' U2' R2' U2 R U2' R2",
          "R U R2 U2 R U2' R U R2 U' R' U2 R2' U' R U R2' U2 R'",
          "R2 U R2' U2 R U2 R' U2 R U R U' R2 U2 R U2 R' U R",
          "R2 U2 R2' U R U2' R' U2 R U' R U R2' U2' R2 U' R' U2' R'",
          "R2 U' R2' U2 R2 U' R2' U2' R2 U2' R2' U R2 U2' R2' U' R2 U' R2'",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          2,
          1,
          4,
          5,
          2,
          5,
          1,
          3,
          2,
          3,
          4,
          3,
          4,
          5,
          1,
        ],
      },
    ],
  },

  {
    cat: 'L',
    cases: [
      {
        name: 'L1',
        scr: [
          "R2 U2' R2' U' R2 U R2' U2' R2 U R2' U2' R2 U2 R2' U R2 U' R2'",
          "R2 U2' R2' U' R2 U R2' U2' R2 U' R2' U2 R2 U2' R2' U2' R2 U' R2'",
          "R2' U2' R2 U' R2' U R2 U2' R2' U R2 U2' R2' U2 R2 U R2' U' R2",
          "R2' U2' R2 U' R2' U R2 U2' R2' U' R2 U2 R2' U2' R2 U2' R2' U' R2",
          "R' U2' R U R' U R U' R U2 R' U' R U R' U R U2 R'",
          "R2' U2' R2 U2' R2' U' R' U2 R2 U2' R U' R2 U R2 U2 R2' U2' R2'",
          "R2 U R U2 R2' U' R2' U R2' U' R' U' R2' U2 R U2 R' U R'",
          "R' U R' U2 R U2 R2' U' R' U' R2' U R2' U' R2' U2 R U R2",
          "R U2 R' U' R U' R' U R' U2' R U R' U' R U' R' U2' R",
          "R2 U2 R2' U R2 U' R2' U2 R2 U R2' U2' R2 U2 R2' U2 R2 U R2'",
          "R2 U2 R2' U R2 U' R2' U2 R2 U' R2' U2 R2 U2' R2' U' R2 U R2'",
          "R2' U2 R2 U R2' U' R2 U2 R2' U R2 U2' R2' U2 R2 U2 R2' U R2",
          "R2' U2 R2 U R2' U' R2 U2 R2' U' R2 U2 R2' U2' R2 U' R2' U R2",
          "R U2' R' U' R U' R' U R U2' R' U R' U' R U' R' U2 R",
          "R U' R U2' R' U2' R2 U R U R2 U' R2 U R2 U2' R' U' R2'",
          "R2 U R2' U2 R2 U2 R2' U2' R2 U R2' U2 R2 U' R2' U R2 U2 R2'",
          "R2 U R2' U' R2 U2' R2' U2 R2 U' R2' U2 R2 U' R2' U R2 U2 R2'",
          "R2 U2 R2 U2' R2' U' R2' U R' U2 R2' U2' R U R2 U2 R2' U2 R2",
          "R2' U R2 U2 R2' U2 R2 U2' R2' U R2 U2 R2' U' R2 U R2' U2 R2",
          "R2' U R2 U' R2' U2' R2 U2 R2' U' R2 U2 R2' U' R2 U R2' U2 R2",
        ],
      },
      {
        name: 'L2',
        scr: [
          "R U' R2' U' R' U' R2 U2' R2 U2 R2 U2' R U2' R U R2 U R'",
          "R2 U2 R2' U R2 U2' R2' U R2 U2' R2' U' R2 U2' R2' U2' R2 U' R2'",
          "R2 U2 R2' U R2 U2' R2' U R2' U2' R2 U' R2' U2' R2 U2' R2 U' R2'",
          "R2' U2 R2 U R2' U2' R2 U R2 U2' R2' U' R2 U2' R2' U2' R2' U' R2",
          "R2' U2 R2 U R2' U2' R2 U R2' U2' R2 U' R2' U2' R2 U2' R2' U' R2",
          "R' U' R2' U' R' U2' R2 U2 R2 U2' R U R U R2 U R2 U R",
          "R U R2 U R2 U R U R U2' R2 U2 R2 U2' R' U' R2' U' R'",
          "R2 U' R2' U2' R2 U2' R2' U' R2 U2' R2' U R2 U2' R2' U R2 U2 R2'",
          "R2 U' R2' U2' R2' U2' R2 U' R2' U2' R2 U R2 U2' R2' U R2 U2 R2'",
          "R2' U' R2 U2' R2 U2' R2' U' R2 U2' R2' U R2' U2' R2 U R2' U2 R2",
          "R2' U' R2 U2' R2' U2' R2 U' R2' U2' R2 U R2' U2' R2 U R2' U2 R2",
          "R' U R2 U R U2' R U2' R2 U2 R2 U2' R2 U' R' U' R2' U' R",
          "R U' R2' U' R' U2 R' U2 R2' U2' R2' U2 R2' U R U R2 U R'",
          "R2 U R2' U2 R2 U2 R2' U R2 U2 R2' U' R2 U2 R2' U' R2 U2' R2'",
          "R2 U R2' U2 R2' U2 R2 U R2' U2 R2 U' R2 U2 R2' U' R2 U2' R2'",
          "R2' U R2 U2 R2 U2 R2' U R2 U2 R2' U' R2' U2 R2 U' R2' U2' R2",
          "R2' U R2 U2 R2' U2 R2 U R2' U2 R2 U' R2' U2 R2 U' R2' U2' R2",
          "R' U' R2' U' R2' U' R' U' R' U2 R2' U2' R2' U2 R U R2 U R",
          "R U R2 U R U2 R2' U2' R2' U2 R' U' R' U' R2' U' R2' U' R'",
          "R U2 R2' U R U' R' U R' U' R' U' R U R' U2' R2 U2' R2",
        ],
      },
      {
        name: 'L3+',
        scr: [
          "R2 U2' R2' U' R2 U2' R2' U R2 U2' R2' U' R2 U R2' U' R2 U2' R2'",
          "R2 U2' R2' U' R2 U2' R2' U R2' U2' R2 U' R2' U R2 U' R2' U2' R2",
          "R2' U2' R2 U' R2' U2' R2 U R2 U2' R2' U' R2 U R2' U' R2 U2' R2'",
          "R2' U2' R2 U' R2' U2' R2 U R2' U2' R2 U' R2' U R2 U' R2' U2' R2",
          "R2 U' R U R U2 R2 U2' R' U' R' U R' U2 R' U2 R2 U R2'",
          "R2 U2 R2' U R2 U' R2' U R2 U2 R2' U' R2 U2 R2' U R2 U2 R2'",
          "R2 U2 R2' U R2 U' R2' U R2 U2 R2' U' R2' U2 R2 U R2' U2 R2",
          "R2 U' R2' U2' R U2' R U' R U R U2 R2' U2' R' U' R' U R2'",
          "R2' U2 R2 U R2' U' R2 U R2' U2 R2 U' R2 U2 R2' U R2 U2 R2'",
          "R2' U2 R2 U R2' U' R2 U R2' U2 R2 U' R2' U2 R2 U R2' U2 R2",
          "R2' U2' R U2 R2 U2' R2' U' R' U R U' R U R U2 R2' U2' R",
          "R2' U2 R2 U2 R' U2 R U2 R' U2' R' U2 R U R U2' R2' U2' R2",
          "R2' U2 R2 U2 R' U' R' U2' R U2 R U2' R' U2' R U2' R2' U2' R2",
          "R' U2 R2 U2' R' U' R' U R' U' R U R2 U2 R2' U2' R' U2 R2",
          "R U R2' U2' R U2 R U2 R U2 R2' U' R2 U' R2 U2 R U R U2' R'",
          "R U2 R U2 R U R U R' U' R' U R' U R' U' R2 U2' R2' U2 R'",
          "R U2 R' U' R' U2' R2' U R2' U R2 U2' R' U2' R' U2' R' U2 R2 U' R'",
          "R U2' R2 U2 R2' U R U' R U' R U R U' R' U' R' U2' R' U2' R'",
          "R2 U2' R U' R2' U2 R2' U2' R2' U2 R' U' R' U2 R2 U2' R U2' R' U' R",
          "R' U R U2 R' U2 R2' U2' R U R U2' R2 U2 R2 U2' R2 U R' U2 R2'",
        ],
      },
      {
        name: 'L3-',
        scr: [
          "R2' U R' U' R' U2' R2' U2 R U R U' R U2' R U2' R2' U' R2",
          "R2 U2 R2' U R2 U2 R2' U' R2 U2 R2' U R2 U' R2' U R2 U2 R2'",
          "R2 U2 R2' U R2 U2 R2' U' R2' U2 R2 U R2' U' R2 U R2' U2 R2",
          "R2' U2 R2 U R2' U2 R2 U' R2 U2 R2' U R2 U' R2' U R2 U2 R2'",
          "R2' U2 R2 U R2' U2 R2 U' R2' U2 R2 U R2' U' R2 U R2' U2 R2",
          "R2 U2' R2' U' R2 U R2' U' R2 U2' R2' U R2 U2' R2' U' R2 U2' R2'",
          "R2 U2' R2' U' R2 U R2' U' R2 U2' R2' U R2' U2' R2 U' R2' U2' R2",
          "R2' U R2 U2 R' U2 R' U R' U' R' U2' R2 U2 R U R U' R2",
          "R2' U2' R2 U' R2' U R2 U' R2' U2' R2 U R2 U2' R2' U' R2 U2' R2'",
          "R2' U2' R2 U' R2' U R2 U' R2' U2' R2 U R2' U2' R2 U' R2' U2' R2",
          "R U2' R2' U2 R U R U' R U R' U' R2' U2' R2 U2 R U2' R2'",
          "R2 U2' R2' U2' R U R U2 R' U2' R' U2 R U2 R' U2 R2 U2 R2'",
          "R2 U2' R2' U2' R U2' R' U2' R U2 R U2' R' U' R' U2 R2 U2 R2'",
          "R2 U2 R' U2' R2' U2 R2 U R U' R' U R' U' R' U2' R2 U2 R'",
          "R U R' U2 R' U' R' U2' R2 U R2' U R2 U' R' U2 R U R U' R'",
          "R U R' U' R' U2 R U R U R2' U R U' R U R' U' R U2' R'",
          "R U R' U' R' U2' R U R2' U' R2 U' R2' U2 R U R U2' R U' R'",
          "R U R' U' R' U2' R' U' R2 U2' R2' U2' R2' U2 R' U' R' U R2 U2 R'",
          "R U2 R' U R U' R' U R' U' R2 U' R' U' R' U2' R U R U' R'",
          "R U2' R U2 R' U' R U' R2 U2' R U' R' U2' R2 U2' R' U2 R U R'",
        ],
      },
      {
        name: 'L4+',
        scr: [
          "R U2' R2 U' R' U2' R2 U R2 U R' U' R2 U2 R2' U2' R2' U' R",
          "R U2' R' U R U2 R U2 R' U R' U' R U' R U' R' U' R'",
          "R2 U R U2 R U2' R' U' R2' U2' R2' U' R' U2' R U2 R U R2",
          "R' U2' R U' R' U2' R2 U2' R' U' R2' U2' R2' U' R2 U2' R2' U2 R'",
          "R' U2' R U' R' U2' R2 U2' R' U' R' U2' R2 U' R2' U2' R2 U2 R'",
          "R' U2' R2 U2 R' U R' U2 R U2 R U2 R' U R' U2 R2 U2' R'",
          "R U' R2' U2' R2' U2 R2 U' R' U R2 U R2 U2' R' U' R2 U2' R",
          "R' U' R' U' R U' R U' R' U R' U2 R U2 R U R' U2' R",
          "R2 U2 R2' U R2 U' R2' U2' R2 U R2' U2' R2 U' R2' U R2 U2 R2'",
          "R2 U' R2 U' R U' R' U' R' U2 R2' U2' R2' U2 R2' U R2' U R2'",
          "R2' U2 R2 U R2' U' R2 U2' R2' U R2 U2' R2' U' R2 U R2' U2 R2",
          "R2' U2 R2' U2 R2' U R U2' R2 U2 R2 U2' R2 U R2 U2' R2 U2' R2",
          "R' U2 R2 U2' R2' U' R2 U2' R' U' R' U2' R2 U2' R' U' R U2' R'",
          "R' U2 R2' U2' R2 U' R2' U2' R2' U' R' U2' R2 U2' R' U' R U2' R'",
          "R' U2' R U2' R' U2' R' U' R U' R' U2 R U2 R U R' U2' R",
          "R' U' R2 U' R2 U R' U2' R2' U2 R2' U2' R2' U R2' U R2' U R",
          "R U R2' U R2' U R2' U2' R2' U2 R2' U2' R' U R2 U' R2 U' R'",
          "R U2' R' U R U2 R U2 R' U' R U' R' U2' R' U2' R U2' R'",
          "R2 U2' R2 U2' R2 U R2 U2' R2 U2 R2 U2' R U R2' U2 R2' U2 R2'",
          "R2' U R2' U R2' U2 R2' U2' R2' U2 R' U' R' U' R U' R2 U' R2",
        ],
      },
      {
        name: 'L4-',
        scr: [
          "R' U2 R U' R' U2' R' U2' R U' R U R' U R' U R U R",
          "R' U2 R2' U R U2 R2' U' R2' U' R U R2' U2' R2 U2 R2 U R'",
          "R2 U' R2 U' R2 U2' R2 U2 R2 U2' R U R U R' U R2' U R2'",
          "R2' U2 R2' U2 R2' U' R2' U2 R2' U2' R2' U2 R' U' R2 U2' R2 U2' R2",
          "R' U2 R U' R' U2' R' U2' R U R' U R U2 R U2 R' U2 R",
          "R' U' R2 U' R2 U' R2 U2 R2 U2' R2 U2 R U' R2' U R2' U R",
          "R U R2' U R2' U' R U2 R2 U2' R2 U2 R2 U' R2 U' R2 U' R'",
          "R U2 R' U2 R U2 R U R' U R U2' R' U2' R' U' R U2 R'",
          "R U2' R2 U2 R2' U R2 U2 R2 U R U2 R2' U2 R U R' U2 R",
          "R U2' R2' U2 R2 U R2' U2 R U R U2 R2' U2 R U R' U2 R",
          "R2 U2' R2 U2' R2 U' R' U2 R2' U2' R2' U2 R2' U' R2' U2 R2' U2 R2'",
          "R2 U2' R2' U' R2 U R2' U2 R2 U' R2' U2 R2 U R2' U' R2 U2' R2'",
          "R2' U R2' U R' U R U R U2' R2 U2 R2 U2' R2 U' R2 U' R2",
          "R2' U2' R2 U' R2' U R2 U2 R2' U' R2 U2 R2' U R2 U' R2' U2' R2",
          "R U R U R' U R' U R U' R U2' R' U2' R' U' R U2 R'",
          "R' U R2 U2 R2 U2' R2' U R U' R2' U' R2' U2 R U R2' U2 R'",
          "R U2 R2' U2' R U' R U2' R' U2' R' U2' R U' R U2' R2' U2 R",
          "R U2 R' U R U2 R2' U2 R U R U2 R2' U R2 U2 R2' U2' R",
          "R U2 R' U R U2 R2' U2 R U R2 U2 R2 U R2' U2 R2 U2' R",
          "R2' U' R' U2' R' U2 R U R2 U2 R2 U R U2 R' U2' R' U' R2'",
        ],
      },
      {
        name: 'L5+',
        scr: [
          "R U R' U2 R U' R' U R U2 R2' U' R U' R' U2 R",
          "R2' U R U R' U' R2 U R2 U2' R2' U' R U2 R' U2' R U2' R2'",
          "R2' U R2' U R U2' R2 U2' R U2 R2 U2' R U' R' U' R2 U' R2",
          "R2' U R2' U R U' R2 U2 R U2' R2 U2 R U' R' U' R2 U' R2",
          "R2 U2 R2' U2' R2 U2' R2 U2' R2' U' R2 U2' R2' U' R2' U2' R2 U2 R2'",
          "R2 U2 R2' U2' R2 U2' R2' U2' R2 U' R2 U2' R2' U' R2 U2' R2' U2 R2'",
          "R2 U2 R2' U2' R2 U2' R2' U2' R2 U' R2' U2' R2 U' R2' U2' R2 U2 R2'",
          "R2 U2' R2' U2 R2 U2 R2 U2 R2' U R2 U2 R2' U R2' U2' R2 U2 R2'",
          "R2 U2' R2' U2 R2 U2 R2' U2 R2 U R2' U2 R2 U R2' U2' R2 U2 R2'",
          "R2' U2 R2 U2' R2' U2' R2 U2' R2' U' R2 U2' R2' U' R2 U2' R2' U2 R2",
          "R2' U2 R2 U2' R2' U2' R2 U2' R2' U' R2' U2' R2 U' R2' U2' R2 U2 R2",
          "R2' U2 R2 U2' R2' U2' R2' U2' R2 U' R2' U2' R2 U' R2 U2' R2' U2 R2",
          "R2' U2' R2 U2 R2' U2 R2 U2 R2' U R2 U2 R2' U R2 U2' R2' U2 R2",
          "R2' U2' R2 U2 R2' U2 R2' U2 R2 U R2' U2 R2 U R2 U2' R2' U2 R2",
          "R2 U2' R2' U2 R2 U R2 U2' R2' U' R2 U2' R2' U' R2' U2' R2 U2 R2'",
          "R2 U2' R2' U2 R2 U R2' U2' R2 U' R2 U2' R2' U' R2 U2' R2' U2 R2'",
          "R2 U2' R2' U2 R2 U R2' U2' R2 U' R2' U2' R2 U' R2' U2' R2 U2 R2'",
          "R2' U2' R2 U2 R2' U R2 U2' R2' U' R2 U2' R2' U' R2 U2' R2' U2 R2",
          "R2' U2' R2 U2 R2' U R2 U2' R2' U' R2' U2' R2 U' R2' U2' R2 U2 R2",
          "R2' U2' R2 U2 R2' U R2' U2' R2 U' R2' U2' R2 U' R2 U2' R2' U2 R2",
        ],
      },
      {
        name: 'L5-',
        scr: [
          "R' U' R U2' R' U R U' R' U2' R2 U R' U R U2' R'",
          "R2 U' R2 U' R' U R2' U2' R' U2 R2' U2' R' U R U R2' U R2'",
          "R2 U' R2 U' R' U2 R2' U2 R' U2' R2' U2 R' U R U R2' U R2'",
          "R2 U' R' U' R U R2' U' R2' U2 R2 U R' U2' R U2 R' U2 R2",
          "R2 U2' R2' U2 R2 U R2 U2' R2' U' R2 U2' R2' U' R2' U2 R2 U2' R2'",
          "R2 U2' R2' U2 R2 U R2' U2' R2 U' R2' U2' R2 U' R2' U2 R2 U2' R2'",
          "R2' U2' R2 U2 R2' U R2 U2' R2' U' R2 U2' R2' U' R2 U2 R2' U2' R2",
          "R2' U2' R2 U2 R2' U R2' U2' R2 U' R2' U2' R2 U' R2 U2 R2' U2' R2",
          "R' U2' R U' R U R2' U2 R U2' R U' R U2 R2' U R2 U2 R2'",
          "R' U2' R U' R U R2' U2 R U2' R U' R2 U2 R2 U R2' U2 R2",
          "R2 U2 R2' U2' R2 U' R2 U2 R2' U R2 U2 R2' U R2' U2 R2 U2' R2'",
          "R2 U2 R2' U2' R2 U' R2' U2 R2 U R2 U2 R2' U R2 U2 R2' U2' R2'",
          "R2 U2 R2' U2' R2 U' R2' U2 R2 U R2' U2 R2 U R2' U2 R2 U2' R2'",
          "R2' U2 R2 U2' R2' U' R2 U2 R2' U R2 U2 R2' U R2 U2 R2' U2' R2",
          "R2' U2 R2 U2' R2' U' R2 U2 R2' U R2' U2 R2 U R2' U2 R2 U2' R2",
          "R2' U2 R2 U2' R2' U' R2' U2 R2 U R2' U2 R2 U R2 U2 R2' U2' R2",
          "R2 U2 R2' U2' R2 U2' R2 U2' R2' U' R2 U2' R2' U' R2' U2 R2 U2' R2'",
          "R2 U2 R2' U2' R2 U2' R2' U2' R2 U' R2' U2' R2 U' R2' U2 R2 U2' R2'",
          "R2 U2' R2' U2 R2 U2 R2 U2 R2' U R2 U2 R2' U R2' U2 R2 U2' R2'",
          "R2 U2' R2' U2 R2 U2 R2' U2 R2 U R2 U2 R2' U R2 U2 R2' U2' R2'",
        ],
      },
      {
        name: 'L6+',
        scr: [
          "R' U2' R U R' U R2 U2' R' U' R U R' U2' R U' R'",
          "R2 U2 R2' U R2 U2 R2 U' R U2' R U2 R2' U R U' R U2' R'",
          "R2 U2 R' U2 R U2' R' U R2 U2 R2' U' R2' U R U' R' U' R2",
          "R2 U2' R2 U2 R2' U R2 U2 R2' U R2' U2 R2 U2 R2' U2 R2 U2' R2'",
          "R2 U2' R2 U2 R2' U R2 U2 R2' U R2' U2 R2 U' R2' U2' R2 U2 R2'",
          "R2 U2' R2' U2 R2 U R2 U2 R2' U R2 U2 R2' U2 R2' U2 R2 U2' R2'",
          "R2 U2' R2' U2 R2 U R2 U2 R2' U R2 U2 R2' U' R2' U2' R2 U2 R2'",
          "R2 U2' R2' U2 R2 U R2' U2 R2 U R2' U2 R2 U2 R2' U2 R2 U2' R2'",
          "R2 U2' R2' U2 R2 U R2' U2 R2 U R2' U2 R2 U' R2' U2' R2 U2 R2'",
          "R2 U2' R2' U2 R2 U' R2 U2' R2' U' R2 U2' R2' U R2' U2 R2 U2' R2'",
          "R2 U2' R2' U2 R2 U' R2 U2' R2' U' R2 U2' R2' U2' R2' U2' R2 U2 R2'",
          "R2 U2' R2' U2 R2 U' R2' U2' R2 U' R2' U2' R2 U R2' U2 R2 U2' R2'",
          "R2 U2' R2' U2 R2 U' R2' U2' R2 U' R2' U2' R2 U2' R2' U2' R2 U2 R2'",
          "R2' U R2' U R U R' U2 R2' U2' R' U2 R2' U2 R' U' R2 U' R2",
          "R2' U R2' U R U R' U2' R2' U2 R' U2' R2' U R' U' R2 U' R2",
          "R2' U2 R2 U R2' U2 R U' R U2' R U2 R2' U R U' R U2' R'",
          "R2' U2' R2 U2 R2' U R2 U2 R2' U R2 U2 R2' U2 R2 U2 R2' U2' R2",
          "R2' U2' R2 U2 R2' U R2 U2 R2' U R2 U2 R2' U' R2 U2' R2' U2 R2",
          "R2' U2' R2 U2 R2' U R2' U2 R2 U R2' U2 R2 U2 R2 U2 R2' U2' R2",
          "R2' U2' R2 U2 R2' U R2' U2 R2 U R2' U2 R2 U' R2 U2' R2' U2 R2",
        ],
      },
      {
        name: 'L6-',
        scr: [
          "R U2 R' U' R U' R2' U2 R U R' U' R U2 R' U R",
          "R2 U2' R2' U2 R2 U2 R2 U2' R2' U' R2 U2' R2' U R2' U2 R2 U2' R2'",
          "R2 U2' R2' U2 R2 U2 R2 U2' R2' U' R2 U2' R2' U2' R2' U2' R2 U2 R2'",
          "R2 U2' R2' U2 R2 U2 R2' U2' R2 U' R2' U2' R2 U R2' U2 R2 U2' R2'",
          "R2 U2' R2' U2 R2 U2 R2' U2' R2 U' R2' U2' R2 U2' R2' U2' R2 U2 R2'",
          "R2 U2' R2' U2 R2 U' R2 U2 R2' U R2 U2 R2' U2 R2' U2 R2 U2' R2'",
          "R2 U2' R2' U2 R2 U' R2 U2 R2' U R2 U2 R2' U' R2' U2' R2 U2 R2'",
          "R2 U2' R2' U2 R2 U' R2' U2 R2 U R2' U2 R2 U2 R2' U2 R2 U2' R2'",
          "R2 U2' R2' U2 R2 U' R2' U2 R2 U R2' U2 R2 U' R2' U2' R2 U2 R2'",
          "R2 U2' R2' U' R2 U2' R2' U2 R2 U2 R2' U2' R2 U R2' U2 R2 U2' R2'",
          "R2 U2' R2' U' R2 U2' R2' U2 R2 U2 R2' U2' R2 U2' R2' U2' R2 U2 R2'",
          "R2 U2' R2' U' R2 U2' R2' U2 R2' U2 R2 U2' R2' U R2 U2 R2' U2' R2",
          "R2 U2' R2' U' R2 U2' R2' U2 R2' U2 R2 U2' R2' U2' R2 U2' R2' U2 R2",
          "R2 U2' R2' U' R2 U2' R2' U' R2 U2' R2' U2 R2 U R2' U2' R2 U2 R2'",
          "R2 U2' R2' U' R2 U2' R2' U' R2 U2' R2' U2 R2 U' R2' U2 R2 U2' R2'",
          "R2 U2' R2' U' R2 U2' R2' U' R2' U2' R2 U2 R2' U R2 U2' R2' U2 R2",
          "R2 U2' R2' U' R2 U2' R2' U' R2' U2' R2 U2 R2' U' R2 U2 R2' U2' R2",
          "R2 U2' R2' U' R2' U2' R2 U' R2' U2' R2 U2 R2 U R2' U2' R2 U2 R2'",
          "R2 U2' R2' U' R2' U2' R2 U' R2' U2' R2 U2 R2 U' R2' U2 R2 U2' R2'",
          "R2 U2' R2' U' R' U2' R U' R2 U2' R2' U2' R2 U2' R2 U2 R2' U2' R2'",
        ],
      },
    ],
  }, //B

  {
    cat: 'M',
    cases: [
      {
        name: 'M',
        scr: [
          "R2 U R2 U' R2 U' R2' U2 R U R U2' R U' R2'",
          "R U2' R U R U2 R2' U' R2 U' R2 U R2 U2' R2'",
          "R2' U2' R2 U R2 U' R2 U' R2' U2 R U R U2' R",
          "R2' U' R U2' R U R U2 R2' U' R2 U' R2 U R2",
          "R2 U R' U2 R' U' R' U2' R2 U R2' U R2' U' R2'",
          "R2 U2 R2' U' R2' U R2' U R2 U2' R' U' R' U2 R'",
          "R' U2 R' U' R' U2' R2 U R2' U R2' U' R2' U2 R2",
          "R2' U' R2' U R2' U R2 U2' R' U' R' U2 R' U R2",
          "R U2' R2 U R2 U' R2 U' R2' U2 R U R U2' R U' R2",
          "R U' R U2' R U R U2 R2' U' R2 U' R2 U R2 U2' R2",
          "R2 U2' R2 U R2 U' R2 U' R2' U2 R U R U2' R U' R",
          "R2 U' R U2' R U R U2 R2' U' R2 U' R2 U R2 U2' R",
          "R' U2' R2 U R2 U' R2 U' R2' U2 R U R U2' R U' R'",
          "R' U' R U2' R U R U2 R2' U' R2 U' R2 U R2 U2' R'",
          "R U R' U2 R' U' R' U2' R2 U R2' U R2' U' R2' U2 R",
          "R U2 R2' U' R2' U R2' U R2 U2' R' U' R' U2 R'",
          "R2' U R' U2 R' U' R' U2' R2 U R2' U R2' U' R2' U2 R'",
          "R2' U2 R2' U' R2' U R2' U R2 U2' R' U' R' U2 R' U R'",
          "R' U R' U2 R' U' R' U2' R2 U R2' U R2' U' R2' U2 R2'",
          "R' U2 R2' U' R2' U R2' U R2 U2' R' U' R' U2 R' U R2'",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          1,
          2,
          5,
          3,
          4,
          4,
          4,
          5,
          3,
          2,
          3,
          2,
          5,
        ],
      },
    ],
  }, //A
  {
    cat: 'N',
    cases: [
      {
        name: 'N1+',
        scr: [
          "R U2 R U2' R' U2 R' U2 R U2' R U2 R' U2' R'",
          "R U2 R U2' R' U' R2' U R2' U2 R' U2' R2' U' R",
          "R U2' R U2 R' U R2' U' R2' U2' R' U2 R2'",
          "R U2' R U2 R' U2' R' U2' R U2 R U2' R' U2 R'",
          "R2 U R2' U R2 U2' R2 U2 R2' U R2 U2 R2' U2 R2'",
          "R2 U R2' U R2 U2' R2' U2 R2 U R2' U2 R2 U2 R2'",
          "R2 U R2' U' R2 U2 R2' U R2 U2 R2' U2' R2 U' R2'",
          "R2 U R2' U' R2 U2 R2' U2' R2 U2' R2' U2 R2 U2 R2'",
          "R2 U R2' U' R2' U2 R2 U R2' U2 R2 U2' R2 U' R2'",
          "R2' U R2 U R2' U2' R2 U2 R2' U R2 U2 R2' U2 R2",
          "R2' U R2 U R2' U2' R2' U2 R2 U R2' U2 R2 U2 R2",
          "R2' U R2 U' R2 U2 R2' U R2 U2 R2' U2' R2' U' R2",
          "R2' U R2 U' R2' U2 R2 U R2' U2 R2 U2' R2' U' R2",
          "R2' U R2 U' R2' U2 R2 U2' R2' U2' R2 U2 R2' U2 R2",
          "R' U R2 U2 R U2' R2 U' R2 U R U2 R' U2' R'",
          "R' U' R2 U2' R U2 R2 U R2 U' R U2' R' U2 R'",
          "R2 U R2' U2 R2 U2' R2' U' R2 U2' R2' U R2 U' R2'",
          "R2 U R2' U2 R2' U2' R2 U' R2' U2' R2 U R2 U' R2'",
          "R2 U2' R2 U2' R2' U' R2 U2' R2' U2 R2' U' R2 U' R2'",
          "R2 U2' R2' U2' R2 U2 R2' U2 R2 U2' R2' U R2 U' R2'",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          4,
          1,
          1,
          2,
          5,
          5,
          1,
          2,
          2,
          3,
          4,
          4,
          5,
          3,
          3,
        ],
      },
      {
        name: 'N1-',
        scr: [
          "R U R2' U2 R' U2' R2' U' R2' U R' U2 R U2' R",
          "R U' R2' U2' R' U2 R2' U R2' U' R' U2' R U2 R",
          "R2 U' R2' U R2 U2' R2' U2 R2 U2 R2' U2' R2 U2' R2'",
          "R2 U' R2' U R2 U2' R2' U' R2 U2' R2' U2 R2 U R2'",
          "R2 U' R2' U R2' U2' R2 U' R2' U2' R2 U2 R2 U R2'",
          "R2 U' R2' U' R2 U2 R2 U2' R2' U' R2 U2' R2' U2' R2'",
          "R2 U' R2' U' R2 U2 R2' U2' R2 U' R2' U2' R2 U2' R2'",
          "R2' U' R2 U R2 U2' R2' U' R2 U2' R2' U2 R2' U R2",
          "R2' U' R2 U R2' U2' R2 U2 R2' U2 R2 U2' R2' U2' R2",
          "R2' U' R2 U R2' U2' R2 U' R2' U2' R2 U2 R2' U R2",
          "R2' U' R2 U' R2' U2 R2 U2' R2' U' R2 U2' R2' U2' R2",
          "R2' U' R2 U' R2' U2 R2' U2' R2 U' R2' U2' R2 U2' R2",
          "R' U2 R' U2' R U2 R U2 R' U2' R' U2 R U2' R",
          "R' U2 R' U2' R U' R2 U R2 U2 R U2' R2 U' R'",
          "R' U2' R' U2 R U R2 U' R2 U2' R U2 R2 U R'",
          "R' U2' R' U2 R U2' R U2' R' U2 R' U2' R U2 R",
          "R2 U' R2 U' R U R2 U' R2' U' R' U R2' U2 R2'",
          "R2' U2' R' U2 R2 U2' R U' R' U2' R2' U2 R U2' R2",
          "R' U2' R U R2 U' R2' U' R' U R2' U R2 U R",
          "R' U2' R' U2 R U2' R U2 R' U2 R' U2' R U2 R",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          4,
          5,
          5,
          2,
          3,
          3,
          1,
          2,
          2,
          3,
          4,
          4,
          5,
        ],
      },
      {
        name: 'N2+',
        scr: [
          "R2' U2 R U2' R2 U2' R2' U2 R' U2' R U R2 U' R2' U' R",
          "R' U R2 U R2' U' R' U2 R U2' R2 U2 R2' U2 R' U2' R2",
          "R' U2' R2 U R2' U2 R U2' R U2 R' U2' R U' R2' U2 R",
          "R' U2' R2 U R' U2 R U2' R' U2 R' U2' R2 U' R2' U2 R",
          "R2 U2 R2' U' R2 U' R U R' U R2' U R2 U2' R U' R2",
          "R2' U R' U2 R2' U' R2 U' R U' R' U R2' U R2 U2' R2'",
          "R U2' R U2 R2' U2' R2 U R2' U R2 U' R2' U2 R U2 R'",
          "R U2' R U2 R2' U' R2 U R2' U' R2 U' R2' U2' R U2 R'",
          "R U2' R' U2 R2 U R2' U R2 U' R2' U R2 U2' R' U2 R'",
          "R U2' R' U2' R2 U R2' U' R2 U' R2' U2 R2 U2' R' U2 R'",
          "R U2' R U2 R2' U2' R2 U R2' U R2 U' R2' U2 R U2 R'",
          "R U2' R U2 R2' U' R2 U R2' U' R2 U' R2' U2' R U2 R'",
          "R U2' R' U2 R2 U R2' U R2 U' R2' U R2 U2' R' U2 R'",
          "R U2' R' U2' R2 U R2' U' R2 U' R2' U2 R2 U2' R' U2 R'",
          "R2 U2 R2' U' R2 U' R U R' U R2' U R2 U2' R U' R2",
          "R2' U R' U2 R2' U' R2 U' R U' R' U R2' U R2 U2' R2'",
          "R' U2' R2 U R2' U2 R U2' R U2 R' U2' R U' R2' U2 R",
          "R' U2' R2 U R' U2 R U2' R' U2 R' U2' R2 U' R2' U2 R",
          "R U2' R U2 R2' U2' R2 U R2' U R2 U' R2' U2 R U2 R'",
          "R U2' R U2 R2' U' R2 U R2' U' R2 U' R2' U2' R U2 R'",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          3,
          1,
          1,
          2,
          5,
          5,
          1,
          4,
          4,
          5,
          3,
          3,
          4,
          2,
          2,
        ],
      },
      {
        name: 'N2-',
        scr: [
          "R U' R2' U' R2 U R U2' R' U2 R2' U2' R2 U2' R U2 R2'",
          "R2 U2' R' U2 R2' U2 R2 U2' R U2 R' U' R2' U R2 U R'",
          "R' U2 R U2 R2' U' R2 U R2' U R2 U2' R2' U2 R U2' R",
          "R' U2 R U2' R2' U' R2 U' R2' U R2 U' R2' U2 R U2' R",
          "R' U2 R' U2' R2 U R2' U' R2 U R2' U R2 U2 R' U2' R",
          "R' U2 R' U2' R2 U2 R2' U' R2 U' R2' U R2 U2' R' U2' R",
          "R2 U' R U2' R2 U R2' U R' U R U' R2 U' R2' U2 R2",
          "R2' U2' R2 U R2' U R' U' R U' R2 U' R2' U2 R' U R2'",
          "R U2 R2' U' R U2' R' U2 R U2' R U2 R2' U R2 U2' R'",
          "R U2 R2' U' R2 U2' R' U2 R' U2' R U2 R' U R2 U2' R'",
          "R U2 R2' U' R U2' R' U2 R U2' R U2 R2' U R2 U2' R'",
          "R U2 R2' U' R2 U2' R' U2 R' U2' R U2 R' U R2 U2' R'",
          "R2 U' R U2' R2 U R2' U R' U R U' R2 U' R2' U2 R2",
          "R2' U2' R2 U R2' U R' U' R U' R2 U' R2' U2 R' U R2'",
          "R' U2 R U2 R2' U' R2 U R2' U R2 U2' R2' U2 R U2' R",
          "R' U2 R U2' R2' U' R2 U' R2' U R2 U' R2' U2 R U2' R",
          "R' U2 R' U2' R2 U R2' U' R2 U R2' U R2 U2 R' U2' R",
          "R' U2 R' U2' R2 U2 R2' U' R2 U' R2' U R2 U2' R' U2' R",
          "R U2 R2' U' R U2' R' U2 R U2' R U2 R2' U R2 U2' R'",
          "R U2 R2' U' R2 U2' R' U2 R' U2' R U2 R' U R2 U2' R'",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          4,
          5,
          5,
          3,
          4,
          4,
          2,
          3,
          3,
          1,
          2,
          2,
          5,
        ],
      },
    ],
  },
  {
    cat: 'P',
    cases: [
      {
        name: 'P1+',
        scr: [
          "R' U2' R U' R' U2 R U2' R' U2' R2 U R' U2 R U2 R'",
          "R U R' U R U R' U2 R' U2 R U2 R' U R U2' R U' R'",
          "R2' U2 R2' U R2 U R2' U2' R' U2' R U2' R' U' R2' U R2' U2 R'",
          "R U2' R' U2 R2' U' R U2' R2' U R U' R2 U2 R' U R2' U2 R'",
          "R U R' U2 R U2 R' U2 R' U2 R U2 R' U' R U R'",
          "R2 U R U2 R U' R2 U' R' U2' R' U R' U2 R2' U R' U' R2",
          "R2 U R2' U2 R2 U' R' U R U2 R2' U' R U' R' U R U2' R'",
          "R2 U2 R2 U R U' R2 U2' R2 U2 R U R' U2 R U' R' U2' R",
          "R2 U2 R2' U R2 U2 R' U R' U2 R' U2' R2 U' R' U R' U2 R",
          "R2 U2' R' U' R U2' R2' U R U' R U2 R' U' R U' R' U2' R'",
          "R2' U2 R2 U R2' U2 R2' U R' U2 R' U2' R2 U' R' U R' U2 R",
          "R U' R2' U2' R U R U2' R' U R' U2 R2' U2 R' U' R U' R2'",
          "R U' R' U2 R2 U R2' U' R2 U2 R2' U R U R' U R2 U2 R2'",
          "R2 U2' R U2' R' U2 R' U' R2' U2' R2' U2 R2 U R2 U2 R' U2 R2'",
          "R2 U' R2' U2 R2 U R2' U2' R2 U2' R2' U R2 U2' R2' U2 R2 U' R2'",
          "R2 U' R2' U2 R2 U R2' U2' R2 U2' R2' U' R2 U2 R2' U2' R2 U R2'",
          "R2 U' R2' U2' R2 U' R2' U2 R2 U2 R2' U' R2 U' R2' U2 R2 U' R2'",
          "R2' U' R2 U2 R2' U R2 U2' R2' U2' R2 U R2' U2' R2 U2 R2' U' R2",
          "R2' U' R2 U2 R2' U R2 U2' R2' U2' R2 U' R2' U2 R2 U2' R2' U R2",
          "R2' U' R2 U2' R2' U' R2 U2 R2' U2 R2 U' R2' U' R2 U2 R2' U' R2",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          5,
          1,
          1,
          2,
          3,
          2,
          3,
          4,
          5,
          1,
          2,
          3,
          4,
          5,
          4,
        ],
      },
      {
        name: 'P1-',
        scr: [
          "R U2 R' U R U2' R' U2 R U2 R2' U' R U2' R' U2' R",
          "R' U' R U' R' U' R U2' R U2' R' U2' R U' R' U2 R'",
          "R' U2 R U2' R2 U R' U2 R2 U' R' U R2' U2' R U' R2 U2' R",
          "R2 U2' R2 U' R2' U' R2 U2 R U2 R' U2 R U R2 U' R2 U2' R",
          "R' U R2 U2 R2 U' R2 U2 R2 U2' R2 U2 R U' R2' U2' R2' U' R",
          "R' U R2' U R U2 R2 U2' R U R U R U2' R U' R2 U' R",
          "R U2 R U2' R2' U' R U R2' U2' R U R2 U2' R2 U2' R2 U' R'",
          "R2 U R2' U2 R2 U R2' U2' R2 U2' R2' U R2 U R2' U2' R2 U R2'",
          "R2 U R2' U2' R2 U' R2' U2 R2 U2 R2' U R2 U2' R2' U2 R2 U' R2'",
          "R2 U R2' U2' R2 U' R2' U2 R2 U2 R2' U' R2 U2 R2' U2' R2 U R2'",
          "R2' U R2 U2 R2' U R2 U2' R2' U2' R2 U R2' U R2 U2' R2' U R2",
          "R2' U R2 U2' R2' U' R2 U2 R2' U2 R2 U R2' U2' R2 U2 R2' U' R2",
          "R2' U R2 U2' R2' U' R2 U2 R2' U2 R2 U' R2' U2 R2 U2' R2' U R2",
          "R2' U2 R' U2 R U2' R U R2 U2 R2 U2' R2' U' R2' U2' R U2' R2",
          "R' U R U2' R2' U' R2 U R2' U2' R2 U' R' U' R U' R2' U2' R2",
          "R' U R2 U2 R' U' R' U2 R U' R U2' R2 U2' R U R' U R2",
          "R2 U2' R2' U' R2 U2' R2 U' R U2' R U2 R2' U R U' R U2' R'",
          "R2' U2 R U R' U2 R2 U' R' U R' U2' R U R' U R U2 R",
          "R2' U2' R2 U' R2' U2' R U' R U2' R U2 R2' U R U' R U2' R'",
          "R2' U2' R2' U' R' U R2' U2 R2' U2' R' U' R U2' R' U R U2 R'",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          2,
          3,
          2,
          3,
          4,
          5,
          1,
          2,
          3,
          4,
          5,
          4,
          5,
        ],
      },
      {
        name: 'P2+',
        scr: [
          "R U2' R' U2' R U' R2' U2 R U2 R' U2' R U R' U2 R",
          "R U R' U2 R' U' R U2' R' U2' R U2' R U' R' U' R U' R'",
          "R U2' R2 U' R U2' R2' U R' U' R2 U2 R' U R2 U2' R U2 R'",
          "R U2' R2 U' R2 U R U2 R' U2 R U2 R2 U' R2' U' R2 U2' R2",
          "R U2 R U R' U R U2' R' U R' U' R2 U2 R' U R U2 R2'",
          "R U2 R' U' R U R' U R2 U2' R' U' R U R2' U2' R2 U' R2'",
          "R2 U R' U R U2' R2 U2' R U' R U2 R' U' R' U2 R2 U R'",
          "R2' U R U' R2 U2' R U' R U2 R U R2' U R' U2' R' U' R2'",
          "R' U2' R U' R U R2' U2 R U2' R U' R U2' R2' U' R2 U2' R2'",
          "R' U2' R U' R U R2' U2 R U2' R U' R2 U2' R2 U' R2' U2' R2",
          "R2 U R2' U2' R2 U R2' U R2 U2' R2' U2' R2 U R2' U2 R2 U R2'",
          "R2 U R2' U2' R2 U2 R2' U' R2 U2 R2' U2 R2 U' R2' U2' R2 U R2'",
          "R2 U' R2' U2 R2 U2' R2' U R2 U2 R2' U2 R2 U' R2' U2' R2 U R2'",
          "R2' U R2 U2' R2' U R2 U R2' U2' R2 U2' R2' U R2 U2 R2' U R2",
          "R2' U R2 U2' R2' U2 R2 U' R2' U2 R2 U2 R2' U' R2 U2' R2' U R2",
          "R2' U' R2 U2 R2' U2' R2 U R2' U2 R2 U2 R2' U' R2 U2' R2' U R2",
          "R' U2 R U R' U2' R U' R' U2' R2' U2 R2' U R' U' R2' U2' R2'",
          "R' U' R2 U2' R2 U2' R2 U R U2' R2' U R U' R2' U2' R U2 R",
          "R U' R2 U' R U2' R U R U R U2' R2 U2 R U R2' U R'",
          "R U' R2' U2' R2' U' R U2 R2 U2' R2 U2 R2 U' R2 U2 R2 U R'",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          4,
          1,
          1,
          2,
          4,
          2,
          3,
          2,
          4,
          5,
          3,
          5,
          1,
          5,
          3,
        ],
      },
      {
        name: 'P2-',
        scr: [
          "R' U2 R U2 R' U R2 U2' R' U2' R U2 R' U' R U2' R'",
          "R' U' R U2' R U R' U2 R U2 R' U2 R' U R U R'",
          "R' U2 R2' U R2' U' R' U2' R U2' R' U2' R2' U R2 U R2' U2 R2'",
          "R' U2 R2' U R' U2 R2 U' R U R2' U2' R U' R2' U2 R' U2' R",
          "R U R' U R U' R' U2 R U2 R' U2 R' U2 R U2 R'",
          "R2' U2 R2 U R' U R U R2' U2 R2 U' R2' U R2 U2 R' U' R",
          "R2' U2 R' U2 R2 U R2 U2 R2' U2' R2' U' R' U2 R' U2' R U2' R2",
          "R' U R2 U2 R2 U R' U2' R2' U2 R2' U2' R2' U R2' U2' R2' U' R",
          "R' U R2' U R' U2 R' U' R' U' R' U2 R2' U2' R' U' R2 U' R",
          "R U R2' U2 R2' U2 R2' U' R' U2 R2 U' R' U R2 U2 R' U2' R'",
          "R U2' R' U' R U2 R' U R U2 R2 U2' R2 U' R U R2 U2 R2",
          "R2 U R2' U2' R2 U2 R2' U' R2 U2' R2' U2' R2 U R2' U2 R2 U' R2'",
          "R2 U' R2' U2 R2 U2' R2' U R2 U2' R2' U2' R2 U R2' U2 R2 U' R2'",
          "R2 U' R2' U2 R2 U' R2' U' R2 U2 R2' U2 R2 U' R2' U2' R2 U' R2'",
          "R2' U R2 U2' R2' U2 R2 U' R2' U2' R2 U2' R2' U R2 U2 R2' U' R2",
          "R2' U' R2 U2 R2' U2' R2 U R2' U2' R2 U2' R2' U R2 U2 R2' U' R2",
          "R2' U' R2 U2 R2' U' R2 U' R2' U2 R2 U2 R2' U' R2 U2' R2' U' R2",
          "R U2 R' U R' U' R2 U2' R' U2 R' U R2' U2 R2' U R2 U2 R2'",
          "R U2 R' U R' U' R2 U2' R' U2 R' U R' U2 R2 U R2' U2 R2",
          "R2 U' R' U R2' U2 R' U R' U2' R' U' R2 U' R U2 R U R2",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          4,
          1,
          5,
          1,
          4,
          1,
          2,
          2,
          4,
          5,
          3,
          2,
          3,
          5,
          3,
        ],
      },
      {
        name: 'P3+',
        scr: [
          "R' U2' R' U' R2 U2' R2' U R U' R U2 R' U2' R' U2' R2",
          "R U2' R' U2 R U R2' U' R2 U' R2' U2 R U2 R U2' R'",
          "R2' U2' R2 U R2' U R U2' R U R U2 R2' U' R2 U' R'",
          "R U R' U2 R U2 R' U2' R U2' R2' U2 R2 U2 R2' U R2 U' R'",
          "R2 U R U R' U R' U' R2 U' R' U R' U R' U' R2 U2' R2'",
          "R2' U R U R' U R' U' R2 U' R' U R' U R2' U' R2' U2' R2",
          "R U R' U R U R' U2' R U' R2' U2 R2 U2 R2' U R2 U2 R'",
          "R U R' U R U R' U2' R U' R2' U2 R2' U2 R2 U R2' U2 R2'",
          "R U R U' R2' U2' R2 U R U R' U R2' U' R2' U' R2' U' R'",
          "R U2' R' U2 R U2 R' U2 R U2' R U2' R' U2' R U' R' U2' R'",
          "R2' U' R2 U2' R' U2' R U' R U R U2 R2' U2' R' U' R2 U R2",
          "R' U2' R2' U R U' R2' U' R2 U R2 U R U' R2' U' R2 U2' R",
          "R' U2 R2 U2 R' U' R2 U R' U R U2' R' U2 R2' U2' R2 U' R'",
          "R' U' R U' R U R2' U R U2' R' U2' R U R U' R2' U2 R",
          "R U R' U2 R' U2' R2 U' R' U R' U2 R2' U2 R2' U R2 U2 R2'",
          "R U R' U2 R' U2' R2 U' R' U R' U2 R' U2 R2 U R2' U2 R2",
          "R U2' R2 U2' R' U' R2 U R2 U R2' U2' R2' U2 R' U2' R2 U2' R2",
          "R U2' R2' U' R U2' R2 U2 R2 U' R2' U' R2' U R U' R2' U2' R",
          "R U2' R2' U' R2' U2 R' U' R' U R U R U2 R2' U R'",
          "R2 U2 R2' U2' R2 U R2' U R2 U2 R2' U2 R2 U2' R2' U R2 U' R2'",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          3,
          1,
          5,
          1,
          5,
          1,
          2,
          3,
          3,
          4,
          2,
          4,
          5,
          4,
          2,
        ],
      },
      {
        name: 'P3-',
        scr: [
          "R U2 R U R2' U2 R2 U' R' U R' U2' R U2 R U2 R2'",
          "R2 U2 R2' U' R2 U' R' U2 R' U' R' U2' R2 U R2'",
          "R' U2 R U2' R' U' R2 U R2' U R2 U2' R' U2' R' U2 R",
          "R2 U' R' U' R U' R U R2' U R U' R U' R2 U R2 U2 R2'",
          "R2' U' R' U' R U' R U R2' U R U' R U' R U R2' U2 R2",
          "R' U' R U2' R' U2' R U2 R' U2 R2 U2' R2' U2' R2 U' R2'",
          "R U R' U R' U' R2 U' R' U2 R U2 R' U' R' U R2 U2' R'",
          "R U2' R2' U2' R U R2' U' R U' R' U2 R U2' R2 U2 R2'",
          "R U2 R2 U' R' U R2 U R2' U' R2' U' R' U R2 U R2' U2 R'",
          "R2 U R2' U2 R U2 R' U R' U' R' U2' R2 U2 R U R2' U' R2'",
          "R' U2 R U2' R' U2' R U2' R' U2 R' U2 R U2 R' U R U2 R",
          "R' U' R' U R2 U2 R2' U' R' U' R U' R2 U R2 U R2",
          "R' U' R U' R' U' R U2 R' U R2 U2' R2 U2' R2' U' R2 U2' R2",
          "R' U' R U' R' U' R U2 R' U R2 U2' R2' U2' R2 U' R2' U2' R",
          "R U2 R2 U R2 U R U R2 U R2' U' R' U2' R U2' R2 U R2",
          "R2 U2' R2' U R2 U' R2' U R2 U R2' U R2 U2' R2' U R2 U R2'",
          "R2 U2' R2' U2 R2 U R2' U2' R' U' R U R2 U2 R2' U' R'",
          "R2 U2' R2' U2 R2 U' R2' U' R2 U R2' U2 R2 U2' R2' U R2 U R2'",
          "R2 U2' R2' U2 R2 U' R2' U' R2 U2' R2' U2' R2 U2 R2' U' R2 U R2'",
          "R2' U2' R2 U R2' U' R2 U R2' U R2 U R2' U2' R2 U R2' U R2",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          2,
          3,
          4,
          3,
          4,
          3,
          1,
          2,
          5,
          4,
          5,
          2,
          5,
        ],
      },
      {
        name: 'P4+',
        scr: [
          "R2' U2 R U2 R U2' R' U R' U' R2 U2 R2' U R U2 R",
          "R U2 R' U2' R' U2' R2 U R2' U R2 U' R' U2' R U2 R'",
          "R U R2' U R2 U2' R' U' R' U2 R' U' R2 U' R2' U2 R2",
          "R U R2' U' R2 U2' R2' U2' R2 U2 R' U2 R U2' R' U2' R U' R'",
          "R2 U2 R2' U R U' R U' R U R2' U R U' R U' R' U' R2'",
          "R2' U2 R2 U R2 U' R U' R U R2' U R U' R U' R' U' R2",
          "R U R' U R2 U2' R2' U2 R2 U' R2' U2 R U' R' U R2 U2' R2'",
          "R U R' U' R2 U2 R2' U2' R2 U R2' U2 R U' R' U R2 U2' R2'",
          "R U R' U' R2' U2 R2 U R U' R' U2' R2' U R2 U2 R2' U2' R2",
          "R2 U R2' U R2 U2' R2' U R2 U R2' U R2 U' R2' U R2 U2' R2'",
          "R2 U R2' U R2 U2' R2' U2 R2 U R2' U' R2 U' R2' U2 R2 U2' R2'",
          "R2 U R2' U' R2 U2 R2' U2' R2 U2' R2' U' R2 U' R2' U2 R2 U2' R2'",
          "R2' U R2 U R2' U2' R2 U R2' U R2 U R2' U' R2 U R2' U2' R2",
          "R2' U R2 U R2' U2' R2 U2 R2' U R2 U' R2' U' R2 U2 R2' U2' R2",
          "R2' U R2 U' R2' U2 R2 U2' R2' U2' R2 U' R2' U' R2 U2 R2' U2' R2",
          "R2 U R2 U2' R U2' R' U' R2' U R2 U R U R2 U R2 U2 R",
          "R2 U2' R2' U' R2 U2' R2 U2' R U' R U R2' U2 R U2' R U' R'",
          "R2' U2 R2' U2 R U2' R2 U2 R2 U' R2' U' R2' U R U2 R2' U2 R'",
          "R2' U2' R2 U' R2' U2' R U2' R U' R U R2' U2 R U2' R U' R'",
          "R' U2 R2 U R' U' R2 U R2 U R2' U2' R2' U2 R' U R2 U2 R'",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          2,
          1,
          2,
          3,
          4,
          5,
          1,
          3,
          3,
          4,
          5,
          4,
          5,
          2,
          1,
        ],
      },
      {
        name: 'P4-',
        scr: [
          "R2 U2' R' U2' R' U2 R U' R U R2' U2' R2 U' R' U2' R'",
          "R' U2' R U2 R U2 R2' U' R2 U' R2' U R U2 R' U2' R",
          "R' U' R2 U' R2' U2 R U R U2' R U R2' U R2 U2' R2'",
          "R U R' U R2' U2 R U R U R' U' R' U2 R2' U' R2' U2' R",
          "R U2' R2' U' R U R2' U' R2' U' R2 U2 R2 U2' R U' R2' U2' R",
          "R2 U2 R2' U R2 U2 R' U2 R' U R' U' R2 U2' R' U2 R'",
          "R2 U2' R2 U2' R' U2 R2' U2' R2' U R2 U R2 U' R' U2' R2 U2' R",
          "R2' U2 R2 U R2' U2 R2' U2 R' U R' U' R2 U2' R' U2 R'",
          "R2' U' R2' U2 R' U2 R U R2 U' R2' U' R' U' R2' U' R2' U2' R'",
          "R2 U' R2' U R2 U2' R2' U2 R2 U2 R2' U R2 U R2' U2' R2 U2 R2'",
          "R2 U' R2' U' R2 U2 R2' U2' R2 U' R2' U R2 U R2' U2' R2 U2 R2'",
          "R2 U' R2' U' R2 U2 R2' U' R2 U' R2' U' R2 U R2' U' R2 U2 R2'",
          "R2' U' R2 U R2' U2' R2 U2 R2' U2 R2 U R2' U R2 U2' R2' U2 R2",
          "R2' U' R2 U' R2' U2 R2 U2' R2' U' R2 U R2' U R2 U2' R2' U2 R2",
          "R2' U' R2 U' R2' U2 R2 U' R2' U' R2 U' R2' U R2 U' R2' U2 R2",
          "R' U' R U R2 U2' R2' U' R' U R U2 R2 U' R2' U2' R2 U2 R2'",
          "R' U' R U R2' U2' R2 U2 R2' U' R2 U2' R' U R U' R2' U2 R2",
          "R' U' R U' R2' U2 R2 U2' R2' U R2 U2' R' U R U' R2' U2 R2",
          "R2 U2' R2' U' R2' U R' U R' U' R2 U' R' U R' U R U R2'",
          "R2' U2' R2 U' R' U R' U R' U' R2 U' R' U R' U R U R2",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          3,
          4,
          5,
          1,
          2,
          3,
          2,
          3,
          2,
          4,
          5,
          4,
          5,
        ],
      },
    ],
  }, //A
  {
    cat: 'Q',
    cases: [
      {
        name: 'Q1+',
        scr: [
          "R2 U2' R2' U' R2 U2' R2' U R2 U2' R2' U' R2 U2' R2'",
          "R2 U2' R2' U' R2 U2' R2' U R2' U2' R2 U' R2' U2' R2",
          "R2' U2' R2 U' R2' U2' R2 U R2 U2' R2' U' R2 U2' R2'",
          "R2' U2' R2 U' R2' U2' R2 U R2' U2' R2 U' R2' U2' R2",
          "R' U2 R U2' R' U2' R' U2' R U' R' U2' R2 U2' R' U2 R",
          "R U2 R' U2' R2 U2' R' U' R U2' R' U2' R' U2' R U2 R'",
          "R' U2 R U2 R2 U R2 U R U R' U2' R2' U' R2' U' R' U2 R",
          "R' U2 R U2' R' U' R' U2 R U R' U2 R U R U2' R' U2 R",
          "R2 U R U2 R2 U' R2 U R U2' R2' U R U R' U2' R U' R2'",
          "R U2' R' U R U R2' U2' R U' R' U2' R2 U' R' U2' R U2' R'",
          "R2 U2' R2' U2 R2 U2 R2' U2' R2 U2 R2' U' R2 U2' R2' U' R2 U2' R2'",
          "R2 U2' R2' U2 R2 U2 R2' U2' R2 U2 R2' U' R2' U2' R2 U' R2' U2' R2",
          "R2 U2' R2' U2 R' U2 R2' U2' R2 U R2' U2' R2 U2 R U2 R2 U2' R2'",
          "R2 U2' R2' U' R2 U R U2 R2 U R2' U2 R' U R2' U' R2 U2' R2'",
          "R2 U2' R2' U' R2 U2' R2' U R2 U2' R2' U2 R2 U2 R2' U2' R2 U2 R2'",
          "R2 U2' R2' U' R2 U2' R2' U R2' U2' R2 U2 R2' U2 R2 U2' R2' U2 R2",
          "R2 U2' R2' U' R2 U2' R2' U' R U2 R2 U2' R2' U' R2 U2' R2' U2 R'",
          "R2 U2' R2' U' R2 U2' R2' U' R U2 R2' U2' R2 U' R2' U2' R2 U2 R'",
          "R2 U2' R2' U' R2 U2' R2' U' R2 U2 R2 U2' R2' U' R2 U2' R2' U2 R2'",
          "R2 U2' R2' U' R2 U2' R2' U' R2 U2 R2' U2' R2 U2 R2' U2 R2 U2' R2'",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          5,
          1,
          2,
          3,
          2,
          3,
          1,
          3,
          4,
          2,
          4,
          5,
          4,
          5,
        ],
      },
      {
        name: 'Q1-',
        scr: [
          "R2 U2 R2' U R2 U2 R2' U' R2 U2 R2' U R2 U2 R2'",
          "R2 U2 R2' U R2 U2 R2' U' R2' U2 R2 U R2' U2 R2",
          "R2' U2 R2 U R2' U2 R2 U' R2 U2 R2' U R2 U2 R2'",
          "R2' U2 R2 U R2' U2 R2 U' R2' U2 R2 U R2' U2 R2",
          "R U2' R' U2 R U2 R U2 R' U R U2 R2' U2 R U2' R'",
          "R' U2' R U2 R2' U2 R U R' U2 R U2 R U2 R' U2' R",
          "R U2' R' U2 R U R U2' R' U' R U2' R' U' R' U2 R U2' R'",
          "R U2' R' U2' R2' U' R2' U' R' U' R U2 R2 U R2 U R U2' R'",
          "R' U2 R U' R' U' R2 U2 R' U R U2 R2' U R U2 R' U2 R",
          "R2' U' R' U2' R2' U R2' U' R' U2 R2 U' R' U' R U2 R' U R2",
          "R2 U2 R2' U R2 U2 R2' U R U2' R2 U2 R2' U R2 U2 R2' U2' R'",
          "R2 U2 R2' U R2 U2 R2' U R U2' R2' U2 R2 U R2' U2 R2 U2' R'",
          "R2 U2 R2' U R2 U2 R2' U R2 U2' R2 U2 R2' U R2 U2 R2' U2' R2'",
          "R2 U2 R2' U R2 U2 R2' U R2 U2' R2' U2 R2 U R2' U2 R2 U2' R2'",
          "R2 U2 R2' U R2 U2 R2' U R2 U2' R2' U2 R2 U2' R2' U2' R2 U2 R2'",
          "R2 U2 R2' U R2 U2 R2' U R2' U2' R2 U2 R2' U R2 U2 R2' U2' R2",
          "R2 U2 R2' U R2 U2 R2' U R2' U2' R2 U2 R2' U2' R2 U2' R2' U2 R2",
          "R2 U2 R2' U R2 U2 R2' U R2' U2' R2' U2 R2 U R2' U2 R2 U2' R2",
          "R2 U2 R2' U R2 U2 R2' U R' U2' R2 U2 R2' U R2 U2 R2' U2' R",
          "R2 U2 R2' U R2 U2 R2' U R' U2' R2' U2 R2 U R2' U2 R2 U2' R",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          3,
          1,
          2,
          1,
          2,
          3,
          4,
          3,
          4,
          5,
          4,
          5,
          2,
          5,
        ],
      },
      {
        name: 'Q2+',
        scr: [
          "R U2 R' U R U2 R' U' R' U2' R U' R' U2' R",
          "R U2' R' U' R U2' R' U2' R' U2' R U' R' U2' R",
          "R U2' R' U' R U2' R' U' R' U2 R U R' U2 R",
          "R U2' R' U' R U' R2 U2' R2' U' R' U R2' U2 R2' U' R'",
          "R' U' R2' U2 R2' U R' U' R2' U2' R2 U' R U' R' U2' R",
          "R U2 R' U R U2 R2' U2 R U R2 U' R2 U2' R U2 R2 U R2'",
          "R2 U' R' U' R U' R' U R U R U R U2 R U2' R' U' R2",
          "R2' U2 R U2 R' U R U2 R U2 R2' U' R2' U2' R2 U2' R2' U' R'",
          "R2' U2 R2 U2 R2' U R' U R U' R2 U2' R2' U2' R2 U2' R2 U' R2'",
          "R2 U' R2' U2' R U2' R U' R U2 R U R2' U' R' U2' R' U2 R2'",
          "R' U2' R U' R' U2' R2 U R U R' U R' U' R2 U' R' U' R'",
          "R' U2' R' U' R U2' R' U2' R2 U2' R U R2 U2 R2' U2 R2 U R2",
          "R U2 R2 U R U2 R U R U' R U2' R' U2' R' U' R U2 R2",
          "R U2 R' U R U R2 U R2 U2 R U' R' U' R2' U' R2' U R'",
          "R U2 R' U R U R2' U2' R' U2 R2' U R2 U2 R2 U R' U2 R",
          "R U2 R' U R U2 R U' R2 U2' R U2 R2 U R2' U2' R' U2 R",
          "R U2 R' U R U2 R2' U2 R U2' R2 U R2' U2 R' U2' R2' U' R2'",
          "R U2 R' U R U' R2' U2' R2 U2 R2' U2' R2 U2 R' U R' U2 R",
          "R U2 R' U R2 U2 R2 U R2' U2 R' U2' R2' U R U R' U2 R",
          "R U2 R' U R' U2 R2 U2' R2' U2 R2 U2' R2' U' R U R' U2 R",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          3,
          1,
          2,
          1,
          2,
          3,
          5,
          3,
          4,
          2,
          4,
          5,
          4,
          5,
        ],
      },
      {
        name: 'Q2-',
        scr: [
          "R' U2' R U' R' U2' R U R U2 R' U R U2 R'",
          "R' U2 R U R' U2 R U R U2' R' U' R U2' R'",
          "R' U2 R U R' U2 R U2 R U2 R' U R U2 R'",
          "R' U2 R U R' U R2' U2 R2 U R U' R2 U2' R2",
          "R U R2 U2' R2 U' R U R2 U2 R2' U R' U R U2 R'",
          "R' U2' R U' R' U2' R2 U2' R' U' R2' U R2' U2 R' U2' R2' U' R2",
          "R U2 R U R' U2 R U2 R2' U2 R' U' R2' U2' R2 U2' R2' U' R2'",
          "R U2 R' U R U2 R2' U' R' U' R U' R U R2' U R",
          "R2' U R2 U2 R' U2 R' U R' U2' R' U' R2 U R U2 R U2' R2",
          "R2 U2' R2' U2' R2 U' R U' R' U R2' U2 R2 U2 R2' U2 R2' U R2",
          "R2 U2' R' U2' R U' R' U2' R' U2' R2 U R2 U2 R2' U2 R2",
          "R2' U R U R' U R U' R' U' R' U' R' U2' R' U2 R U R2'",
          "R U R2' U2 R U' R' U R' U2' R2' U' R2 U2 R U2' R' U2' R2",
          "R U R2' U2 R U' R' U' R2 U' R2' U2' R' U' R U2' R' U2' R2",
          "R U R' U2 R U2 R' U2' R U2' R2' U' R U' R' U2 R2 U2 R'",
          "R2 U R2 U2 R U2' R2 U' R2' U2 R' U2' R2 U2' R' U' R U2' R'",
          "R' U2' R U2 R2 U' R2' U2' R' U2 R2' U R' U2' R' U' R U2' R'",
          "R' U2' R U' R U2' R2' U2 R2 U2' R2' U2 R2 U R' U' R U2' R'",
          "R' U2' R U' R2' U2' R2' U' R2 U2' R U2 R2 U' R' U' R U2' R'",
          "R' U2' R U' R' U R2 U2 R2' U2' R2 U2 R2' U2' R U' R U2' R'",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          3,
          1,
          2,
          5,
          2,
          3,
          4,
          3,
          4,
          2,
          4,
          5,
          1,
          5,
        ],
      },
    ],
  },
  {
    cat: 'R',
    cases: [
      {
        name: 'R1+',
        scr: [
          "R2 U R2' U R2 U R2' U2 R2 U2 R2' U R2 U' R2'",
          "R2' U R2 U R2' U R2 U2 R2' U2 R2 U R2' U' R2",
          "R' U R' U2 R U R U' R2' U2' R2 U R' U2' R",
          "R U R' U' R2' U2 R2 U R U' R' U R2' U2 R2",
          "R U2 R U R2 U2 R2' U2 R2 U R2 U R' U R U2 R'",
          "R2 U R2' U R2 U R2' U2 R2' U2 R2 U R2' U2 R' U2 R2'",
          "R2 U R2' U' R' U2 R2' U R2 U2 R2' U2 R2' U R2 U' R2'",
          "R2' U R2 U R2' U R2 U2 R2 U2 R2' U R2 U2 R U2 R2",
          "R2' U R2 U' R U2 R2 U R2' U2 R2 U2 R2 U R2' U' R2",
          "R2' U2' R2 U' R U2' R2' U2 R' U R U2 R2 U2' R2 U2 R2",
          "R U2 R2' U R2 U2 R' U2 R2 U2 R2' U R' U' R U R2 U2 R2'",
          "R U' R U R2' U2 R U' R' U' R2 U' R' U2' R' U R U2 R'",
          "R2 U2 R2 U R2' U2 R2' U2 R2 U2 R2' U R' U' R U R2 U2 R2'",
          "R2 U R2' U R2 U R2' U' R2 U2' R2' U2 R2 U2' R2' U2' R2 U' R2'",
          "R2 U R2' U R2 U2' R2' U2' R2 U2 R2' U2' R2 U' R2' U R2 U' R2'",
          "R2 U R2' U' R' U2 R2' U R2 U2 R' U2 R2 U R2' U2 R' U2 R2'",
          "R2 U2 R2' U R2 U2' R2' U2 R2 U2 R2' U2' R2 U R2' U R2 U2' R2'",
          "R2 U2 R2' U R2 U2' R2' U' R2 U2' R2' U2 R2 U' R2' U R2 U2' R2'",
          "R2 U2 R2' U R2 U' R2' U' R2 U R2' U2' R2 U2 R2' U R2 U' R2'",
          "R2 U2 R2' U R2 U' R2' U' R2 U' R2' U2 R2 U2' R2' U2' R2 U' R2'",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          2,
          1,
          2,
          4,
          4,
          5,
          3,
          2,
          3,
          1,
          3,
          4,
          5,
          5,
        ],
      },
      {
        name: 'R1-',
        scr: [
          "R' U' R U R2 U2' R2' U' R' U R U' R2 U2' R2'",
          "R U' R U2' R' U' R' U R2 U2 R2' U' R U2 R'",
          "R2 U' R2' U' R2 U' R2' U2' R2 U2' R2' U' R2 U R2'",
          "R2' U' R2 U' R2' U' R2 U2' R2' U2' R2 U' R2' U R2",
          "R' U2' R' U' R2' U2' R2 U2' R2' U' R2' U' R U' R' U2' R",
          "R2 U' R2' U R' U2' R2' U' R2 U2' R2' U2' R2' U' R2 U R2'",
          "R2 U' R2' U' R2 U' R2' U2' R2' U2' R2 U' R2' U2' R' U2' R2'",
          "R2' U' R2 U R U2' R2 U' R2' U2' R2 U2' R2 U' R2' U R2",
          "R2' U' R2 U' R2' U' R2 U2' R2 U2' R2' U' R2 U2' R U2' R2",
          "R2 U2 R2' U R' U2 R2 U2' R U' R' U2' R2' U2 R2' U2' R2'",
          "R2' U2' R2' U' R2 U2' R2 U2' R2' U2' R2 U' R U R' U' R2' U2' R2",
          "R' U R' U' R2 U2' R' U R U R2' U R U2 R U' R' U2' R",
          "R' U2' R2 U' R2' U2' R U2' R2' U2' R2 U' R U R' U' R2' U2' R2",
          "R U2' R2 U' R2' U2' R' U R2' U' R2 U2' R2' U2' R2 U' R2' U R2",
          "R' U2' R2' U' R2 U2' R U R2 U' R2' U2' R2 U2' R2' U' R2 U R2'",
          "R' U2' R' U2 R U R' U R U2' R U2 R' U2' R' U2' R U2' R",
          "R' U2' R' U2 R U R' U' R U2 R U2' R' U2 R' U R U2' R",
          "R' U2 R2' U2' R2 U' R' U2 R U2' R2' U2' R2 U R' U' R U2 R",
          "R' U2 R' U' R' U2' R2 U R2' U R2' U R2' U R2 U2' R2' U2 R2",
          "R2 U' R2 U' R2 U R2' U2' R2' U2 R' U' R2' U R U2' R2 U2' R2'",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          2,
          1,
          4,
          5,
          5,
          2,
          3,
          2,
          3,
          4,
          4,
          5,
          1,
          3,
          1,
        ],
      },
      {
        name: 'R2+',
        scr: [
          "R2 U R2' U' R2 U2' R2' U2' R2 U' R2' U' R2 U' R2'",
          "R2' U R2 U' R2' U2' R2 U2' R2' U' R2 U' R2' U' R2",
          "R2' U2' R2 U' R U R' U' R2' U2' R2 U R U' R'",
          "R' U2 R U' R2' U2 R2 U R' U' R' U2' R U' R",
          "R U2' R' U' R U' R2' U' R2' U2' R2 U2' R2' U' R' U2' R'",
          "R2 U R2' U' R2 U2' R2 U2' R2' U' R2 U2' R U R2 U' R2'",
          "R2 U2' R U2' R2 U' R2' U2' R2 U2' R2 U' R2' U' R2 U' R2'",
          "R2' U R2 U' R2' U2' R2' U2' R2 U' R2' U2' R' U R2' U' R2",
          "R2' U2' R' U2' R2' U' R2 U2' R2' U2' R2' U' R2 U' R2' U' R2",
          "R2' U2' R2' U2 R2' U2' R' U' R U2' R2 U2 R' U R2' U2 R2",
          "R U2' R' U' R U2 R U R2' U R U R' U2' R2 U' R' U R'",
          "R2 U2' R2' U' R' U R U' R2 U2' R2' U2' R U2' R2' U' R2 U2' R'",
          "R2 U2' R2' U' R' U R U' R2 U2' R2' U2' R2 U2' R2 U' R2' U2' R2'",
          "R U2 R' U R U2 R2' U2 R2' U2' R2' U' R2 U2' R2' U' R' U2' R",
          "R U2 R' U R U2 R2' U2 R' U2' R2 U' R2' U2' R2 U' R' U2' R",
          "R U2 R2 U2' R2' U2 R' U' R2' U2 R2 U R U2 R' U R2' U2 R2",
          "R2 U2 R2' U2' R2 U R2 U2 R2' U R2 U2 R2' U2' R2' U2' R2 U2 R2'",
          "R2 U2 R2' U2' R2 U R2' U2 R2 U R2' U2 R2 U2' R2' U2' R2 U2 R2'",
          "R2 U2 R2' U2' R2 U R2' U2 R2 U2' R2' U2' R2 U2 R2' U R2 U2 R2'",
          "R2 U2 R2' U2' R2 U R2' U2 R2 U2' R2' U2' R2' U2 R2 U R2' U2 R2",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          4,
          1,
          2,
          1,
          3,
          4,
          3,
          4,
          5,
          2,
          2,
          3,
          5,
          5,
        ],
      },
      {
        name: 'R2-',
        scr: [
          "R U2' R' U R2 U2' R2' U' R U R U2 R' U R'",
          "R2 U2 R2' U R' U' R U R2 U2 R2' U' R'",
          "R2 U' R2' U R2 U2 R2' U2 R2 U R2' U R2 U R2'",
          "R2' U' R2 U R2' U2 R2 U2 R2' U R2 U R2' U R2",
          "R' U2 R U R' U R2 U R2 U2 R2' U2 R2 U R U2 R",
          "R2 U2 R U2 R2 U R2' U2 R2 U2 R2 U R2' U R2 U R2'",
          "R2 U' R2' U R2 U2 R2 U2 R2' U R2 U2 R U' R2 U R2'",
          "R2' U2 R' U2 R2' U R2 U2 R2' U2 R2' U R2 U R2' U R2",
          "R2' U' R2 U R2' U2 R2' U2 R2 U R2' U2 R' U' R2' U R2",
          "R2 U2 R2 U2' R2 U2 R U R' U2 R2' U2' R U' R2 U2' R2'",
          "R2' U2 R2 U R U' R' U R2' U2 R2 U2 R2' U2 R2' U R2 U2 R2",
          "R2' U2 R2 U R U' R' U R2' U2 R2 U2 R' U2 R2 U R2' U2 R",
          "R' U2 R U R' U2' R' U' R2 U' R' U' R U2 R2' U R U' R",
          "R2 U2 R2' U2' R2 U R2 U2' R2' U' R2 U2' R2' U2 R2' U2 R2 U2' R2'",
          "R2 U2 R2' U2' R2 U R2' U2' R2 U2 R2' U2 R2 U2' R2' U' R2 U2' R2'",
          "R2 U2 R2' U2' R2 U R2' U2' R2 U2 R2' U2 R2' U2' R2 U' R2' U2' R2",
          "R2 U2 R2' U2' R2 U R2' U2' R2 U' R2' U2' R2 U2 R2' U2 R2 U2' R2'",
          "R2 U2 R2' U2' R2 U' R2' U2 R2 U2' R2' U' R2 U2' R2' U' R2 U2' R2'",
          "R2 U2 R2' U2' R2 U' R2' U2 R2 U2' R2' U' R2' U2' R2 U' R2' U2' R2",
          "R2 U2 R2' U2' R2 U' R2' U2 R2' U2' R2 U' R2' U2' R2 U' R2 U2' R2'",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          2,
          1,
          2,
          4,
          3,
          4,
          1,
          4,
          5,
          5,
          2,
          3,
          3,
          5,
        ],
      },
      {
        name: 'R3+',
        scr: [
          "R2 U2 R2' U R2 U' R2 U2' R2' U' R2 U2' R2' U2 R2'",
          "R2 U2 R2' U R2 U' R2' U2' R2 U' R2' U2' R2 U2 R2'",
          "R2' U2 R2 U R2' U' R2 U2' R2' U' R2 U2' R2' U2 R2",
          "R2' U2 R2 U R2' U' R2' U2' R2 U' R2' U2' R2 U2 R2",
          "R2 U2 R2' U R2 U2 R2' U2 R2 U2' R2' U' R2 U2' R2'",
          "R2 U2 R2' U R2 U2 R2' U2 R2' U2' R2 U' R2' U2' R2",
          "R2 U2 R2' U R2 U' R2' U2' R2 U2 R2' U2 R2 U2' R2'",
          "R2' U2 R2 U R2' U2 R2 U2 R2 U2' R2' U' R2 U2' R2'",
          "R2' U2 R2 U R2' U2 R2 U2 R2' U2' R2 U' R2' U2' R2",
          "R2' U2 R2 U R2' U' R2 U2' R2' U2 R2 U2 R2' U2' R2",
          "R' U R2' U2 R2 U2 R U' R2 U R2 U2' R2' U2' R2 U' R",
          "R U2 R2' U R2' U2 R' U R U2 R2 U' R U R U2' R'",
          "R2 U2 R2' U R2 U2 R U2 R2 U2' R2' U' R2 U2' R2' U2 R2",
          "R2 U2 R2' U R2 U2 R U2 R2' U2' R2 U' R2' U2' R2 U2 R2",
          "R2 U2 R2' U R2 U2 R2 U2 R2 U2' R2' U' R2 U2' R2' U2 R",
          "R2 U2 R2' U R2 U2 R2 U2 R2' U2' R2 U' R2' U2' R2 U2 R",
          "R2 U2 R2' U R2 U2 R' U2 R2 U2' R2' U' R2 U2' R2' U2 R'",
          "R2 U2 R2' U R2 U2 R' U2 R2' U2' R2 U' R2' U2' R2 U2 R'",
          "R2 U2 R2' U R2 U' R2 U2' R2' U2 R2 U2 R2' U2' R2 U2 R",
          "R2 U2 R2' U2' R' U2' R2' U' R2 U2' R2' U' R2' U2' R2 U2 R2'",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          5,
          1,
          2,
          3,
          3,
          4,
          1,
          4,
          5,
          2,
          2,
          3,
          4,
          5,
        ],
      },
      {
        name: 'R3-',
        scr: [
          "R2 U2' R2' U' R2 U R2 U2 R2' U R2 U2 R2' U2' R2'",
          "R2 U2' R2' U' R2 U R2' U2 R2 U R2' U2 R2 U2' R2'",
          "R2' U2' R2 U' R2' U R2 U2 R2' U R2 U2 R2' U2' R2",
          "R2' U2' R2 U' R2' U R2' U2 R2 U R2' U2 R2 U2' R2",
          "R2 U2' R2' U' R2 U R2' U2 R2 U2' R2' U2' R2 U2 R2'",
          "R2 U2' R2' U' R2 U2' R2' U2' R2 U2 R2' U R2 U2 R2'",
          "R2 U2' R2' U' R2 U2' R2' U2' R2' U2 R2 U R2' U2 R2",
          "R2' U2' R2 U' R2' U R2 U2 R2' U2' R2 U2' R2' U2 R2",
          "R2' U2' R2 U' R2' U2' R2 U2' R2 U2 R2' U R2 U2 R2'",
          "R2' U2' R2 U' R2' U2' R2 U2' R2' U2 R2 U R2' U2 R2",
          "R2 U2' R2' U2 R' U2 R2' U R2 U2 R2' U R2' U2 R2 U2' R2'",
          "R2 U2' R2' U' R2 U R2 U2 R2' U2' R2 U2' R2' U2 R2 U2' R",
          "R2 U2' R2' U' R2 U2' R U2' R2 U2 R2' U R2 U2 R2' U2' R2",
          "R2 U2' R2' U' R2 U2' R U2' R2' U2 R2 U R2' U2 R2 U2' R2",
          "R2 U2' R2' U' R2 U2' R2 U2' R2 U2 R2' U R2 U2 R2' U2' R",
          "R2 U2' R2' U' R2 U2' R2 U2' R2' U2 R2 U R2' U2 R2 U2' R",
          "R2 U2' R2' U' R2 U2' R' U2' R2 U2 R2' U R2 U2 R2' U2' R'",
          "R2 U2' R2' U' R2 U2' R' U2' R2' U2 R2 U R2' U2 R2 U2' R'",
          "R2' U2' R2 U2 R U2 R2 U R2' U2 R2 U R2 U2 R2' U2' R2",
          "R2' U2' R2 U' R2' U R2' U2 R2 U2' R2' U2' R2 U2 R2' U2' R'",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          3,
          1,
          3,
          4,
          4,
          5,
          1,
          2,
          1,
          2,
          3,
          4,
          5,
          5,
          2,
        ],
      },
      {
        name: 'R4+',
        scr: [
          "R2 U2' R2 U2 R2' U R2 U2 R2' U R2' U' R2 U2' R2'",
          "R2 U2' R2' U2 R2 U R2' U2 R2 U R2' U' R2 U2' R2'",
          "R2' U2' R2 U2 R2' U R2 U2 R2' U R2 U' R2' U2' R2",
          "R2' U2' R2' U2 R2 U R2' U2 R2 U R2 U' R2' U2' R2",
          "R2 U2 R2' U R2 U2 R2' U2' R2 U2' R2' U' R2 U2' R2'",
          "R2 U2 R2' U R2 U2 R2' U2' R2' U2' R2 U' R2' U2' R2",
          "R2 U2 R2' U2' R2 U2' R2' U2 R2 U R2' U' R2 U2' R2'",
          "R2' U2 R2 U R2' U2 R2 U2' R2 U2' R2' U' R2 U2' R2'",
          "R2' U2 R2 U R2' U2 R2 U2' R2' U2' R2 U' R2' U2' R2",
          "R2' U2 R2 U2' R2' U2' R2 U2 R2' U R2 U' R2' U2' R2",
          "R2' U2 R2 U2 R U R2' U' R2 U2 R2 U2' R U R2 U' R'",
          "R U2 R' U' R' U R2' U2' R' U' R U2' R2 U' R2 U2' R'",
          "R U2' R2 U2 R2' U R2 U2 R2' U2' R U2' R2' U' R2 U2' R2'",
          "R U2' R2 U2 R2' U R2 U2 R2' U2' R2 U2' R2 U' R2' U2' R2",
          "R U2' R2 U2 R2' U2' R2 U2' R2' U2 R2 U R2 U' R2' U2' R2",
          "R U2' R2' U2 R2 U R2' U2 R2 U2' R U2' R2' U' R2 U2' R2'",
          "R U2' R2' U2 R2 U R2' U2 R2 U2' R2 U2' R2 U' R2' U2' R2",
          "R2 U2' R2 U2 R2' U R2 U2 R2' U2' R U2' R2 U' R2' U2' R2",
          "R2 U2' R2' U2 R2 U R2 U2 R2' U R2 U2 R U2 R2 U2' R2'",
          "R2 U2' R2' U2 R2 U R2' U2 R2 U2' R U2' R2 U' R2' U2' R2",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          4,
          1,
          5,
          1,
          3,
          1,
          2,
          4,
          4,
          5,
          2,
          2,
          3,
          5,
          3,
        ],
      },
      {
        name: 'R4-',
        scr: [
          "R2 U2 R2 U2' R2' U' R2 U2' R2' U' R2' U R2 U2 R2'",
          "R2 U2 R2' U2' R2 U' R2' U2' R2 U' R2' U R2 U2 R2'",
          "R2' U2 R2 U2' R2' U' R2 U2' R2' U' R2 U R2' U2 R2",
          "R2' U2 R2' U2' R2 U' R2' U2' R2 U' R2 U R2' U2 R2",
          "R2 U2' R2' U2 R2 U2 R2' U2' R2 U' R2' U R2 U2 R2'",
          "R2 U2' R2' U' R2 U2' R2' U2 R2 U2 R2' U R2 U2 R2'",
          "R2 U2' R2' U' R2 U2' R2' U2 R2' U2 R2 U R2' U2 R2",
          "R2' U2' R2 U2 R2' U2 R2 U2' R2' U' R2 U R2' U2 R2",
          "R2' U2' R2 U' R2' U2' R2 U2 R2 U2 R2' U R2 U2 R2'",
          "R2' U2' R2 U' R2' U2' R2 U2 R2' U2 R2 U R2' U2 R2",
          "R2 U2' R2' U2' R' U' R2 U R2' U2' R2' U2 R' U' R2'",
          "R U2 R2 U2' R2' U2 R2 U2 R2' U2' R2 U' R2 U R2' U2 R2",
          "R U2 R2 U2' R2' U' R2 U2' R2' U2 R U2 R2' U R2 U2 R2'",
          "R U2 R2 U2' R2' U' R2 U2' R2' U2 R2 U2 R2 U R2' U2 R2",
          "R U2 R2' U2' R2 U' R2' U2' R2 U2 R U2 R2' U R2 U2 R2'",
          "R U2 R2' U2' R2 U' R2' U2' R2 U2 R2 U2 R2 U R2' U2 R2",
          "R U' R2 U2' R2' U2' R2 U R2 U' R U2 R2 U2 R2' U R'",
          "R2 U2 R2 U2' R2' U' R2 U2' R2' U2 R U2 R2 U R2' U2 R2",
          "R2 U2 R2' U2' R2 U' R2 U2' R2' U' R2 U2' R U2' R2 U2 R2'",
          "R2 U2 R2' U2' R2 U' R2' U2' R2 U2 R U2 R2 U R2' U2 R2",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          3,
          4,
          1,
          4,
          5,
          4,
          1,
          2,
          5,
          2,
          3,
          3,
          5,
        ],
      },
    ],
  },

  {
    cat: 'S',
    cases: [
      {
        name: 'S1+',
        scr: [
          "R U R' U2 R U2 R' U' R' U' R U' R' U2 R",
          "R2 U R2' U R2 U' R2' U R2 U R2' U2' R2 U' R2'",
          "R2 U R2' U2 R2 U' R2' U' R2 U R2' U' R2 U' R2'",
          "R2' U R2 U R2' U' R2 U R2' U R2 U2' R2' U' R2",
          "R2' U R2 U2 R2' U' R2 U' R2' U R2 U' R2' U' R2",
          "R' U2' R U R' U R U R U2' R' U2' R U' R'",
          "R2 U R2' U' R2 U' R2' U2 R2 U R2' U2' R2 U' R2'",
          "R2' U R2 U' R2' U' R2 U2 R2' U R2 U2' R2' U' R2",
          "R2 U R2' U2 R2 U' R2' U2' R2 U R2' U R2 U' R2'",
          "R2' U R2 U2 R2' U' R2 U2' R2' U R2 U R2' U' R2",
          "R U2 R2 U R2' U2 R2 U' R2 U' R2' U R2 U' R2' U' R2",
          "R' U2 R2' U R2 U2 R2' U' R2' U' R2 U R2' U' R2 U' R2'",
          "R2 U R2' U' R2 U' R2 U2 R2' U R2 U2 R U R2 U' R2'",
          "R2' U R2 U' R2' U' R2' U2 R2 U R2' U2 R' U R2' U' R2",
          "R U2 R2 U R2' U2 R2 U' R2 U2' R2' U R2 U R2' U' R2",
          "R2 U2' R2' U' R2 U2' R' U2 R U2' R' U' R U2' R' U2 R'",
          "R2 U2' R2' U' R2 U2' R' U2' R U2 R' U R U2 R' U2' R'",
          "R2' U2' R2 U' R2' U2' R2' U2 R U2' R' U' R U2' R' U2 R'",
          "R2' U2' R2 U' R2' U2' R2' U2' R U2 R' U R U2 R' U2' R'",
          "R' U2 R2' U R2 U2 R2' U' R2' U2' R2 U R2' U R2 U' R2'",
        ],
      }, //B
      {
        name: 'S1-',
        scr: [
          "R2 U' R2' U R2 U R2' U2' R2 U' R2' U2 R2 U R2'",
          "R2' U' R2 U R2' U R2 U2' R2' U' R2 U2 R2' U R2",
          "R U2 R' U' R U' R' U' R' U2 R U2 R'",
          "R2 U' R2' U2' R2 U R2' U R2 U' R2' U R2 U R2'",
          "R2 U' R2' U' R2 U R2' U' R2 U' R2' U2 R2 U R2'",
          "R2' U' R2 U2' R2' U R2 U R2' U' R2 U R2' U R2",
          "R2' U' R2 U' R2' U R2 U' R2' U' R2 U2 R2' U R2",
          "R' U' R U2' R' U2' R U R U R' U R U2' R'",
          "R2 U' R2' U2' R2 U R2' U2 R2 U' R2' U' R2 U R2'",
          "R2' U' R2 U2' R2' U R2 U2 R2' U' R2 U' R2' U R2",
          "R U2' R2 U' R2' U2' R2 U R2 U R2' U' R2 U R2' U R2",
          "R' U2' R2' U' R2 U2' R2' U R2' U R2 U' R2' U R2 U R2'",
          "R2 U' R2' U R2 U R2 U2' R2' U' R2 U2' R U' R2 U R2'",
          "R2' U' R2 U R2' U R2' U2' R2 U' R2' U2' R' U' R2' U R2",
          "R U2' R2 U' R2' U2' R2 U R2 U2 R2' U' R2 U' R2' U R2",
          "R2 U2 R2' U R2 U2 R2 U2 R' U2' R U' R' U2' R U2 R",
          "R2 U2 R2' U R2 U2 R2 U2' R' U2 R U R' U2 R U2' R",
          "R2' U2 R2 U R2' U2 R U2 R' U2' R U' R' U2' R U2 R",
          "R2' U2 R2 U R2' U2 R U2' R' U2 R U R' U2 R U2' R",
          "R' U2' R2' U' R2 U2' R2' U R2' U2 R2 U' R2' U' R2 U R2'",
        ],
      },
      {
        name: 'S2+',
        scr: [
          "R2 U2' R2' U2' R2' U R' U' R2' U R2 U R U' R' U2' R2'",
          "R2' U2' R2 U' R U R' U' R2' U' R2 U R U' R2 U' R2",
          "R' U' R2 U' R2' U2 R U R U2' R U R2' U2 R2 U2 R2'",
          "R U2' R U R U2 R2' U' R2 U' R2 U' R2 U2' R2' U2' R2 U2 R2'",
          "R2 U2' R2' U' R2 U2' R2' U2' R U2 R U2' R' U' R U2' R' U2 R'",
          "R2 U2' R2' U' R2 U2' R2' U2' R U2' R U2 R' U R U2 R' U2' R'",
          "R2' U R' U2 R2' U' R2 U' R U' R2 U2 R2 U2' R2' U2' R2 U' R2'",
          "R2' U2' R U2' R' U2 R2 U2 R2' U R U R U R' U2 R' U2 R2",
          "R2' U2' R2 U' R2' U2' R2 U2' R U2 R U2' R' U' R U2' R' U2 R'",
          "R2' U2' R2 U' R2' U2' R2 U2' R U2' R U2 R' U R U2 R' U2' R'",
          "R U R2 U R2' U' R2 U R2 U R2' U2' R2' U R2 U' R2' U' R'",
          "R' U2' R U2 R' U' R2 U2 R2' U' R2 U' R2' U2' R U2 R' U2' R",
          "R' U2' R2 U R2' U2 R U2' R U2 R' U2 R' U2 R U R U' R'",
          "R U2' R2 U2 R' U' R' U R2 U2' R2 U' R U' R U R' U2' R'",
          "R2' U2 R2' U2' R2 U2' R2' U R' U' R2' U R2 U R U2 R2 U2 R2",
          "R2' U2 R2' U2' R2 U' R2 U R U2 R2' U2' R' U' R U2' R' U2 R2",
          "R U R' U R' U' R2' U R2 U R2' U2' R2 U2 R U2' R U' R'",
          "R U2' R U R U2 R2' U' R2 U' R2 U' R2 U R2' U2 R2 U2' R2'",
          "R U2' R' U' R' U' R U R' U R2 U2 R2' U2 R U2 R' U2' R",
          "R2 U2 R U2' R2' U2' R2 U R U' R2' U R2 U R2 U2 R' U2 R2'",
        ],
      },
      {
        name: 'S2-',
        scr: [
          "R2 U2 R2' U R' U' R U R2 U R2' U' R' U R2' U R2'",
          "R2' U2 R2 U2 R2 U' R U R2 U' R2' U' R' U R U2 R2",
          "R U R2' U R2 U2' R' U' R' U2 R' U' R2 U2' R2' U2' R2",
          "R2 U2 R2' U R2 U2 R2' U2 R' U2 R' U2' R U' R' U2' R U2 R",
          "R2 U2 R2' U R2 U2 R2' U2 R' U2' R' U2 R U R' U2 R U2' R",
          "R2 U2 R' U2 R U2' R2' U2' R2 U' R' U' R' U' R U2' R U2' R2'",
          "R2 U' R U2' R2 U R2' U R' U R2' U2' R2' U2 R2 U2 R2' U R2",
          "R2' U2 R2 U R2' U2 R2 U2 R' U2 R' U2' R U' R' U2' R U2 R",
          "R2' U2 R2 U R2' U2 R2 U2 R' U2' R' U2 R U R' U2 R U2' R",
          "R' U2 R' U' R' U2' R2 U R2' U R2' U R2' U2 R2 U2 R2' U2' R2",
          "R2 U2' R2 U2 R2' U R2' U' R' U2' R2 U2 R U R' U2 R U2' R2'",
          "R2 U2' R2 U2 R2' U2 R2 U' R U R2 U' R2' U' R' U2' R2' U2' R2'",
          "R' U2 R2' U2' R U R U' R2' U2 R2' U R' U R' U' R U2 R",
          "R U2 R2' U' R2 U2' R' U2 R' U2' R U2' R U2' R' U' R'",
          "R U2 R' U2' R U R2' U2' R2 U R2' U R2 U2 R' U2' R U2 R'",
          "R' U' R2' U' R2 U R2' U' R2' U' R2 U2 R2 U' R2' U R2",
          "R U2' R2' U2 R2 U2 R2' U R U2 R' U' R2 U2' R' U2 R' U R",
          "R U2' R2' U' R U' R' U R U' R' U R2 U' R2' U2 R2 U2 R'",
          "R2 U2 R2' U R' U2 R2 U2' R U' R' U2' R2' U2 R U R2 U2 R2'",
          "R2 U2 R2' U R' U' R U R2' U R2 U' R U R2 U' R U2 R2'",
        ],
      },
      {
        name: 'S3+',
        scr: [
          "R2 U2' R2' U2' R2 U' R' U2 R' U' R' U2' R2 U R2' U R",
          "R2 U2 R U R' U' R2' U' R2 U R U' R2 U2 R2 U2 R2'",
          "R2' U R2' U R' U' R2' U R2 U R U' R' U R2' U2 R2",
          "R U2' R' U2' R2 U2' R' U2' R' U2 R2 U2 R2 U2' R2 U R2'",
          "R2 U2' R2' U2 R2' U R2' U R2 U2' R' U' R' U2 R' U' R2 U R2'",
          "R U' R2' U2 R U R U' R2' U2' R2' U R' U R U2' R' U2 R'",
          "R2 U2 R2' U2' R2 U2' R2' U2' R2 U' R2' U R2 U' R2' U R2 U2 R2'",
          "R2' U2 R2 U2' R2' U2' R2 U2' R2' U' R2 U R2' U' R2 U R2' U2 R2",
          "R U R2 U R2' U' R2 U2 R2 U' R2' U' R2' U R2 U' R2' U' R'",
          "R U R' U' R' U2' R U2' R U2' R' U2 R' U2' R2 U' R2' U2 R",
          "R U2 R U2' R' U' R U2' R' U2 R' U2 R2 U2 R2' U R2 U2 R2'",
          "R U2 R U2' R' U' R U2' R' U2 R' U2 R2' U2 R2 U R2' U2 R2",
          "R U2 R U' R' U R' U R2' U2 R2' U' R U R U2' R2' U2 R'",
          "R U2' R U2 R' U R U2 R' U2' R' U2 R2 U2 R2' U R2 U2 R2'",
          "R U2' R U2 R' U R U2 R' U2' R' U2 R2' U2 R2 U R2' U2 R2",
          "R2 U R2' U2 R2 U2 R2' U2' R2' U R' U R2' U R2 U2' R U' R2",
          "R2 U2' R2' U2 R2 U2 R2' U R2' U R2' U R2 U2' R' U' R' U2 R'",
          "R2' U2' R U2 R' U R U2 R2 U2' R' U' R2' U R2' U2 R2 U2' R2",
          "R2' U2' R U2' R U' R' U' R' U' R2 U2' R2' U2' R U2 R' U2 R2",
          "R2' U2' R2' U2' R' U' R2' U' R2 U R U' R2 U2 R2' U2 R2 U2' R2",
        ],
      },
      {
        name: 'S3-',
        scr: [
          "R2' U2 R2 U2 R2' U R U2' R U R U2 R2' U' R2 U' R'",
          "R2 U' R2 U' R U R2 U' R2' U' R' U R U' R2 U2' R2'",
          "R2' U2' R' U' R U R2 U R2' U' R' U R2' U2' R2' U2' R2",
          "R2' U2 R2 U2' R2 U' R2 U' R2' U2 R U R U2' R U R2' U' R2",
          "R' U2 R U2 R2' U2 R U2 R U2' R2' U2' R2' U2 R2' U' R2 U' R'",
          "R2 U2' R2' U2 R2 U2 R2' U2 R2 U R2' U' R2 U R2' U' R2 U2' R2'",
          "R2' U2' R2 U2 R2' U2 R2 U2 R2' U R2 U' R2' U R2 U' R2' U2' R2",
          "R' U R2 U2' R' U' R' U R2 U2 R2 U' R U' R' U2 R U2' R",
          "R U2' R2' U2' R2 U R2' U' R U R' U' R U R' U R2 U2 R'",
          "R2 U2' R2' U' R' U2' R2 U2 R U R' U2 R2' U2' R U' R2 U2' R2'",
          "R2 U2' R' U R2' U' R' U R2' U' R2 U' R' U R U' R2 U2' R2'",
          "R2' U2' R2 U2 R2' U R2 U' R2 U' R2 U' R2' U2 R U R U2' R",
          "R2' U2' R' U2 R2 U2' R U' R' U2' R2' U2 R U R2 U' R2' U2' R2",
          "R2' U2' R' U' R U R2' U R2 U' R U R2 U' R U' R2' U2' R2",
          "R' U2' R U' R' U R U R U R2' U2 R2 U2 R' U R' U2 R",
          "R' U2' R' U2' R2' U R U R U' R2 U R2 U2' R2' U' R' U2' R2",
          "R' U' R U2' R U2 R2 U2' R2' U R2 U R2' U' R' U R'",
          "R' U' R U2' R U2 R2' U R U2' R' U' R2 U2' R2' U2' R2 U2 R'",
          "R U2 R2 U2' R U R U' R U' R2 U2' R2 U R' U' R2 U2 R'",
          "R U2' R' U2 R U2 R2' U2 R2 U R' U R U' R' U' R' U2' R",
        ],
      },
      {
        name: 'S4+',
        scr: [
          "R2 U2' R2' U' R2 U2' R2' U' R2 U2 R2' U R2 U2 R2'",
          "R2 U2' R2' U' R2 U2' R2' U' R2' U2 R2 U R2' U2 R2",
          "R2' U2' R2 U' R2' U2' R2 U' R2 U2 R2' U R2 U2 R2'",
          "R2' U2' R2 U' R2' U2' R2 U' R2' U2 R2 U R2' U2 R2",
          "R U2' R U2 R' U R2 U2 R2' U R2 U2 R' U2' R' U2 R'",
          "R U2' R U2 R' U R2' U2 R2 U R2' U2 R2' U2' R' U2 R'",
          "R2' U2 R2 U2' R' U2' R U R U2 R2' U' R2 U' R2 U' R2",
          "R2 U2' R2' U' R2' U2' R2 U' R2' U2' R' U' R2' U R2 U2 R2'",
          "R2' U2' R2 U' R2 U2' R2' U' R2 U2' R U' R2 U R2' U2 R2",
          "R U R2 U R2 U' R U R' U R2' U' R U R2 U2 R2' U2 R",
          "R U R2' U R2' U2' R2' U' R U R U2 R2' U R' U2' R2 U' R'",
          "R U R' U R U' R' U2 R U2 R' U2' R U R' U R U2' R'",
          "R U2' R' U2 R' U2 R U2 R' U R2 U2 R2' U2 R U R' U2 R",
          "R2 U2 R2' U' R' U2 R2' U' R2 U' R U R' U R2' U2 R2 U2 R",
          "R' U R' U' R2' U R2' U R2' U2' R' U2 R U2' R2 U2' R U' R'",
          "R2 U R U' R2 U' R U2 R' U R U' R2 U R2' U2 R U2 R2'",
          "R2' U R' U R2' U' R2' U' R2 U2' R2' U2' R' U' R2' U R2' U2 R2",
          "R U R' U R U' R' U R U R2' U2' R2 U R2' U R2 U2 R'",
          "R2 U2 R2' U2' R2 U R2' U2' R2 U2 R2' U R2 U2' R2' U' R2 U2' R2'",
          "R2 U2 R2' U2' R2 U R2' U2' R2 U2 R2' U R2' U2' R2 U' R2' U2' R2",
        ],
      },
      {
        name: 'S4-',
        scr: [
          "R2 U2 R2' U R2 U2 R2' U R2 U2' R2' U' R2 U2' R2'",
          "R2 U2 R2' U R2 U2 R2' U R2' U2' R2 U' R2' U2' R2",
          "R2' U2 R2 U R2' U2 R2 U R2 U2' R2' U' R2 U2' R2'",
          "R2' U2 R2 U R2' U2 R2 U R2' U2' R2 U' R2' U2' R2",
          "R' U2 R' U2' R U' R2 U2' R2' U' R2 U2' R2 U2 R U2' R",
          "R' U2 R' U2' R U' R2' U2' R2 U' R2' U2' R U2 R U2' R",
          "R2 U2' R2' U2 R U2 R' U' R' U2' R2 U R2' U R2' U R2'",
          "R2 U2 R2' U R2' U2 R2 U R2' U2 R' U R2' U' R2 U2' R2'",
          "R2' U2 R2 U R2 U2 R2' U R2 U2 R U R2 U' R2' U2' R2",
          "R U' R U R2 U' R2 U' R2 U2 R U2' R' U2 R2' U2 R' U R",
          "R2' U2' R2 U R U2' R2 U R2' U R' U' R U' R2 U2' R2' U2' R'",
          "R' U2 R U2' R U2' R' U2' R U' R2' U2' R2 U2' R' U' R U2' R'",
          "R' U' R U' R' U R U2' R' U2' R U2 R' U' R U' R' U2 R",
          "R' U' R2 U' R2 U2 R2 U R' U' R' U2' R2 U' R U2 R2' U R",
          "R' U' R2' U' R2' U R' U' R U' R2 U R' U' R2' U2' R2 U2' R'",
          "R2 U2 R2' U2' R2 U R2' U2 R2 U2' R2' U' R2 U2 R2' U R2 U2 R2'",
          "R2 U2 R2' U2' R2 U R2' U2 R2 U2' R2' U' R2' U2 R2 U R2' U2 R2",
          "R2 U2 R2' U2' R2 U2' R2' U2' R2 U2 R2' U2 R2 U2 R2' U R2 U2 R2'",
          "R2 U2 R2' U2' R2 U2' R2' U2' R2 U2 R2' U2 R2' U2 R2 U R2' U2 R2",
          "R2' U2 R2 U2' R2' U R2 U2 R2' U2' R2 U' R2 U2 R2' U R2 U2 R2'",
        ],
      },
      {
        name: 'S5+',
        scr: [
          "R2' U2 R U R' U2 R U2 R U' R' U R U2 R' U2 R",
          "R2 U R2 U2 R U' R' U' R2' U' R2 U R U2 R' U2 R",
          "R2' U R' U2 R2' U' R2 U' R U' R' U R2' U2 R2 U2 R2'",
          "R U2 R2 U' R2 U2 R' U2' R2' U2 R2' U2' R U R2' U2' R'",
          "R U2 R' U2 R U2 R U2 R' U R' U' R2 U2' R' U' R'",
          "R U2' R2 U R' U2 R2 U2' R2 U2 R U2' R2' U' R2' U2 R'",
          "R' U' R' U2' R U' R' U2' R U R U' R' U R U2 R' U2 R",
          "R U2 R U2' R' U2' R2' U' R2' U' R2 U2 R2 U' R' U R2 U2' R2'",
          "R U R2' U2 R U2 R' U2 R U2 R' U R2 U2 R' U2 R' U2 R",
          "R' U R2 U R2' U' R' U2 R U2' R2 U2 R2' U2 R U R2' U2 R2",
          "R2' U' R U2' R U R U2 R U R2 U' R2 U' R' U R2' U2' R'",
          "R U2' R U2 R' U R2 U R' U2 R' U2' R U2 R U2 R' U2 R2'",
          "R U2' R U2 R' U R2 U2' R' U2' R' U2 R U2' R U' R' U2 R2'",
          "R U2' R' U2' R U' R U2' R2' U' R2 U2' R' U R' U R U2' R'",
          "R U2' R' U2' R U' R2 U2' R2 U' R2' U2' R2' U R' U R U2' R'",
          "R2 U2' R2' U2' R2' U R' U' R2' U' R2 U R U' R2 U2' R2 U2 R2'",
          "R2' U2' R2 U' R U2 R2' U2' R' U' R U2' R2 U2 R' U2 R2' U2 R2",
          "R' U R2 U2 R U2 R' U' R' U R U R U2 R2' U R' U2 R",
          "R' U R2 U2 R' U2' R2 U2 R2 U' R2' U' R2' U R U' R2' U' R",
          "R' U2' R U2 R2 U R2' U R' U' R2' U' R2 U R U2 R' U2 R",
        ],
      },
      {
        name: 'S5-',
        scr: [
          "R' U R U2' R2' U' R U2' R' U R U R' U R U R",
          "R U2' R2' U2' R' U2 R2' U2 R' U' R' U' R' U2' R U2 R",
          "R U' R2' U2 R' U2' R2' U R' U' R' U' R' U2' R U2 R",
          "R' U' R U' R2 U R2 U' R2 U' R2' U2' R2 U2' R U' R2'",
          "R U2 R' U' R U' R' U R' U' R U' R' U R U2' R' U2' R",
          "R U R2' U2' R U2 R U R' U2 R' U R2 U' R2' U2' R2 U2 R'",
          "R U2 R U' R2' U R' U2' R2' U R U2' R' U R' U R U R",
          "R2 U R2 U2' R2 U2 R U R' U2 R2' U R2' U' R2 U2' R2' U2 R2'",
          "R2 U2 R U2 R' U2' R2' U2' R U2 R' U2 R U R U2 R U2' R2",
          "R2' U R U' R2' U R U R' U2' R' U' R2' U2' R2 U2' R2 U' R2",
          "R' U2 R2 U2' R2' U' R2 U R2 U' R2' U2' R2' U2 R' U R U' R",
          "R' U2 R' U2' R U2 R2' U2 R2' U R2 U2 R2 U2' R' U2 R U2' R",
          "R' U2 R' U2' R U2 R' U2 R2 U R2' U2 R U2' R' U2 R U2' R",
          "R' U' R U2' R U2 R2' U R2' U2 R2' U R2 U2 R2' U R U2 R'",
          "R' U' R U2' R U2 R2' U R' U2 R2 U R2' U2 R2 U R U2 R'",
          "R' U' R2' U' R U R2' U R2 U2 R U2 R2 U' R U R2' U R2'",
          "R' U' R2' U' R U' R U2 R2 U R2' U' R2 U' R U R2' U R2'",
          "R U2' R' U2 R' U2' R' U2 R U R' U2 R2 U R' U2 R2 U2 R'",
          "R U' R' U2 R' U2' R U2 R2' U2 R2' U2 R2 U R2 U' R' U R",
          "R2 U2' R2' U' R2 U2' R2' U' R2 U2' R2' U' R2 U R2' U' R2 U2' R2'",
        ],
      },
      {
        name: 'S6+',
        scr: [
          "R U' R' U2 R2 U R' U2 R U' R' U' R U' R' U' R'",
          "R U R' U R2' U' R2' U R2' U R2 U2 R2' U2 R' U R2",
          "R' U R2 U2' R U2 R2 U' R U R U R U2 R' U2' R'",
          "R' U2 R2 U2 R U2' R2 U2' R U R U R U2 R' U2' R'",
          "R' U2' R U R' U R U' R U R' U R U' R' U2 R U2 R'",
          "R U R2 U R' U R' U2' R2' U' R2 U R2' U R' U' R2 U' R2",
          "R U R2 U R' U' R2 U' R2' U2' R' U2' R2' U R' U' R2 U' R2",
          "R U R' U2 R' U2' R2 U' R U2' R2' U' R2 U2' R2' U' R' U2' R",
          "R U R' U2 R' U2' R2 U' R2 U2' R2 U' R2' U2' R2 U' R' U2' R",
          "R U2' R U2 R' U2' R U2' R2' U' R2 U2' R' U2 R U2' R' U2 R'",
          "R U2' R U2 R' U2' R2 U2' R2 U' R2' U2' R2' U2 R U2' R' U2 R'",
          "R U2' R2' U2 R2 U R2' U' R2' U R2 U2 R2 U2' R U' R' U R'",
          "R2 U' R' U R2 U' R' U' R U2 R U R2 U2 R2' U2 R2' U R2'",
          "R2' U2' R' U2' R U2 R2 U2 R' U2' R U2' R' U' R' U2' R' U2 R2'",
          "R2' U' R2' U2 R2' U2' R' U' R U2' R2 U' R2 U R2' U2 R2 U2' R2",
          "R' U2' R' U R2 U' R U2 R2 U' R' U2 R U' R U' R' U' R'",
          "R' U' R2 U2 R' U2' R' U' R U2' R U' R2' U R2 U2 R2' U2' R",
          "R U2 R' U' R2' U' R' U' R U R U R2' U2' R' U2 R' U' R",
          "R U2 R' U R2' U' R' U R U2 R' U2 R2' U2 R2' U R2' U' R'",
          "R U2 R' U' R U' R' U R' U2 R2 U2' R2' U2' R2 U' R2' U R",
        ],
      },
      {
        name: 'S6-',
        scr: [
          "R2 U2' R' U' R U2' R' U2' R' U R U' R' U2' R U2' R'",
          "R2 U' R U2' R2 U R2' U R' U R U' R2 U2' R2' U2' R2",
          "R2' U' R2' U2' R' U R U R2 U R2' U' R' U2' R U2' R'",
          "R' U2' R U2' R' U2' R' U2' R U' R U R2' U2 R U R",
          "R' U2' R2' U R2' U2' R U2 R2 U2' R2 U2 R' U' R2 U2 R",
          "R' U2 R2' U' R U2' R2' U2 R2' U2' R' U2 R2 U R2 U2' R",
          "R U R U2 R' U R U2 R' U' R' U R U' R' U2' R U2' R'",
          "R U2 R' U R' U2' R U2 R U R' U2 R' U2' R U2' R U2' R'",
          "R U2 R' U2' R2' U' R2 U' R U R2 U R2' U' R' U2' R U2' R'",
          "R U' R2' U2' R U2 R2' U2' R2' U R2 U R2 U' R' U R2 U R'",
          "R U' R2' U2' R' U2' R U R U' R' U' R' U2' R2 U' R U2' R'",
          "R2 U2 R2' U R' U2' R2 U2 R U R' U2 R2' U2' R U2' R2 U2' R2'",
          "R2' U2 R2 U2 R2 U' R U R2 U R2' U' R' U R2' U2 R2' U2' R2",
          "R' U2 R U2 R' U R2' U2 R2' U R2 U2 R2 U' R U' R' U2 R",
          "R' U2 R U2 R' U R' U2 R2 U R2' U2 R U' R U' R' U2 R",
          "R' U2 R' U2' R U' R2' U2 R U2 R U2' R' U2 R' U R U2' R2",
          "R' U2 R' U2' R U' R2' U' R U2' R U2 R' U2' R' U2' R U2' R2",
          "R2 U R' U2 R' U' R' U2' R' U' R2' U R2' U R U' R2 U2 R",
          "R U' R2' U' R2 U R U2' R' U2 R2' U2' R2 U2' R' U' R2 U2' R2'",
          "R' U' R2 U2' R' U2' R U2' R' U2' R U' R2' U2' R U2' R U2' R'",
        ],
      },
    ],
  }, //B
  {
    cat: 'T',
    cases: [
      {
        name: 'T1',
        scr: [
          "R2' U R U R U2 R' U2' R' U2 R U2 R' U' R2",
          "R2' U R U2' R' U2' R U2 R U2' R' U' R' U' R2",
          "R2 U' R' U2 R U2 R' U2' R' U2 R U R U R2'",
          "R2 U' R' U' R' U2' R U2 R U2' R' U2' R U R2'",
          "R2' U' R2 U R U R' U' R2' U R2 U R U' R'",
          "R' U' R U R2 U R2' U' R' U R U R2 U' R2'",
          "R U R2 U R2' U2 R2' U R2 U R2 U' R' U' R2' U R2'",
          "R2 U' R2 U R U R2 U R2' U' R2 U' R2 U' R2' U R2'",
          "R2 U' R2 U R U R2' U' R2' U' R2 U2' R2 U' R2' U' R'",
          "R2 U' R2 U R2' U R2' U R2 U' R2' U' R' U' R2' U R2'",
          "R2 U' R2' U R2 U R U R' U' R2' U' R2 U R U' R2",
          "R2' U R' U' R2' U R2 U R U' R' U' R2' U' R2 U R2'",
          "R2' U' R' U R U R2 U R2' U' R2 U' R2 U' R U R2",
          "R2' U' R' U R2' U R2' U R2 U' R2' U' R' U' R U R2",
          "R2 U R U' R2 U' R2 U' R2' U R2 U R U R' U' R2'",
          "R2 U R U' R' U' R2' U' R2 U R2' U R2' U R' U' R2'",
          "R2 U' R U R2 U' R2' U' R' U R U R2 U R2' U' R2",
          "R2' U R2 U' R2' U' R' U' R U R2 U R2' U' R' U R2'",
          "R2' U R2' U' R2 U' R2 U' R2' U R2 U R U R2 U' R2",
          "R2' U R2' U' R' U' R2 U R2 U R2' U2 R2' U R2",
        ],
      },
      {
        name: 'T2+',
        scr: [
          "R U' R U R' U' R' U R U2' R U2 R' U2 R' U' R U2 R'",
          "R' U2 R U2' R2' U2' R2' U2 R2 U' R2' U' R2 U R2 U' R'",
          "R' U R U2' R U2 R' U2 R' U2 R U2' R U2 R' U2 R U2 R'",
          "R' U R U2' R U2 R' U' R U2' R' U2 R' U2' R U' R U2 R'",
          "R' U2' R' U2 R U R U R U R2' U2 R2 U2 R2 U2' R U2 R",
          "R' U' R U' R2' U' R U R U2' R' U2' R' U2 R2 U2' R'",
          "R' U' R2 U R2' U R2 U2' R2' U2 R U2 R' U2' R U R'",
          "R U2 R' U R U2' R' U2 R' U' R U2' R' U2' R U R U' R'",
          "R U2 R' U R' U2' R2 U R2 U' R2' U' R2 U2 R2 U2' R' U2' R",
          "R U2 R' U2 R' U2 R2' U2 R2 U R U' R2 U2' R2' U2' R U R'",
          "R U2' R U2 R2' U' R' U' R2 U' R2' U2 R2 U R U2 R' U2' R'",
          "R U2' R U2' R' U' R' U2 R U2 R U2' R2' U2' R2 U2' R' U2 R'",
          "R U2' R2 U R2' U R2 U2' R2 U' R U2' R2 U R2' U R2 U2' R2",
          "R U2' R2' U R2 U R2' U2' R U' R U2' R2' U R2 U R2' U2' R",
          "R U2' R' U2' R2 U2 R2 U' R2' U' R2 U R2 U2' R' U R' U2 R",
          "R U' R' U2' R' U' R2' U2' R U2 R U R2' U2' R2 U' R",
          "R2 U2 R' U2 R' U2' R U' R' U R U2 R U2' R' U' R U' R2'",
          "R2 U2' R U R' U' R2' U' R U2' R U R U' R2' U2 R U2' R2'",
          "R2 U2' R2 U R2' U R2 U2' R U' R2 U2' R2 U R2' U R2 U2' R",
          "R2 U2' R2 U2 R' U' R' U R2 U2' R U' R2 U' R U R' U2' R2'",
        ], //T2+
      },
      {
        name: 'T2-',
        scr: [
          "R' U R' U' R U R U' R' U2 R' U2' R U2' R U R' U2' R",
          "R U R2' U' R2 U' R2' U2 R2 U2' R' U2' R U2 R' U' R U' R'",
          "R U R' U R2 U R' U' R' U2 R U2 R U2' R2' U2 R U' R'",
          "R U2 R U2' R' U' R' U' R' U' R2 U2' R2' U2' R2' U2 R' U2' R'",
          "R U' R' U2 R' U2' R U R' U2 R U2' R U2 R' U R' U2' R",
          "R U' R' U2 R' U2' R U2' R U2' R' U2 R' U2' R U2' R' U2' R",
          "R U2' R' U2 R2 U2 R2 U2' R2' U R2 U R2' U' R2' U R U' R'",
          "R U R' U2 R2' U' R2 U' R U' R' U2 R2' U' R2 U' R2' U2' R2",
          "R2 U2 R U' R' U R2' U R' U2 R2' U' R U R U2' R2' U2 R2'",
          "R2 U2 R2 U2 R U2' R U R2 U2 R2 U2' R2' U' R2' U2' R2' U2' R2'",
          "R2 U2 R' U2' R2 U R' U' R' U2 R' U R2 U R U' R' U2 R2'",
          "R2' U2 R2' U2' R U R U' R2' U2 R' U R2' U R' U' R U2 R2",
          "R2' U2 R2' U' R2 U' R2' U2 R' U R2' U2 R2' U' R2 U' R2' U2 R'",
          "R2' U2 R' U' R U R2 U R' U2 R' U' R' U R2 U2' R' U2 R2",
          "R2' U2' R U2' R U2 R' U R U' R' U2' R' U2 R U R' U R2",
          "R' U R U2 R U R2 U2 R' U2' R' U' R2 U2 R2' U R' U' R'",
          "R' U2 R U2 R2' U2' R2' U R2 U R2' U' R2' U2 R U' R U2' R'",
          "R' U2 R2 U' R2' U' R2 U2 R' U R' U2 R2 U' R2' U' R2 U2 R'",
          "R' U2 R2' U' R2 U' R2' U2 R2' U R' U2 R2' U' R2 U' R2' U2 R2'",
          "R' U2 R' U2 R U R U2' R' U2' R' U2 R2 U2 R2' U2 R U2' R",
        ],
      },
      {
        name: 'T3+',
        scr: [
          "R2 U R2' U2' R2 U R2' U' R2 U R2' U2' R2 U R2'",
          "R2 U2' R2' U2 R' U2 R2' U R2 U2 R U2 R2 U2' R2'",
          "R2 U2' R2' U2' R2 U R2' U R2 U' R2' U' R2 U' R2'",
          "R2 U' R2' U' R2 U' R2' U R2 U R2' U2' R2 U2' R2'",
          "R2' U R2 U2' R2' U R2 U' R2' U R2 U2' R2' U R2",
          "R2' U2' R2 U2 R U2 R2 U R2' U2 R' U2 R2' U2' R2",
          "R2' U2' R2 U2' R2' U R2 U R2' U' R2 U' R2' U' R2",
          "R2' U' R2 U' R2' U' R2 U R2' U R2 U2' R2' U2' R2",
          "R2 U2' R2' U' R2 U R2' U2 R2 U2 R2' U2' R2 U2 R2'",
          "R2' U2' R2 U' R2' U R2 U2 R2' U2 R2 U2' R2' U2 R2",
          "R U2 R' U2' R U2 R2 U2 R2' U R2 U2 R2 U2 R U2' R'",
          "R U2 R' U2' R U2 R2' U2 R2 U R2' U2 R U2 R U2' R'",
          "R2 U2 R2' U2' R2 U2 R2 U2 R2' U R2 U2 R U2 R2 U2' R2'",
          "R2 U2 R2' U2' R2 U2 R2' U2 R2 U2' R U2' R2 U' R2' U2' R2",
          "R2' U2 R2 U2' R2' U2 R2 U2 R2' U2' R' U2' R2' U' R2 U2' R2'",
          "R2' U2 R2 U2' R2' U2 R2' U2 R2 U R2' U2 R' U2 R2' U2' R2",
          "R' U R U R2' U' R2 U2' R2' U2 R U' R U' R2' U2' R2",
          "R2 U2 R U2' R2 U' R2' U2' R2 U' R2 U R2' U' R2 U2' R2'",
          "R2' U2 R' U2' R2' U' R2 U2' R2' U' R2' U R2 U' R2' U2' R2",
          "R2 U2' R2' U2 R' U2 R2' U R2 U2 R2' U2 R2' U2' R2 U2 R2'",
        ],
      },
      {
        name: 'T3-',
        scr: [
          "R2 U R2' U R2 U R2' U' R2 U' R2' U2 R2 U2 R2'",
          "R2 U2 R2' U2 R2 U' R2' U' R2 U R2' U R2 U R2'",
          "R2 U2 R2' U2' R' U2' R2' U' R2 U2' R U2' R2 U2 R2'",
          "R2 U' R2' U2 R2 U' R2' U R2 U' R2' U2 R2 U' R2'",
          "R2' U R2 U R2' U R2 U' R2' U' R2 U2 R2' U2 R2",
          "R2' U2 R2 U2 R2' U' R2 U' R2' U R2 U R2' U R2",
          "R2' U2 R2 U2' R U2' R2 U' R2' U2' R' U2' R2' U2 R2",
          "R2' U' R2 U2 R2' U' R2 U R2' U' R2 U2 R2' U' R2",
          "R2 U2 R2' U R2 U' R2' U2' R2 U2' R2' U2 R2 U2' R2'",
          "R2' U2 R2 U R2' U' R2 U2' R2' U2' R2 U2 R2' U2' R2",
          "R U' R' U' R2 U R2' U2 R2 U2' R' U R' U R2 U2 R2'",
          "R2 U2' R2' U2 R2 U2' R2 U2' R2' U' R2 U2' R U2' R2 U2 R2'",
          "R2 U2' R2' U2 R2 U2' R2' U2' R2 U2 R U2 R2 U R2' U2 R2",
          "R2' U2' R2 U2 R2' U2' R2 U2' R2' U2 R' U2 R2' U R2 U2 R2'",
          "R2' U2' R2 U2 R2' U2' R2' U2' R2 U' R2' U2' R' U2' R2' U2 R2",
          "R' U2' R U2 R' U2' R2 U2' R2' U' R2 U2' R' U2' R' U2 R",
          "R' U2' R U2 R' U2' R2' U2' R2 U' R2' U2' R2' U2' R' U2 R",
          "R2 U2' R U2 R2 U R2' U2 R2 U R2 U' R2' U R2 U2 R2'",
          "R2' U2' R' U2 R2' U R2 U2 R2' U R2' U' R2 U R2' U2 R2",
          "R U2 R' U2' R2' U2' R2' U' R2 U2' R2' U2' R' U2 R U2' R'",
        ],
      },
      {
        name: 'T4+',
        scr: [
          "R U R' U R2 U2' R2' U' R2 U2' R2' U2' R U' R'",
          "R U R' U R2' U2' R2 U' R2' U2' R2 U2' R U' R'",
          "R2 U R2' U R2 U2' R2' U' R2 U2' R2' U2' R2 U' R2'",
          "R2 U R2' U R2' U2' R2 U' R2' U2' R2 U2' R2 U' R2'",
          "R2' U R2 U R2 U2' R2' U' R2 U2' R2' U2' R2' U' R2",
          "R2' U R2 U R2' U2' R2 U' R2' U2' R2 U2' R2' U' R2",
          "R2 U2 R2 U R2' U' R2' U R2 U2 R2' U' R' U' R",
          "R' U R U R2 U2' R2' U' R2 U R2 U' R2' U2' R2'",
          "R U R' U2 R2 U2 R2' U R2 U2 R2' U' R U' R'",
          "R U R' U2 R2' U2 R2 U R2' U2 R2 U' R U' R'",
          "R2 U R2' U2 R2 U2 R2' U R2 U2 R2' U' R2 U' R2'",
          "R2 U R2' U2 R2' U2 R2 U R2' U2 R2 U' R2 U' R2'",
          "R2' U R2 U2 R2 U2 R2' U R2 U2 R2' U' R2' U' R2",
          "R2' U R2 U2 R2' U2 R2 U R2' U2 R2 U' R2' U' R2",
          "R2 U2 R2' U2 R2' U R' U' R2' U' R2 U R U' R' U R2'",
          "R2' U2 R U2' R' U' R U2' R' U2 R' U2' R2' U R2 U R2'",
          "R2' U2' R U2 R' U R U2 R' U2' R' U2' R2' U R2 U R2'",
          "R' U2 R U2' R' U' R U2' R' U2 R' U2' R2 U R2' U R2",
          "R' U2' R U2 R' U R U2 R' U2' R' U2' R2 U R2' U R2",
          "R U2 R2 U R2' U2 R U2 R2' U R2 U2 R2' U' R2' U' R2",
        ],
      },
      {
        name: 'T4-',
        scr: [
          "R2 U' R2' U' R2 U2 R2' U R2 U2 R2' U2 R2 U R2'",
          "R2 U' R2' U' R2' U2 R2 U R2' U2 R2 U2 R2 U R2'",
          "R2' U' R2 U' R2 U2 R2' U R2 U2 R2' U2 R2' U R2",
          "R2' U' R2 U' R2' U2 R2 U R2' U2 R2 U2 R2' U R2",
          "R' U' R U' R2 U2 R2' U R2 U2 R2' U2 R'",
          "R' U' R U' R2' U2 R2 U R2' U2 R2 U2 R'",
          "R2 U' R2' U2' R2 U2' R2' U' R2 U2' R2' U R2 U R2'",
          "R2 U' R2' U2' R2' U2' R2 U' R2' U2' R2 U R2 U R2'",
          "R2' U' R2 U2' R2 U2' R2' U' R2 U2' R2' U R2' U R2",
          "R2' U' R2 U2' R2' U2' R2 U' R2' U2' R2 U R2' U R2",
          "R' U' R U2' R2 U2' R2' U' R2 U2' R2' U R'",
          "R' U' R U2' R2' U2' R2 U' R2' U2' R2 U R'",
          "R U' R' U' R2' U2 R2 U R2' U' R2' U R2 U2 R2",
          "R2' U2' R2' U' R2 U R2 U' R2' U2' R2 U R U R'",
          "R U2 R' U2' R U' R' U2' R U2 R U2 R2' U' R2 U' R2'",
          "R U2' R' U2 R U R' U2 R U2' R U2 R2' U' R2 U' R2'",
          "R2 U2 R' U2' R U' R' U2' R U2 R U2 R2 U' R2' U' R2",
          "R2 U2' R' U2 R U R' U2 R U2' R U2 R2 U' R2' U' R2",
          "R2' U2' R2 U2' R2 U' R U R2 U R2' U' R' U R U' R2",
          "R2 U R2' U R2 U2' R' U2 R' U2' R U' R' U2' R U2 R'",
        ],
      },
    ],
  },

  {
    cat: 'U',
    cases: [
      {
        name: 'U1+',
        scr: [
          "R U R U R2' U R U' R U' R' U2 R' U' R U2' R'",
          "R' U R U' R' U2 R' U' R U' R U R2' U R U2' R",
          "R' U2' R U2' R U R' U R' U' R2 U' R' U R' U2' R",
          "R U R' U R2' U R U2' R2 U' R' U R' U2 R' U' R2",
          "R2 U' R' U2 R' U R' U' R2 U2' R U R2' U R' U R",
          "R U R' U' R' U2 R' U R2 U R U' R2 U' R U2' R",
          "R U2' R U' R2 U' R U R2 U R' U2 R' U' R'",
          "R2 U2' R U' R2' U' R' U R2' U R' U2 R2' U' R U R'",
          "R' U R U' R2' U2 R' U R2' U R' U' R2' U' R U2' R2",
          "R U2' R U R2' U R U' R U' R' U2 R' U' R U R'",
          "R U2' R' U R' U' R2 U' R' U R' U R U2' R U2' R'",
          "R' U2' R U' R' U2 R' U' R U' R U R2' U R U R",
          "R U2 R U R' U R' U' R2 U' R' U R' U R U R'",
          "R2 U2 R U R' U R' U' R2 U' R' U R' U R U R2'",
          "R2' U2 R U R' U R' U' R2 U' R' U R' U R U R2",
          "R' U2 R U R' U R' U' R2 U' R' U R' U R",
          "R U R U R' U R' U' R2 U' R' U R' U R U2 R'",
          "R2 U R U R' U R' U' R2 U' R' U R' U R U2 R2'",
          "R2' U R U R' U R' U' R2 U' R' U R' U R U2 R2",
          "R' U R U R' U R' U' R2 U' R' U R' U R U2 R",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          5,
          1,
          2,
          1,
          2,
          3,
          3,
          3,
          4,
          4,
          4,
          5,
          2,
          5,
        ],
      }, //A
      {
        name: 'U1-',
        scr: [
          "R U2 R' U2 R' U' R U' R U R2' U R U' R U2 R'",
          "R U' R' U R U2' R U R' U R' U' R2 U' R' U2 R'",
          "R' U' R' U' R2 U' R' U R' U R U2' R U R' U2 R",
          "R2' U R U2' R U' R U R2' U2 R' U' R2 U' R U' R'",
          "R' U' R U' R2 U' R' U2 R2' U R U' R U2' R U R2'",
          "R U' R' U' R U' R U R2' U R U' R U' R' U2' R'",
          "R2 U' R' U' R U' R U R2' U R U' R U' R' U2' R2'",
          "R2' U' R' U' R U' R U R2' U R U' R U' R' U2' R2",
          "R' U' R' U' R U' R U R2' U R U' R U' R' U2' R",
          "R U2' R' U' R U' R U R2' U R U' R U' R' U' R'",
          "R2 U2' R' U' R U' R U R2' U R U' R U' R' U' R2'",
          "R2' U2' R' U' R U' R U R2' U R U' R U' R' U' R2",
          "R' U2' R' U' R U' R U R2' U R U' R U' R' U' R",
          "R U2 R' U R U2' R U R' U R' U' R2 U' R' U' R'",
          "R' U2 R U' R U R2' U R U' R U' R' U2 R' U2 R",
          "R' U2 R' U' R2 U' R' U R' U R U2' R U R' U' R",
          "R U' R' U R2 U2' R U' R2 U' R U R2 U R' U2 R2'",
          "R2' U2 R' U R2 U R U' R2 U' R U2' R2 U R' U' R",
          "R' U2 R' U R2' U R' U' R2' U' R U2' R U R U' R'",
          "R' U' R U R U2' R U' R2' U' R' U R2' U R' U2 R'",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          2,
          1,
          2,
          5,
          2,
          3,
          3,
          3,
          4,
          4,
          4,
          5,
          1,
          5,
        ],
      },
      {
        name: 'U2+',
        scr: [
          "R U2 R U R2' U R U' R U' R' U2 R' U' R U2 R'",
          "R U2 R' U R' U' R2 U' R' U R' U R U2' R U' R'",
          "R' U2 R U' R' U2 R' U' R U' R U R2' U R U2 R",
          "R' U' R U2' R U R' U R' U' R2 U' R' U R' U2 R",
          "R2 U R U' R' U2' R2' U2' R2 U' R2' U' R2' U R' U' R2'",
          "R2 U2' R2' U2' R' U' R U R2 U' R2' U' R' U R2' U' R2'",
          "R2 U2' R2' U' R2' U2 R2' U2' R' U' R U2' R2 U2 R' U' R2'",
          "R2' U2' R2 U2' R2' U' R' U2 R2 U2' R U' R' U2' R2' U2 R2'",
          "R2' U2' R2 U' R2' U' R2' U R' U' R2' U' R2 U R U' R'",
          "R U R' U' R2' U' R U2' R U R U' R2' U2 R' U R2",
          "R U2 R2' U' R U R U2' R U' R2' U' R' U R2' U R2'",
          "R U' R' U2' R2' U2' R2 U' R2' U' R2' U R' U' R2' U' R2",
          "R2 U2 R' U' R' U R2 U2' R U' R2 U' R U R2 U R2",
          "R2' U' R' U2 R2 U2' R U' R' U2' R2' U2 R2' U' R2' U2' R2",
          "R' U R U' R2 U' R U2' R2 U R' U' R' U2 R' U R2'",
          "R' U' R U R2 U' R2' U' R' U R2' U' R2' U' R2 U2' R2'",
          "R2 U R2 U R U' R2 U' R U2' R2 U R' U' R' U2 R2",
          "R2 U R' U2 R2' U' R U R U2' R U' R2' U' R'",
          "R2' U R2' U R' U' R2' U' R U2' R U R U' R2' U2 R",
          "R2' U R' U2 R' U' R' U R2 U2' R U' R2 U' R U R'",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          1,
          2,
          5,
          2,
          3,
          3,
          3,
          4,
          2,
          4,
          5,
          4,
          5,
        ],
      },
      {
        name: 'U2-',
        scr: [
          "R U R' U2 R' U' R U' R U R2' U R U' R U2' R'",
          "R U2' R' U R U2' R U R' U R' U' R2 U' R' U2' R'",
          "R' U2' R U' R U R2' U R U' R U' R' U2 R'",
          "R' U2' R' U' R2 U' R' U R' U R U2' R U R' U2' R",
          "R2 U R2 U2' R2 U2 R U R' U2 R2' U2' R U R2 U2 R2'",
          "R2 U2 R U R' U' R2' U R2 U R U' R2 U R2 U R2'",
          "R2' U R2 U R U' R2 U R2 U R2' U2 R2 U2 R U R'",
          "R2' U R2 U R2 U' R U R2 U R2' U' R' U R U2 R2",
          "R2' U2 R2 U R U2' R2' U2 R' U R U2 R2 U2' R2 U R2",
          "R2 U R U' R2 U R2 U R2' U2 R2 U2 R U R' U' R2'",
          "R2 U R2 U' R U R2 U R2' U' R' U R U2 R2 U2 R2'",
          "R2 U2' R2 U2 R U R' U2 R2' U2' R U R2 U2 R2' U2 R2",
          "R2 U' R U2' R U R U' R2' U2 R' U R2' U R' U' R",
          "R2 U' R2 U' R U R2 U R' U2 R' U' R' U R2 U2' R'",
          "R2' U' R U2' R2 U R' U' R' U2 R' U R2 U R U' R'",
          "R2' U' R2' U' R' U R2' U R' U2 R2' U' R U R U2' R2'",
          "R U R' U' R2' U R2 U R U' R2 U R2 U R2' U2 R2",
          "R U' R' U R2' U R' U2 R2' U' R U R U2' R U' R2",
          "R2 U R U2' R2' U2 R' U R U2 R2 U2' R2 U R2 U2 R2'",
          "R2' U2' R U R U' R2' U2 R' U R2' U R' U' R2' U' R2'",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          1,
          2,
          4,
          2,
          3,
          3,
          3,
          4,
          5,
          4,
          5,
          2,
          5,
        ],
      },
    ],
  }, //A
  {
    cat: 'V',
    cases: [
      {
        name: 'V1+',
        scr: [
          "R' U2' R U' R U R' U2 R U2 R' U2 R' U2' R",
          "R U2' R U R U2 R2' U' R2 U' R2 U2 R2 U2 R2'",
          "R' U' R U2 R U R' U2 R' U2' R2 U' R' U R' U2' R",
          "R2' U R2' U2 R U2 R' U2 R U R U' R2 U2' R U R'",
          "R U R U R2 U R2 U' R2' U' R U R2' U R2 U' R2' U2' R'",
          "R U R2 U' R U R2' U R2 U' R2 U' R2 U R2 U R2' U2' R'",
          "R2 U R2 U R' U R U' R U R2' U' R U' R' U R' U2' R2'",
          "R2 U2 R' U2' R2 U2' R U2' R2 U2 R2 U2' R2 U' R2' U2 R U2' R2'",
          "R2 U2' R2' U' R2 U2' R2' U R2 U2' R2' U2 R2 U R2' U2' R2 U2 R2'",
          "R2 U2' R2' U' R2 U2' R2' U R2' U2' R2 U2 R2' U R2 U2' R2' U2 R2",
          "R2 U2' R2' U' R2 U2' R2' U' R2 U2 R2' U2' R2 U2' R2' U2' R2 U2 R2'",
          "R2 U2' R2' U' R2 U2' R2' U' R2' U2 R2 U2' R2' U2' R2 U2' R2' U2 R2",
          "R2 U' R2' U2 R U R' U2 R' U2' R2 U' R' U R' U2 R2' U R2'",
          "R2' U2' R2 U' R2' U2' R2 U R2 U2' R2' U2 R2 U R2' U2' R2 U2 R2'",
          "R2' U2' R2 U' R2' U2' R2 U R2' U2' R2 U2 R2' U R2 U2' R2' U2 R2",
          "R2' U2' R2 U' R2' U2' R2 U' R2 U2 R2' U2' R2 U2' R2' U2' R2 U2 R2'",
          "R2' U2' R2 U' R2' U2' R2 U' R2' U2 R2 U2' R2' U2' R2 U2' R2' U2 R2",
          "R2' U' R2 U2 R U R' U2 R' U2' R2 U' R' U R' U2 R' U R2",
          "R' U R U2 R2' U' R2 U' R U R2 U R2' U2' R' U R' U2' R",
          "R2 U2 R2' U2' R2 U' R U R' U' R2' U2 R2 U R U' R' U2' R2'",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          4,
          5,
          4,
          2,
          3,
          2,
          1,
          2,
          3,
          3,
          4,
          5,
          5,
        ],
      },
      {
        name: 'V1-',
        scr: [
          "R U2 R' U R' U' R U2' R' U2' R U2' R U2 R'",
          "R' U2 R' U' R' U2' R2 U R2' U R2' U2' R2' U2' R2",
          "R U R' U2' R' U' R U2' R U2 R2' U R U' R U2 R'",
          "R2 U' R2 U2' R' U2' R U2' R' U' R' U R2' U2 R' U' R",
          "R U' R' U2' R2 U R2' U R' U' R2' U' R2 U2 R U' R U2 R'",
          "R2 U R2' U2' R' U' R U2' R U2 R2' U R U' R U2' R U' R2'",
          "R2 U2 R2' U R2 U2 R2' U R2 U2' R2' U2 R2 U2 R2' U2 R2 U2' R2'",
          "R2 U2 R2' U R2 U2 R2' U R2' U2' R2 U2 R2' U2 R2 U2 R2' U2' R2",
          "R2 U2 R2' U R2 U2 R2' U' R2 U2 R2' U2' R2 U' R2' U2 R2 U2' R2'",
          "R2 U2 R2' U R2 U2 R2' U' R2' U2 R2 U2' R2' U' R2 U2 R2' U2' R2",
          "R2' U R2 U2' R' U' R U2' R U2 R2' U R U' R U2' R2 U' R2",
          "R2' U2 R2 U R2' U2 R2 U R2 U2' R2' U2 R2 U2 R2' U2 R2 U2' R2'",
          "R2' U2 R2 U R2' U2 R2 U R2' U2' R2 U2 R2' U2 R2 U2 R2' U2' R2",
          "R2' U2 R2 U R2' U2 R2 U' R2 U2 R2' U2' R2 U' R2' U2 R2 U2' R2'",
          "R2' U2 R2 U R2' U2 R2 U' R2' U2 R2 U2' R2' U' R2 U2 R2' U2' R2",
          "R2' U2' R U2 R2' U2 R' U2 R2' U2' R2' U2 R2' U R2 U2' R' U2 R2",
          "R2' U' R2' U' R U' R' U R' U' R2 U R' U R U' R U2 R2",
          "R' U' R2' U R' U' R2 U' R2' U R2' U R2' U' R2' U' R2 U2 R",
          "R' U' R' U' R2' U' R2' U R2 U R' U' R2 U' R2' U R2 U2 R",
          "R2' U2' R2 U' R U R' U' R2' U2 R2 U R U' R' U' R2' U R2",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          2,
          3,
          3,
          4,
          5,
          4,
          3,
          4,
          2,
          1,
          2,
          5,
          5,
        ],
      },
      {
        name: 'V2+',
        scr: [
          "R2 U2' R2' U2' R2' U R2' U R2 U2' R' U' R' U2 R'",
          "R' U2 R U2' R U2' R' U2' R U' R' U R' U2 R",
          "R' U2 R U' R U R2' U2 R U2' R U' R' U2' R'",
          "R U' R' U2 R2' U R' U' R' U2' R U2' R' U2' R2 U' R2",
          "R U' R U2 R' U R' U' R2 U2' R2' U R U R' U2' R U2 R'",
          "R U' R' U R' U2 R2' U2' R U2' R' U2 R' U2 R2' U2' R' U2' R",
          "R U' R' U' R U' R' U2' R U2' R' U' R U2' R' U2 R U R'",
          "R U' R' U' R U' R' U' R U2 R' U R U2 R' U2' R U R'",
          "R2 U2 R2' U R2 U R2' U R2 U R2' U2' R2 U' R2' U2 R2 U R2'",
          "R2 U' R2' U R U2' R U' R' U R' U' R U2' R' U2 R2 U R2'",
          "R2' U R2 U2 R U2 R2 U' R' U R2 U R2' U' R2' U' R' U' R'",
          "R2' U2 R2 U R2' U R2 U R2' U R2 U2' R2' U' R2 U2 R2' U R2",
          "R2' U2' R2' U R2 U' R2 U R2 U' R U R' U' R2 U2 R U2' R",
          "R' U R U' R U2' R' U2' R U' R' U R' U' R U' R' U' R",
          "R2 U2 R2' U2' R2 U R2' U2' R2 U2 R2' U' R2 U2 R2' U R2 U2 R2'",
          "R2 U2 R2' U2' R2 U R2' U2' R2 U2 R2' U' R2' U2 R2 U R2' U2 R2",
          "R2 U2 R2' U2' R2 U' R2' U2 R2 U2' R2' U R2 U2 R2' U R2 U2 R2'",
          "R2 U2 R2' U2' R2 U' R2' U2 R2 U2' R2' U R2' U2 R2 U R2' U2 R2",
          "R2' U2 R2 U2' R2' U R2 U2' R2' U2 R2 U' R2 U2 R2' U R2 U2 R2'",
          "R2' U2 R2 U2' R2' U R2 U2' R2' U2 R2 U' R2' U2 R2 U R2' U2 R2",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          3,
          4,
          3,
          2,
          3,
          4,
          4,
          5,
          2,
          1,
          2,
          5,
          5,
        ],
      },
      {
        name: 'V2-',
        scr: [
          "R2' U2 R2 U2 R2 U' R2 U' R2' U2 R U R U2' R",
          "R U2' R' U2 R' U2 R U2 R' U R U' R U2' R'",
          "R U2' R' U R' U' R2 U2' R' U2 R' U R U2 R U' R'",
          "R' U R U2' R2 U' R U R U2 R' U2 R U2 R2' U R2'",
          "R U' R' U R' U2 R U2 R' U R U' R U R' U R U R'",
          "R2 U2 R2 U' R2' U R2' U' R2' U R' U' R U R2' U2' R' U2 R'",
          "R2 U2' R2' U' R2 U' R2' U' R2 U' R2' U2 R2 U R2' U2' R2 U' R2'",
          "R2 U' R2' U2' R' U2' R2' U R U' R2' U' R2 U R2 U R",
          "R2' U R2 U' R' U2 R' U R U' R U R' U2 R U2' R2' U' R2",
          "R2' U2' R2 U' R2' U' R2 U' R2' U' R2 U2 R2' U R2 U2' R2' U' R2",
          "R' U R U R' U R U R' U2' R U' R' U2' R U2 R' U' R",
          "R' U R U R' U R U2 R' U2 R U R' U2 R U2' R' U' R",
          "R' U R U' R U2' R2 U2 R' U2 R U2' R U2' R2 U2 R U2 R'",
          "R' U R' U2' R U' R U R2' U2 R2 U' R' U' R U2 R' U2' R",
          "R' U2' R2' U' R' U R2' U R2' U' R2 U2 R2' U2' R' U' R U R2'",
          "R' U' R' U2' R2' U2 R2 U' R2' U R2' U R' U' R2' U2' R2 U R2",
          "R U2' R' U R' U2' R2' U R2 U R U' R2 U' R2' U2 R U R'",
          "R2 U R' U2 R' U R' U' R2 U2' R' U2 R' U R U2 R2 U' R2'",
          "R2 U2 R2' U2' R2 U R2' U2 R2 U2' R2' U R2 U2' R2' U' R2 U2' R2'",
          "R2 U2 R2' U2' R2 U R2' U2 R2 U2' R2' U R2' U2' R2 U' R2' U2' R2",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          4,
          5,
          4,
          1,
          2,
          2,
          3,
          4,
          3,
          2,
          3,
          5,
          5,
        ],
      },
      {
        name: 'V3+',
        scr: [
          "R' U' R' U' R U' R2 U R2 U R U R U2' R U' R'",
          "R2' U2 R2 U' R U2' R2' U2 R' U R U2 R2 U2' R2 U2' R2",
          "R2 U R U' R2 U' R2 U2 R2' U' R2 U' R U R' U' R2'",
          "R U R2' U2 R2 U2 R2' U R U2 R U2' R' U2' R U' R'",
          "R' U R' U' R2 U' R U R U' R' U R U R2' U' R'",
          "R U2 R2' U R2 U2' R U2 R2 U' R2 U R U2' R' U' R'",
          "R U2 R2' U2 R2 U2 R U2' R2 U2' R2 U R U2' R' U' R'",
          "R U2' R' U2 R U' R U2' R' U' R' U' R U R U2' R2'",
          "R2' U R U R' U' R2 U2 R U2' R U' R' U R' U2 R'",
          "R2' U2 R2' U R' U' R2' U2 R2 U R U' R' U' R2' U R2",
          "R2' U2' R U R U' R2' U' R2 U R2' U2 R2 U2' R' U' R",
          "R2' U2' R2' U R2' U' R2 U2 R2 U2' R U R2 U' R2 U R2",
          "R' U2' R2 U R' U' R' U2 R' U2 R2 U R U' R2 U2' R2",
          "R U2' R U2 R2 U2' R' U' R U2' R U' R' U' R U R2' U2' R2'",
          "R2 U2' R2 U' R' U' R U R2' U2' R2' U2' R U2' R U2 R U2' R2'",
          "R2' U2' R2 U R' U2 R U2 R' U2' R' U2 R U R U2' R2' U2' R2",
          "R2' U2' R2 U R' U' R' U2' R U2 R U2' R' U2' R U2' R2' U2' R2",
          "R' U R U R U R2' U' R2 U' R2 U2 R U2 R2 U2' R2 U2' R2",
          "R' U R U2 R' U' R U' R' U R' U2' R2 U R2' U R U' R",
          "R' U2' R U2' R U2 R' U' R' U' R' U2 R U2 R2 U2' R2 U2' R2",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          4,
          5,
          3,
          1,
          2,
          4,
          3,
          4,
          2,
          2,
          3,
          5,
          5,
        ],
      },
      {
        name: 'V3-',
        scr: [
          "R U R U R' U R2' U' R2' U' R' U' R' U2 R'",
          "R' U' R2 U2' R2' U2' R2 U' R' U2' R' U2 R U2 R'",
          "R2' U' R' U R2' U R2' U2' R2 U R2' U R' U' R U R2",
          "R2 U2' R2' U R' U2 R2 U2' R U' R' U2' R2' U2 R2' U2 R2'",
          "R U2 R2' U' R U R U2' R U2' R2' U' R' U R2' U2 R2'",
          "R2 U2 R2 U' R2 U R2' U2' R2' U2 R' U' R2' U R2' U' R2'",
          "R2 U2 R' U' R' U R2 U R2' U' R2 U2' R2' U2 R U R'",
          "R2 U2' R2 U' R U R2 U2' R2' U' R' U R U R2 U' R2'",
          "R2 U' R' U' R U R2' U2' R' U2 R' U R U' R U2' R",
          "R' U2 R U2' R' U R' U2 R U R U R' U' R' U2 R2",
          "R' U2' R2 U2' R2' U2' R' U2 R2' U2 R2' U' R' U2 R",
          "R' U2' R2 U' R2' U2 R' U2' R2' U R2' U' R' U2 R",
          "R U' R U R2' U R' U' R' U R U' R' U' R2",
          "R' U2 R' U2' R2' U2 R U R' U2 R' U R U R' U' R2 U2 R2",
          "R U2 R' U' R U2 R2' U' R2 U' R2' U' R2 U2 R2' U R2 U' R'",
          "R U2' R U2 R' U R U2 R2' U R' U' R2 U2' R' U2 R'",
          "R U2' R2' U' R2 U2' R2' U2 R U' R U2 R2' U' R2 U' R2'",
          "R U' R2' U' R2 U R2' U' R2' U' R' U2' R2' U2 R U' R2 U2 R2'",
          "R2 U2 R2' U' R2 U2 R2' U' R2 U' R2' U' R2 U2 R2' U R2 U' R2'",
          "R2 U2' R2 U' R2' U2' R2 U2 R U' R U2 R2' U' R2 U' R2'",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          3,
          4,
          4,
          2,
          3,
          2,
          4,
          5,
          3,
          1,
          2,
          5,
          5,
        ],
      },
      {
        name: 'V4+',
        scr: [
          "R U R' U2 R' U' R' U' R2' U' R2' U R' U R U R",
          "R U R' U2 R U2 R' U2' R' U' R2 U2' R2' U2' R2 U' R'",
          "R2 U R U' R' U R2' U R2 U2' R2' U R2' U R' U' R2'",
          "R2' U2 R2' U2 R2' U2' R' U' R U2' R2 U2 R' U R2' U2' R2",
          "R U R U2 R' U' R2' U R2' U2' R' U2 R2' U' R2 U2' R'",
          "R U R U2 R' U' R2' U2 R2' U2 R' U2' R2' U2' R2 U2' R'",
          "R U R2 U' R' U' R U R' U' R' U R2' U R U' R",
          "R2' U' R2 U R U R' U' R2' U2' R2 U R U' R2 U2' R2",
          "R2' U' R2' U R2' U' R' U2 R2' U2' R2' U R2 U' R2 U2 R2",
          "R2 U2 R' U' R' U R U R U2 R' U R' U2' R U2 R'",
          "R2' U2 R2' U R' U' R2' U2' R U2' R U R U' R2' U2 R",
          "R U2' R U' R U R' U2 R' U2' R2' U R U' R' U' R2",
          "R' U R U2 R2' U2' R2 U' R2' U R2 U R' U' R' U2 R2",
          "R2 U2 R2 U' R' U R U R' U2 R' U R U2 R2' U2' R' U2 R'",
          "R2 U2 R2' U R2 U' R2' U R2 U' R2 U2' R2' U' R2 U2' R2' U2 R2'",
          "R2 U2 R2' U R2 U' R2' U R2 U' R2' U2' R2 U' R2' U2' R2 U2 R2'",
          "R2 U2' R U2' R U R U' R U R2' U R' U2 R2' U2 R U' R'",
          "R2' U2 R2 U R2' U' R2 U R2' U' R2 U2' R2' U' R2 U2' R2' U2 R2",
          "R2' U2 R2 U R2' U' R2 U R2' U' R2' U2' R2 U' R2' U2' R2 U2 R2",
          "R' U R U' R2' U2 R2 U2 R' U2' R2 U R2 U2 R2 U2' R U' R'",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          2,
          3,
          4,
          4,
          5,
          2,
          3,
          4,
          3,
          1,
          2,
          5,
          5,
        ],
      },
      {
        name: 'V4-',
        scr: [
          "R' U' R U2' R U R U R2 U R2 U' R U' R' U' R'",
          "R2 U2' R2 U2' R2 U2 R U R' U2 R2' U2' R U' R2 U2 R2'",
          "R2' U' R' U R U' R2 U' R2' U2 R2 U' R2 U' R U R2",
          "R' U' R U2' R' U2' R U2 R U R2' U2 R2 U2 R2'",
          "R U' R' U2' R2 U2 R2' U R2 U' R2' U' R U R U2' R2'",
          "R' U2 R' U R' U' R U2' R U2 R2 U' R' U R U R2'",
          "R2 U2' R2 U' R U R2 U2 R' U2 R' U' R' U R2 U2' R'",
          "R2' U2' R U R U' R' U' R' U2' R U' R U2 R' U2' R",
          "R2 U R2 U' R2 U R U2' R2 U2 R2 U' R2' U R2' U2' R2'",
          "R2 U R2' U' R' U' R U R2 U2 R2' U' R' U R2' U2 R2'",
          "R' U' R2' U R U R' U' R U R U' R2 U' R' U R'",
          "R' U' R' U2' R U R2 U2' R2 U2' R U2 R2 U2 R2' U2 R",
          "R' U' R' U2' R U R2 U' R2 U2 R U2' R2 U R2' U2 R",
          "R2' U2' R2' U R U' R' U' R U2' R U' R' U2' R2 U2 R U2' R",
          "R U2 R2' U' R U2 R' U2' R U2 R U2' R2' U2 R2 U2 R2' U2 R",
          "R U2 R2' U' R2 U2 R' U2' R' U2 R U2' R' U2 R2 U2 R2' U2 R",
          "R U2 R2' U' R' U2 R2' U2' R U2 R' U2' R' U' R2 U2' R U' R",
          "R U2 R' U R' U2' R2 U R2' U R U' R' U' R2 U' R2' U2 R",
          "R' U2' R U' R' U R' U' R U2' R U2' R2' U' R2 U' R2' U R2",
          "R U2 R U2 R2' U R2 U2 R' U' R U R2' U2 R U2' R U' R2'",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          4,
          5,
          3,
          2,
          3,
          4,
          1,
          2,
          2,
          3,
          4,
          5,
          5,
        ],
      },
    ],
  },
  {
    cat: 'W',
    cases: [
      {
        name: 'W',
        scr: [
          "R2 U2' R2' U' R2 U R2' U2 R2 U2 R2' U2 R2 U2' R2'",
          "R2' U2' R2 U' R2' U R2 U2 R2' U2 R2 U2 R2' U2' R2",
          "R2 U2' R2' U2 R2 U R2' U2' R2 U' R2' U R2 U2 R2'",
          "R2' U2' R2 U2 R2' U R2 U2' R2' U' R2 U R2' U2 R2",
          "R' U' R U2' R2' U2' R2 U R' U2' R' U2' R U2 R",
          "R U R' U2 R2 U2 R2' U' R U2 R U2 R' U2' R'",
          "R2 U2 R2' U2' R2 U' R2' U2 R2 U R2' U' R2 U2' R2'",
          "R2' U2 R2 U2' R2' U' R2 U2 R2' U R2 U' R2' U2' R2",
          "R U2 R U2' R' U2' R' U R2 U2' R2' U2' R U' R'",
          "R2 U2 R2' U R2 U' R2' U2' R2 U R2' U2 R2 U2' R2'",
          "R2 U2 R2' U R2 U' R2' U2' R2 U2' R2' U2' R2 U2 R2'",
          "R2' U2 R2 U R2' U' R2 U2' R2' U R2 U2 R2' U2' R2",
          "R2' U2 R2 U R2' U' R2 U2' R2' U2' R2 U2' R2' U2 R2",
          "R2 U2 R2' U2' R2 U2' R2' U2' R2 U' R2' U R2 U2 R2'",
          "R2 U2' R2' U2 R2 U2 R2' U2 R2 U R2' U' R2 U2' R2'",
          "R2' U2 R2 U2' R2' U2' R2 U2' R2' U' R2 U R2' U2 R2",
          "R2' U2' R2 U2 R2' U2 R2 U2 R2' U R2 U' R2' U2' R2",
          "R2 U2' R2' U2 R' U2 R2' U R2 U2 R2' U' R2' U2' R2 U2 R2'",
          "R2 U2' R2' U' R2 U R2' U' R' U2' R2' U' R2 U2' R2' U2 R2'",
          "R2 U2' R2' U' R2 U2' R U2' R2 U2 R2' U' R2 U2' R2' U2 R2",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          4,
          5,
          4,
          3,
          4,
          2,
          2,
          3,
          3,
          1,
          2,
          5,
          5,
        ],
      },
    ],
  },

  {
    cat: 'X',
    cases: [
      {
        name: 'X1',
        scr: [
          "R U R U R2' U R U' R U' R2 U' R2 U' R2' U2 R U' R U' R'",
          "R U R' U R' U2' R2 U R2' U R2' U R' U R' U' R2 U' R' U' R'",
          "R' U' R U' R U2 R2' U' R2 U' R2 U' R U' R U R2' U R",
          "R' U' R' U' R2 U' R' U R' U R2' U R2' U R2 U2' R' U R'",
          "R U2 R' U R2 U R U R U2 R2 U2' R' U2 R' U2' R U' R' U' R2'",
          "R2 U R U R' U2 R U2' R U2 R2' U2' R' U' R' U' R2' U' R U2' R'",
          "R' U2 R' U2 R2' U R2' U R' U R2' U' R' U' R U' R' U R' U2 R",
          "R' U2' R U' R U R' U R U R2 U' R U' R2 U' R2 U2' R U2' R",
          "R U R U R2' U' R2 U2 R2 U' R' U' R2 U R U R2' U2' R' U' R'",
          "R U R U2 R2 U' R2' U' R2' U' R2 U R2 U2 R2' U2 R2' U2 R U2' R'",
          "R U R U2 R2 U' R' U' R2' U R U R2' U2' R2' U R2 U' R' U' R'",
          "R U2 R' U2' R2 U2' R2 U2' R2' U' R2' U R2 U R2 U R2' U2' R' U' R'",
          "R U2 R' U2' R2' U2' R U2' R2' U' R2' U R U R2' U2' R2' U2' R' U2 R2",
          "R U2' R2' U R' U2 R U R U' R2 U R U' R U2' R U' R2 U2 R'",
          "R U2' R2' U R' U2 R' U R' U' R2' U R' U' R' U2' R U' R2 U2 R'",
          "R U2' R' U' R U2' R2' U2' R' U2 R U R U' R2' U2' R2 U' R' U2' R",
          "R2' U2' R U2 R2 U2 R2 U' R' U' R2 U R2 U2 R' U2 R2 U2 R U2' R'",
          "R' U2 R U R2' U2 R2 U R' U' R' U2' R U2 R2 U2 R' U R U2 R'",
          "R U2' R' U' R2 U2' R2' U' R U R U2 R' U2' R2' U2' R U' R' U2' R",
          "R2 U2 R' U2' R2' U2' R2' U R U R2' U' R2' U2' R U2' R2' U2' R' U2 R",
        ],
      }, //B
      {
        name: 'X2',
        scr: [
          "R2' U R2' U' R2' U' R U' R U R U R2 U R U2' R U' R2",
          "R2 U' R2 U R2 U R' U R' U' R' U' R2' U' R' U2 R' U R2'",
          "R' U2 R2 U2 R' U' R U' R2' U2' R2 U R2' U2 R2 U2 R2'",
          "R U2' R2' U2' R U R' U R2 U2 R2' U' R2 U2' R2' U2' R2 U' R'",
          "R2 U2' R2' U2' R2 U R2' U2' R2 U2 R2' U R2 U R2' U R2 U2 R2'",
          "R2 U2' R2' U2' R2 U' R2' U2 R2 U2' R2' U2' R2 U R2' U R2 U2 R2'",
          "R2 U2' R2' U' R2 U' R2' U2 R2 U2 R2' U2' R2 U R2' U2 R2 U2 R2'",
          "R2 U2' R2' U' R2 U' R2' U' R2 U2' R2' U2 R2 U' R2' U2 R2 U2 R2'",
          "R2' U2' R2 U2' R2' U R2 U2' R2' U2 R2 U R2' U R2 U R2' U2 R2",
          "R2' U2' R2 U2' R2' U' R2 U2 R2' U2' R2 U2' R2' U R2 U R2' U2 R2",
          "R2' U2' R2 U' R2' U' R2 U2 R2' U2 R2 U2' R2' U R2 U2 R2' U2 R2",
          "R2' U2' R2 U' R2' U' R2 U' R2' U2' R2 U2 R2' U' R2 U2 R2' U2 R2",
          "R' U2' R U R2' U2' R U R U' R2' U2 R2' U2' R2' U2' R2 U' R'",
          "R' U2' R U R' U2' R U R U2 R2' U2' R2 U' R2' U R2 U' R'",
          "R' U' R2 U R2' U' R2 U2' R2' U2 R U R U2' R' U R U2' R'",
          "R U R2' U2 R2 U2 R2' U R2 U2' R2' U' R U' R' U2 R2 U2 R'",
          "R2 U' R U2' R U R2 U R U R U' R U' R2' U' R2' U R2'",
          "R2' U R' U2 R' U' R2' U' R' U' R' U R' U R2 U R2 U' R2",
          "R' U' R2 U2' R2' U2' R2 U' R2' U2 R2 U R' U R U2' R2' U2' R",
          "R U R2' U' R2 U R2' U2 R2 U2' R' U' R' U2 R U' R' U2 R",
        ],
      },
      {
        name: 'X3',
        scr: [
          "R2 U2 R2' U R2 U2 R2' U2 R2 U2 R2' U2' R2 U R2' U2' R2 U2 R2'",
          "R2 U2 R2' U R2 U2 R2' U2 R2' U2 R2 U2' R2' U R2 U2' R2' U2 R2",
          "R2 U2 R2' U R2 U2 R2' U' R2 U2' R2' U2 R2 U' R2' U2' R2 U2 R2'",
          "R2 U2 R2' U R2 U2 R2' U' R2' U2' R2 U2 R2' U' R2 U2' R2' U2 R2",
          "R2 U2' R2' U2 R2 U R2' U2' R2 U2 R2' U R2 U2' R2' U' R2 U2' R2'",
          "R2 U2' R2' U2 R2 U R2' U2' R2 U2 R2' U R2' U2' R2 U' R2' U2' R2",
          "R2 U2' R2' U2 R2 U' R2' U2 R2 U2' R2' U2' R2 U2' R2' U' R2 U2' R2'",
          "R2 U2' R2' U2 R2 U' R2' U2 R2 U2' R2' U2' R2' U2' R2 U' R2' U2' R2",
          "R2' U2 R2 U R2' U2 R2 U2 R2 U2 R2' U2' R2 U R2' U2' R2 U2 R2'",
          "R2' U2 R2 U R2' U2 R2 U2 R2' U2 R2 U2' R2' U R2 U2' R2' U2 R2",
          "R2' U2 R2 U R2' U2 R2 U' R2 U2' R2' U2 R2 U' R2' U2' R2 U2 R2'",
          "R2' U2 R2 U R2' U2 R2 U' R2' U2' R2 U2 R2' U' R2 U2' R2' U2 R2",
          "R2' U2' R2 U2 R2' U R2 U2' R2' U2 R2 U R2 U2' R2' U' R2 U2' R2'",
          "R2' U2' R2 U2 R2' U R2 U2' R2' U2 R2 U R2' U2' R2 U' R2' U2' R2",
          "R2' U2' R2 U2 R2' U' R2 U2 R2' U2' R2 U2' R2 U2' R2' U' R2 U2' R2'",
          "R2' U2' R2 U2 R2' U' R2 U2 R2' U2' R2 U2' R2' U2' R2 U' R2' U2' R2",
          "R U R' U2 R' U' R2 U2' R' U2 R' U R2 U2 R' U' R U' R'",
          "R2 U2 R2' U2' R2 U R2' U2 R2 U2' R2' U2' R2 U2' R2' U' R2 U2' R2'",
          "R2 U2 R2' U2' R2 U R2' U2 R2 U2' R2' U2' R2' U2' R2 U' R2' U2' R2",
          "R2 U2 R2' U2' R2 U2' R2' U2' R2 U2 R2' U R2 U2' R2' U' R2 U2' R2'",
        ],
      },
      {
        name: 'X4',
        scr: [
          "R' U2' R U R' U R U' R' U2' R U' R' U2 R U' R' U2 R",
          "R' U2' R U R' U2' R U R' U2 R U R' U' R U' R' U2 R",
          "R' U' R2 U' R' U R U' R2' U' R2 U R' U' R U R2' U2 R",
          "R U2' R2 U2' R2' U' R2 U2' R2 U R U2' R2' U' R2 U2' R2' U2' R",
          "R U2' R2 U2' R2' U' R2 U2' R2 U R2 U2' R2 U' R2' U2' R2 U2' R",
          "R U2' R2' U2' R2 U' R2' U2' R U R U2' R2' U' R2 U2' R2' U2' R",
          "R U2' R2' U2' R2 U' R2' U2' R U R2 U2' R2 U' R2' U2' R2 U2' R",
          "R' U2 R2 U2 R2' U R2 U2 R' U' R2' U2 R2' U R2 U2 R2' U2 R'",
          "R' U2 R2 U2 R2' U R2 U2 R' U' R' U2 R2 U R2' U2 R2 U2 R'",
          "R' U2 R2' U2 R2 U R2' U2 R2' U' R2' U2 R2' U R2 U2 R2' U2 R'",
          "R' U2 R2' U2 R2 U R2' U2 R2' U' R' U2 R2 U R2' U2 R2 U2 R'",
          "R' U2' R2 U' R' U R U' R2' U R2 U R' U' R U R2'",
          "R U R2' U R U' R' U R2 U R2' U' R U R' U' R2 U2' R'",
          "R U2 R2' U R U' R' U R2 U' R2' U' R U R' U' R2 U' R'",
          "R U2 R' U' R U2 R' U' R U2' R' U' R U R' U R U2' R'",
          "R U2 R' U' R U' R' U R U2 R' U R U2' R' U R U2' R'",
          "R U2 R U' R2' U2 R' U' R U' R2 U R U2' R2' U R' U R",
          "R' U' R' U' R U' R2 U2 R' U' R2' U R' U R U2' R2 U R' U2' R'",
          "R U2' R2 U' R2' U R U2 R2 U2' R2' U2' R U2 R' U2' R' U' R' U R2",
          "R' U2' R' U2' R U R U' R2' U R2 U2' R2' U2' R U2' R U2 R' U2' R",
        ],
      },
      {
        name: 'X5+',
        scr: [
          "R U2' R2 U2 R2' U2 R U2' R U R U R2 U' R' U2 R2' U2 R'",
          "R2 U2 R' U R U2 R2' U R U2 R' U2 R U R' U2' R U2' R'",
          "R' U' R2' U' R U R2' U2' R' U2 R2' U2' R' U R' U R2",
          "R' U' R2' U' R U2 R2' U2 R' U2' R2' U2 R' U R' U R2",
          "R U R2 U R' U R' U2 R2' U2' R' U2 R2' U2 R U' R2' U' R'",
          "R U R2 U R' U R' U2' R2' U2 R' U2' R2' U R U' R2' U' R'",
          "R' U2 R2' U2 R' U' R2 U R U R U2' R U2 R2' U2 R2 U2' R",
          "R' U2' R U2' R' U R U2 R' U2 R U R2' U2 R U R' U2 R2",
          "R U' R' U2' R U2' R' U' R2 U R' U R U R' U2' R U' R2'",
          "R2' U2 R U R2' U2' R U R2' U' R' U R' U' R2' U' R' U2' R2'",
          "R2 U' R2' U2 R2 U2 R2' U2 R2 U' R2' U2 R2 U2 R2' U2 R2 U' R2'",
          "R2' U' R2 U2 R2' U2 R2 U2 R2' U' R2 U2 R2' U2 R2 U2 R2' U' R2",
          "R2' U2' R' U' R2' U' R' U R' U' R2' U R U2' R2' U R U2 R2'",
          "R2' U' R U2' R' U R U R' U R2 U' R' U2' R U2' R' U' R",
          "R' U2 R U R' U' R2 U2 R' U' R' U2 R2 U2' R' U R U2' R'",
          "R' U2' R U R' U2' R2 U2 R' U' R' U2 R2 U' R' U R U2 R'",
          "R U R2 U2 R2' U R2 U' R U2' R2' U2' R' U' R2' U2' R U2 R2' U2 R'",
          "R U2' R2' U2' R' U' R2 U' R2' U2 R2' U2' R' U' R' U2 R U R' U' R",
          "R2 U2 R2' U' R U2 R' U' R2 U' R' U R' U' R2 U R' U' R U' R2'",
          "R2' U2' R2' U2 R2 U2' R2' U' R U2' R U R U R2 U' R' U2 R2' U2 R'",
        ],
      },
      {
        name: 'X5-',
        scr: [
          "R' U2 R2' U2' R2 U2' R' U2 R' U' R' U' R2' U R U2' R2 U2' R",
          "R U R2 U R' U2' R2 U2' R U2 R2 U2' R U' R U' R2' U' R'",
          "R U R2 U R' U' R2 U2 R U2' R2 U2 R U' R U' R2' U' R'",
          "R2' U2' R U' R' U2' R2 U' R' U2' R U2' R' U' R U2 R' U2 R",
          "R U2 R' U' R U2 R2' U2' R U R U2' R2' U R U' R' U2' R",
          "R U2' R' U' R U R2' U2' R U R U2' R2' U2 R U' R' U2 R",
          "R2 U R' U2 R U' R' U' R U' R2' U R U2 R' U2 R U R'",
          "R2 U2 R U R2 U R U' R U R2 U' R' U2 R2 U' R' U2' R2",
          "R2 U R2' U2' R2 U2' R2' U2' R2 U R2' U2' R2 U2' R2' U2' R2 U R2'",
          "R2' U R2 U2' R2' U2' R2 U2' R2' U R2 U2' R2' U2' R2 U2' R2' U R2",
          "R2 U2' R' U' R2 U2 R' U' R2 U R U' R U R2 U R U2 R2",
          "R' U R U2 R' U2 R U R2' U' R U' R' U' R U2 R' U R2",
          "R U2 R' U2 R U' R' U2' R U2' R' U' R2 U2' R' U' R U2' R2'",
          "R U2' R2 U2' R U R2' U' R' U' R' U2 R' U2' R2 U2' R2' U2 R'",
          "R' U' R2' U' R U' R U2 R2 U2' R U2 R2 U' R' U R2",
          "R' U' R2' U' R U' R U2' R2 U2 R U2' R2 U2' R' U R2",
          "R U R' U2 R U' R' U' R2 U' R' U2' R' U2 R U' R U2 R' U2' R'",
          "R U2' R2' U2 R U R2 U2 R2 U' R U R2' U R' U' R U R2' U2 R2'",
          "R U2' R' U R U R2 U' R U' R2 U' R U R U' R2 U2 R' U R2",
          "R U2' R' U' R U2' R' U2' R' U2' R U' R2' U2' R U' R' U2' R U2 R",
        ],
      },
      {
        name: 'X6+',
        scr: [
          "R' U' R U2' R' U R U' R' U2' R U' R' U2 R U2 R'",
          "R' U' R U2' R' U2' R U R' U2 R U R' U' R U2 R'",
          "R2 U R2' U' R2 U R2' U2' R2 U' R2' U R2 U2' R2' U R2 U2' R2'",
          "R2' U R2 U' R2' U R2 U2' R2' U' R2 U R2' U2' R2 U R2' U2' R2",
          "R U2' R' U' R2 U R' U R' U R U' R' U' R2 U' R' U2 R'",
          "R U2' R U R2' U R U R' U' R U' R U' R2' U R U2 R'",
          "R2 U2 R2' U' R2 U R2' U' R2 U R2' U R2 U2' R2' U R2 U2' R2'",
          "R2 U2 R2' U' R2 U2 R2' U' R2 U R2' U2 R2 U' R2' U R2 U' R2'",
          "R2 U2 R2' U' R2 U2 R2' U' R2 U' R2' U R2 U' R2' U R2 U2' R2'",
          "R2' U2 R2 U' R2' U R2 U' R2' U R2 U R2' U2' R2 U R2' U2' R2",
          "R2' U2 R2 U' R2' U2 R2 U' R2' U R2 U2 R2' U' R2 U R2' U' R2",
          "R2' U2 R2 U' R2' U2 R2 U' R2' U' R2 U R2' U' R2 U R2' U2' R2",
          "R U2 R U2' R2 U2' R' U2 R2 U' R' U' R U2 R2' U' R2 U R2' U2 R2'",
          "R U2 R U2' R2' U2' R' U2 R U2' R2' U2 R2 U' R' U' R U2 R2' U2 R2'",
          "R U2 R2 U R' U R' U R2' U' R' U R2' U2' R U R2' U R2 U2 R2",
          "R U2 R2 U R' U2 R2 U' R U R2 U' R U' R U R2' U R2 U2 R2",
          "R U2' R U2' R2' U R U' R U R2' U2' R U R U2 R2' U' R U R'",
          "R U' R' U R2 U2' R' U' R' U2 R2 U' R' U R' U' R2 U2 R' U2 R'",
          "R2 U2' R2 U2' R' U R U R2' U2' R2 U2 R' U2' R U2 R2 U2 R' U2' R'",
          "R2 U2' R2 U' R2' U R2 U2' R' U R U R2' U2' R U2 R2' U2 R' U2' R'",
        ],
      },
      {
        name: 'X6-',
        scr: [
          "R U R' U2 R U2 R' U' R U2' R' U' R U R' U2' R U' R'",
          "R U R' U2 R U' R' U R U2 R' U R U2' R' U2' R U' R'",
          "R2 U2' R2' U R2 U2' R2' U R2 U R2' U' R2 U R2' U' R2 U2 R2'",
          "R2 U2' R2' U R2 U2' R2' U R2 U' R2' U2' R2 U R2' U' R2 U R2'",
          "R2 U2' R2' U R2 U' R2' U R2 U' R2' U' R2 U2 R2' U' R2 U2 R2'",
          "R2' U2' R2 U R2' U2' R2 U R2' U R2 U' R2' U R2 U' R2' U2 R2",
          "R2' U2' R2 U R2' U2' R2 U R2' U' R2 U2' R2' U R2 U' R2' U R2",
          "R2' U2' R2 U R2' U' R2 U R2' U' R2 U' R2' U2 R2 U' R2' U2 R2",
          "R' U2 R' U' R2 U' R' U' R U R' U R' U R2 U' R' U2' R",
          "R' U2 R U R2' U' R U' R U' R' U R U R2' U R U2' R",
          "R2 U' R2' U R2 U' R2' U2 R2 U R2' U' R2 U2 R2' U' R2 U2 R2'",
          "R2' U' R2 U R2' U' R2 U2 R2' U R2 U' R2' U2 R2 U' R2' U2 R2",
          "R2 U2 R2 U R2' U R U2' R2' U R' U' R2' U R' U R' U R2 U2 R",
          "R2 U2 R2 U R2' U R U' R U' R2 U R U' R2 U2 R' U R2 U2 R",
          "R2' U2 R2' U R2 U' R2' U2 R U' R' U' R2 U2 R' U2' R2 U2' R U2 R",
          "R2' U2 R2' U2 R U' R' U' R2 U2 R2' U2' R U2 R' U2' R2' U2' R U2 R",
          "R' U R U' R2' U2 R U R U2' R2' U R U' R U R2' U2' R U2' R",
          "R' U2 R' U2 R2 U' R' U R' U' R2 U2 R' U' R' U2' R2 U R' U' R",
          "R' U2' R2' U' R U2' R2' U R' U' R2' U R' U R' U' R2 U' R2' U2' R2'",
          "R' U2' R2' U' R U' R U' R2 U R U' R2 U2 R' U' R2 U' R2' U2' R2'",
        ],
      },
      {
        name: 'X7+',
        scr: [
          "R U R' U R2' U2' R2 U' R2' U2 R2 U' R U' R' U2 R2' U R2",
          "R2' U' R2 U2' R U R' U R2' U2' R2 U R2' U2 R2 U' R U' R'",
          "R U2' R2' U2 R2 U R2 U' R U2' R2 U2 R2 U' R2 U R2' U R2",
          "R2' U' R2 U' R2' U R2' U2' R2' U2 R' U R2' U' R2' U2' R2 U2 R'",
          "R U R' U R2' U2' R2 U' R2' U2 R2 U' R U R2 U R2' U2 R'",
          "R U2' R2 U' R2' U' R' U R2' U2' R2 U R2' U2 R2 U' R U' R'",
          "R U R' U R2' U2' R2 U' R2' U2 R2 U' R U R2 U R2' U2 R'",
          "R U2' R2 U' R2' U' R' U R2' U2' R2 U R2' U2 R2 U' R U' R'",
          "R U2' R2' U2 R2 U R2 U' R U2' R2 U2 R2 U' R2 U R2' U R2",
          "R2' U' R2 U' R2' U R2' U2' R2' U2 R' U R2' U' R2' U2' R2 U2 R'",
          "R U R' U R2' U2' R2 U' R2' U2 R2 U' R U R2 U R2' U2 R'",
          "R U R' U R2' U2' R2 U' R2' U2 R2 U' R U' R' U2 R2' U R2",
          "R U2' R2 U' R2' U' R' U R2' U2' R2 U R2' U2 R2 U' R U' R'",
          "R2' U' R2 U2' R U R' U R2' U2' R2 U R2' U2 R2 U' R U' R'",
          "R U R' U R2' U2' R2 U' R2' U2 R2 U' R U' R' U2 R2' U R2",
          "R U2' R2' U2 R2 U R2 U' R U2' R2 U2 R2 U' R2 U R2' U R2",
          "R2' U' R2 U2' R U R' U R2' U2' R2 U R2' U2 R2 U' R U' R'",
          "R2' U' R2 U' R2' U R2' U2' R2' U2 R' U R2' U' R2' U2' R2 U2 R'",
          "R U R' U R2' U2' R2 U' R2' U2 R2 U' R U R2 U R2' U2 R'",
          "R U R' U R2' U2' R2 U' R2' U2 R2 U' R U' R' U2 R2' U R2",
        ],
      },
      {
        name: 'X7-',
        scr: [
          "R2 U R2' U2 R' U' R U' R2 U2 R2' U' R2 U2' R2' U R'",
          "R' U' R U' R2 U2 R2' U R2 U2' R2' U R' U R U2' R2 U' R2'",
          "R' U2 R2' U R2 U R U' R2 U2 R2' U' R2 U2' R2' U R'",
          "R' U' R U' R2 U2 R2' U R2 U2' R2' U R' U' R2' U' R2 U2' R",
          "R2 U R2' U R2 U' R2 U2 R2 U2' R U' R2 U R2 U2 R2' U2' R",
          "R' U2 R2 U2' R2' U' R2' U R' U2 R2' U2' R2' U R2' U' R2 U' R2'",
          "R2 U R2' U R2 U' R2 U2 R2 U2' R U' R2 U R2 U2 R2' U2' R",
          "R' U2 R2 U2' R2' U' R2' U R' U2 R2' U2' R2' U R2' U' R2 U' R2'",
          "R' U2 R2' U R2 U R U' R2 U2 R2' U' R2 U2' R2' U R'",
          "R' U' R U' R2 U2 R2' U R2 U2' R2' U R' U' R2' U' R2 U2' R",
          "R2 U R2' U R2 U' R2 U2 R2 U2' R U' R2 U R2 U2 R2' U2' R",
          "R2 U R2' U2 R' U' R U' R2 U2 R2' U' R2 U2' R2' U R'",
          "R' U2 R2 U2' R2' U' R2' U R' U2 R2' U2' R2' U R2' U' R2 U' R2'",
          "R' U2 R2' U R2 U R U' R2 U2 R2' U' R2 U2' R2' U R' U R",
          "R' U' R U' R2 U2 R2' U R2 U2' R2' U R' U R U2' R2 U' R2'",
          "R' U' R U' R2 U2 R2' U R2 U2' R2' U R' U' R2' U' R2 U2' R",
          "R2 U R2' U R2 U' R2 U2 R2 U2' R U' R2 U R2 U2 R2' U2' R",
          "R2 U R2' U2 R' U' R U' R2 U2 R2' U' R2 U2' R2' U R'",
          "R' U2 R2 U2' R2' U' R2' U R' U2 R2' U2' R2' U R2' U' R2 U' R2'",
          "R' U2 R2' U R2 U R U' R2 U2 R2' U' R2 U2' R2' U R'",
        ],
      },
    ],
  }, //B

  {
    cat: 'Y',
    cases: [
      {
        name: 'Y1+',
        scr: [
          "R2' U2' R2' U2 R' U R U2 R2 U2' R' U2' R2' U R2 U R2'",
          "R U2 R2' U2' R' U' R U2' R2 U2 R2 U' R2 U R2' U R2",
          "R2 U2' R2' U' R2 U R2 U' R U R2 U2 R2' U' R'",
          "R2 U2 R U R' U2 R2' U' R2 U' R U' R2 U R2 U R2'",
          "R2 U R2' U2 R2 U' R' U R U2 R' U2' R' U2 R U2 R'",
          "R2 U R2' U2 R2 U' R' U2' R' U2' R U2 R U2' R' U' R'",
          "R' U2 R U2 R' U2' R' U2 R U R' U' R2 U2 R2' U R2",
          "R' U' R' U2' R U2 R U2' R' U2' R' U' R2 U2 R2' U R2",
          "R U R' U' R2' U2 R2 U R U' R2 U R2 U' R2' U2' R2",
          "R2 U R2' U R2 U' R2 U2 R2 U2' R U' R' U2' R2' U2 R",
          "R2' U R2 U R2 U' R U' R2 U' R2' U2 R' U R U2 R2",
          "R2' U R2 U R2' U2' R' U2' R2 U2 R U R' U2 R2' U2' R2'",
          "R U R2 U' R2' U' R' U2 R U2 R' U' R2' U R2 U R U2' R'",
          "R2 U' R' U R' U' R2' U R2 U R U' R2 U' R2 U R2 U R2'",
          "R2' U R' U' R2 U' R2' U R' U' R2' U R U' R2' U R2 U R2'",
          "R2' U R' U' R2' U' R2 U R U' R2 U R2 U' R2' U R2 U R2'",
          "R2' U' R2' U R' U' R2' U R2 U R U' R2 U' R2 U R2' U R2",
          "R' U' R2 U R U' R2 U R2' U R U' R2 U' R2 U R2' U R2",
          "R' U' R2 U R' U' R2' U R2 U R U' R2 U' R2 U R'",
          "R2 U2' R2 U2 R U R' U2 R U R U2 R U R' U2 R U2' R2'",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          3,
          4,
          2,
          2,
          3,
          4,
          4,
          5,
          5,
          1,
          2,
          3,
          5,
        ],
      }, //A
      {
        name: 'Y1-',
        scr: [
          "R2 U2 R2 U2' R U' R' U2' R2' U2 R U2 R2 U' R2' U' R2",
          "R U R U2 R' U2' R' U2 R U2 R U R2' U2' R2 U' R2'",
          "R U2' R' U2' R U2 R U2' R' U' R U R2' U2' R2 U' R2'",
          "R2' U' R2 U2' R2' U R U2 R U2 R' U2' R' U2 R",
          "R2' U' R2 U2' R2' U R U' R' U2' R U2 R U2' R' U2' R",
          "R2' U2' R' U' R U2' R2 U R2' U R' U R2' U' R2' U' R2",
          "R2' U2 R2 U R2' U' R2' U R' U' R2' U2' R2 U R U' R'",
          "R' U2' R2 U2 R U R' U2 R2' U2' R2' U R2' U' R2 U' R2'",
          "R2 U' R2' U' R2 U2 R U2 R2' U2' R' U' R U2' R2 U2 R2",
          "R2 U' R2' U' R2' U R' U R2' U R2 U2' R U' R' U2' R2'",
          "R2' U' R2 U' R2' U R2' U2' R2' U2 R' U R U2 R2 U2' R'",
          "R' U' R U R2 U2' R2' U' R' U R2' U' R2' U R2 U2 R2'",
          "R U R2' U' R U R2 U' R2' U' R' U R2' U R2' U' R U' R'",
          "R U R2' U' R' U R2' U' R2 U' R' U R2' U R2' U' R2 U' R2'",
          "R2 U R2 U' R U R2 U' R2' U' R' U R2' U R2' U' R2 U' R2'",
          "R2 U' R U R2 U R2' U' R' U R2' U' R2' U R2 U' R2' U' R2",
          "R2 U' R U R2' U R2 U' R U R2 U' R' U R2 U' R2' U' R2",
          "R2' U R U' R U R2 U' R2' U' R' U R2' U R2' U' R2' U' R2",
          "R' U' R2' U R2 U R U2' R' U2' R U R2 U' R2' U' R' U2 R",
          "R2 U' R2' U' R U2 R U2 R' U2' R' U2 R U R' U' R2 U R2'",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          4,
          5,
          2,
          2,
          3,
          5,
          1,
          2,
          3,
          3,
          4,
          4,
          5,
        ],
      },
      {
        name: 'Y2+',
        scr: [
          "R2 U2' R2' U' R2 U2' R2' U2 R2 U2' R2' U' R2 U2' R2'",
          "R2 U2' R2' U' R2 U2' R2' U2 R2' U2' R2 U' R2' U2' R2",
          "R2' U2' R2 U' R2' U2' R2 U2 R2 U2' R2' U' R2 U2' R2'",
          "R2' U2' R2 U' R2' U2' R2 U2 R2' U2' R2 U' R2' U2' R2",
          "R' U2' R U R U R2' U' R2 U2' R2' U2 R2 U2' R'",
          "R' U2' R2 U2 R2' U2' R2 U' R2' U R U R U2' R'",
          "R U2 R2 U2' R2' U2 R2 U2 R2' U2' R' U' R2' U2' R2",
          "R U2 R' U' R' U' R2 U R2' U2' R2 U2 R2' U2' R",
          "R' U2 R2' U2' R2 U2 R2' U2 R2 U2' R U' R2 U2' R2'",
          "R U2' R2' U2 R2 U2' R2' U R2 U' R' U' R' U2 R",
          "R2 U2' R2' U' R' U2' R2' U2 R2 U2 R2' U2' R2 U2 R",
          "R2' U2' R2 U' R U2' R2 U2 R2' U2 R2 U2' R2' U2 R'",
          "R' U R U2 R U2' R' U R' U2' R U2 R U R'",
          "R' U' R U' R' U2 R U R U R' U2 R U2 R'",
          "R2 U2 R2' U R' U2 R2' U R2 U2 R U R2 U2 R2'",
          "R2' U2 R2 U R U2 R2 U R2' U2 R' U R2' U2 R2",
          "R' U2 R U2 R' U R U R U2 R' U' R U' R'",
          "R' U2' R' U' R U R U' R' U2 R' U2' R2 U R' U2 R",
          "R U2' R2' U2 R2' U2 R2 U R2' U2 R' U2' R' U R U2' R'",
          "R U2' R2' U' R2 U2' R2' U2 R2 U2' R2' U2' R U R U2' R'",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          3,
          4,
          2,
          2,
          3,
          5,
          4,
          5,
          3,
          1,
          2,
          4,
          5,
        ],
      },
      {
        name: 'Y2-',
        scr: [
          "R U2' R2 U2 R2' U2' R2 U2' R2' U2 R' U R2' U2 R2",
          "R' U2' R U R U R2' U' R2 U2 R2' U2' R2 U2 R'",
          "R' U2' R2' U2 R2 U2' R2' U2' R2 U2 R U R2 U2 R2'",
          "R U2 R2' U2' R2 U2 R2' U R2 U' R' U' R' U2 R",
          "R U2 R' U' R' U' R2 U R2' U2 R2 U2' R2' U2 R",
          "R2 U2 R2' U R2 U2 R2' U2' R2 U2 R2' U R2 U2 R2'",
          "R2 U2 R2' U R2 U2 R2' U2' R2' U2 R2 U R2' U2 R2",
          "R2' U2 R2 U R2' U2 R2 U2' R2 U2 R2' U R2 U2 R2'",
          "R2' U2 R2 U R2' U2 R2 U2' R2' U2 R2 U R2' U2 R2",
          "R U2' R' U2' R U' R' U' R' U2' R U R' U R",
          "R2 U2' R2' U' R' U2' R2' U' R2 U2' R U' R2 U2' R2'",
          "R2' U2' R2 U' R U2' R2 U' R2' U2' R' U' R2' U2' R2",
          "R U R' U R U2' R' U' R' U' R U2' R' U2' R",
          "R U' R' U2' R' U2 R U' R U2 R' U2' R' U' R",
          "R2 U2 R2' U R' U2 R2' U2' R2 U2' R2' U2 R2 U2' R",
          "R2' U2 R2 U R U2 R2 U2' R2' U2' R2 U2 R2' U2' R'",
          "R' U2 R2 U2' R2' U2 R2 U' R2' U R U R U2' R'",
          "R U2 R U R' U' R' U R U2' R U2 R2' U' R U2' R'",
          "R U2' R2 U2 R2' U R2 U2 R2' U2' R U2 R2' U R2 U2 R2'",
          "R U2' R2 U2 R2' U R2 U2 R2' U2' R2 U2 R2 U R2' U2 R2",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          4,
          5,
          2,
          2,
          3,
          4,
          1,
          2,
          5,
          3,
          4,
          3,
          5,
        ],
      },
      {
        name: 'Y3+',
        scr: [
          "R U R' U R2 U2' R2' U2' R U R U2' R' U2 R'",
          "R2 U R2' U R2 U2' R2' U2 R2 U R2' U R2 U2' R2'",
          "R2 U R2' U' R2 U2 R2' U2' R2 U2' R2' U R2 U2' R2'",
          "R2 U2 R2' U' R2 U2 R2' U2 R2 U2' R2' U R2 U' R2'",
          "R2 U2 R2' U' R2 U' R2' U2' R2 U2 R2' U' R2 U' R2'",
          "R2' U R2 U R2' U2' R2 U2 R2' U R2 U R2' U2' R2",
          "R2' U R2 U' R2' U2 R2 U2' R2' U2' R2 U R2' U2' R2",
          "R2' U2 R2 U' R2' U2 R2 U2 R2' U2' R2 U R2' U' R2",
          "R2' U2 R2 U' R2' U' R2 U2' R2' U2 R2 U' R2' U' R2",
          "R U2' R U2 R' U' R' U2 R2 U2 R2' U' R U' R'",
          "R' U R U' R' U' R2 U R' U R' U' R U2 R U2 R'",
          "R U R U R2' U' R2 U2 R2' U2 R2 U2' R2' U R U' R'",
          "R U R U R2' U' R2 U' R2' U2' R2 U2 R2' U' R U' R'",
          "R U R' U R2 U2' R2' U2 R2 U R2' U R2 U' R' U' R'",
          "R U R' U' R2 U2 R2' U2' R2 U2' R2' U R2 U' R' U' R'",
          "R U R' U' R2' U2 R2 U R U2 R2 U' R2' U2' R2 U2 R2",
          "R2 U R2' U R2 U2' R2 U2 R2' U R2 U2 R U' R2 U2' R2'",
          "R2 U2 R2' U R' U2' R2' U' R2 U2' R2' U2 R2' U' R2 U' R2'",
          "R2' U R2 U R2' U2' R2' U2 R2 U R2' U2 R' U' R2' U2' R2",
          "R2' U2 R2 U R U2' R2 U' R2' U2' R2 U2 R2 U' R2' U' R2",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          4,
          5,
          3,
          3,
          4,
          2,
          2,
          3,
          5,
          1,
          2,
          4,
          5,
        ],
      },
      {
        name: 'Y3-',
        scr: [
          "R2 U2' R2' U R2 U R2' U2 R2 U2' R2' U R2 U R2'",
          "R2 U2' R2' U R2 U2' R2' U2' R2 U2 R2' U' R2 U R2'",
          "R2 U' R2' U R2 U2' R2' U2 R2 U2 R2' U' R2 U2 R2'",
          "R2 U' R2' U' R2 U2 R2' U2' R2 U' R2' U' R2 U2 R2'",
          "R2' U2' R2 U R2' U R2 U2 R2' U2' R2 U R2' U R2",
          "R2' U2' R2 U R2' U2' R2 U2' R2' U2 R2 U' R2' U R2",
          "R2' U' R2 U R2' U2' R2 U2 R2' U2 R2 U' R2' U2 R2",
          "R2' U' R2 U' R2' U2 R2 U2' R2' U' R2 U' R2' U2 R2",
          "R' U' R U' R2' U2 R2 U2 R' U' R' U2 R U2' R",
          "R' U2 R' U2' R U R U2' R2' U2' R2 U R'",
          "R U' R' U R U R2' U' R U' R U R' U2' R' U2' R",
          "R U2 R' U' R U2 R' U' R U' R2' U2 R2 U2 R2'",
          "R2 U2' R2' U' R' U2 R2' U R2 U2 R2' U2' R2' U R2 U R2'",
          "R2 U' R2' U' R2 U2 R2 U2' R2' U' R2 U2' R U R2 U2 R2'",
          "R2' U2' R2 U' R U2 R2 U R2' U2 R2 U2' R2 U R2' U R2",
          "R2' U' R2 U' R2' U2 R2' U2' R2 U' R2' U2' R' U R2' U2 R2",
          "R' U' R U R2 U2' R2' U' R' U2' R2' U R2 U2 R2' U2' R2'",
          "R' U' R U R2' U2' R2 U2 R2' U2 R2 U' R2' U R",
          "R' U' R U' R2' U2 R2 U2' R2' U' R2 U' R2' U R",
          "R' U' R' U' R2 U R2' U R2 U2 R2' U2' R2 U R'",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          4,
          5,
          3,
          3,
          4,
          5,
          2,
          3,
          4,
          1,
          2,
          2,
          5,
        ],
      },
    ],
  }, //A
  {
    cat: 'Z',
    cases: [
      {
        name: 'Z1',
        scr: [
          "R U2 R' U R U R' U2' R U2' R' U2' R U2' R' U R U R'",
          "R2 U2 R U R' U' R' U2' R U R U' R2' U2 R' U2 R2 U R2'",
          "R2 U2 R2' U R2 U2 R' U2 R2' U' R U R U2' R' U' R'",
          "R2' U2 R U R' U' R' U2' R U R U' R2' U2 R2' U2 R2' U R2",
          "R2' U2 R2 U R2' U2 R2' U2 R2' U' R U R U2' R' U' R'",
          "R2 U' R2' U2' R2 U R2' U2 R2 U2 R2' U2 R2 U2 R2' U' R2 U2 R2'",
          "R2' U' R2 U2' R2' U R2 U2 R2' U2 R2 U2 R2' U2 R2 U' R2' U2 R2",
          "R U R' U' R2' U2' R2 U R U' R' U2 R2' U2' R2 U' R2' U R2",
          "R2 U R2' U' R2 U2' R2' U2 R' U' R U R2 U2' R2' U' R'",
          "R U' R2' U R2 U R2' U' R U' R2 U2 R U R U' R' U2' R2'",
          "R2 U2 R U R' U' R' U2' R2' U R U' R2' U R2 U R2' U' R",
          "R2 U2 R U R' U' R' U2' R2' U R' U R2 U' R2' U' R2 U R'",
          "R2 U' R U R U2 R2 U' R U' R2' U R2 U R2' U' R' U2' R2",
          "R2 U' R U R U2 R2 U' R' U R2 U' R2' U' R2 U R2 U2' R2",
          "R2' U2 R U R2 U' R2' U' R2 U R' U R2' U2' R' U' R' U R2'",
          "R2' U2 R2' U' R2' U R2 U R2' U' R U R2' U2' R' U' R' U R2'",
          "R' U R2 U' R2' U' R2 U R' U' R2 U2 R U R U' R' U2' R2'",
          "R2' U2' R U' R' U2' R2 U2' R' U' R2 U2 R' U R U2 R2' U2 R",
          "R2 U2' R2' U' R2 U2' R2 U2' R2 U R' U' R' U2 R U R U' R'",
          "R2 U2' R' U' R U R U2 R' U' R' U R2 U2' R2 U2' R2 U' R2'",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          2,
          1,
          2,
          1,
          2,
          3,
          3,
          3,
          4,
          5,
          4,
          5,
          4,
          5,
        ],
      },
      {
        name: 'Z2',
        scr: [
          "R2 U R2' U2 R2 U2 R2' U2 R2 U2 R2' U R2 U2' R2' U2 R2 U2 R2'",
          "R2 U R2' U2 R2 U2 R2' U2 R2 U2 R2' U' R2 U2 R2' U2' R2 U' R2'",
          "R2' U R2 U2 R2' U2 R2 U2 R2' U2 R2 U R2' U2' R2 U2 R2' U2 R2",
          "R2' U R2 U2 R2' U2 R2 U2 R2' U2 R2 U' R2' U2 R2 U2' R2' U' R2",
          "R2 U2 R U2' R' U2' R2' U R2' U2' R' U2 R' U' R' U' R U2 R'",
          "R U2' R' U R U R U2' R U2 R2 U' R2 U2 R U2 R' U2' R2'",
          "R2 U R2' U2 R2 U2' R2' U R2 U2' R2' U2' R2 U2' R2' U2' R2 U' R2'",
          "R2 U2' R2' U2' R2 U2 R2' U' R2 U2' R2' U2' R2 U2' R2' U2' R2 U' R2'",
          "R2' U R2 U2 R2' U2' R2 U R2' U2' R2 U2' R2' U2' R2 U2' R2' U' R2",
          "R2' U2' R2 U2' R2' U2 R2 U' R2' U2' R2 U2' R2' U2' R2 U2' R2' U' R2",
          "R2 U2' R2' U R2' U R2' U R2 U2' R' U' R' U2 R' U' R2 U2 R2'",
          "R2 U2' R2' U2 R2 U' R' U2 R' U' R' U2' R2 U R2' U R2' U R2'",
          "R2' U2 R2 U2' R2' U R U2' R U R U2 R2' U' R2 U' R2 U' R2",
          "R2' U2 R2 U' R2 U' R2 U' R2' U2 R U R U2' R U R2' U2' R2",
          "R2 U2 R2' U2 R2 U2' R2' U R2 U2 R2' U2 R2 U2 R2' U2 R2 U R2'",
          "R2 U' R2' U2' R2 U2 R2' U' R2 U2 R2' U2 R2 U2 R2' U2 R2 U R2'",
          "R2' U2 R2 U2 R2' U2' R2 U R2' U2 R2 U2 R2' U2 R2 U2 R2' U R2",
          "R2' U' R2 U2' R2' U2 R2 U' R2' U2 R2 U2 R2' U2 R2 U2 R2' U R2",
          "R' U2 R U' R' U' R' U2 R' U2' R2' U R2' U2' R' U2' R U2 R2",
          "R2 U2' R2' U R U2' R U R U2 R2' U' R2 U' R2 U' R2 U2 R2'",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          5,
          1,
          2,
          4,
          2,
          3,
          3,
          3,
          4,
          2,
          4,
          5,
          1,
          5,
        ],
      },
      {
        name: 'Z3',
        scr: [
          "R U' R U R U' R' U' R U R U2 R U' R U' R2' U' R2'",
          "R U' R U' R U2 R U R U' R' U' R U R U' R' U' R2",
          "R2 U R2 U R' U R' U2' R' U' R' U R U R' U' R' U R'",
          "R2 U2' R U2 R U R' U' R2' U' R2 U R2' U' R2' U2 R U2 R2",
          "R2' U R U R' U' R' U R U R' U' R' U2' R' U R' U R'",
          "R2' U2' R' U2' R2 U R2 U' R2' U R2 U R U' R' U2' R' U2 R2'",
          "R2 U2' R2' U2 R2 U R2' U R2' U R2' U R2 U2' R' U' R' U2 R'",
          "R2' U R' U2 R2' U2 R2 U R2' U R2' U R2' U R2 U2 R2' U2 R'",
          "R' U R U R' U R2 U2' R' U' R' U' R2 U' R' U2' R' U2 R",
          "R' U R U2 R' U2' R' U' R2 U' R' U' R' U2' R2 U R'",
          "R2 U2 R2' U2' R2 U2' R2' U R2' U R2' U R2 U2' R' U' R' U2 R'",
          "R2' U2 R2' U2' R2 U' R U2' R' U' R U2' R2 U2 R' U R2' U2 R2",
          "R2' U2 R2' U2' R2' U2 R' U R U2 R' U R2' U2 R' U R2' U2 R2",
          "R2' U2' R2 U R' U' R U2 R2' U' R2 U' R' U2' R' U2' R U2 R",
          "R' U2' R U R U R2' U2 R2 U2 R2 U2' R U' R' U2' R U2 R",
          "R' U' R' U2' R2 U R' U R U R' U R U2 R' U2' R' U' R2",
          "R U2' R U R U2 R2' U' R2 U' R2 U' R2 U2 R2' U2 R2 U2' R2'",
          "R U2' R U R U2 R2' U' R2 U' R2 U' R2 U' R2' U2' R2 U2 R2'",
          "R U2' R2 U2' R2' U' R2 U' R2 U' R2 U' R2' U2' R2 U2' R U' R2",
          "R2' U R U2 R U2' R' U' R U' R' U' R U' R2' U2 R",
        ],
        state: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          4,
          1,
          2,
          5,
          2,
          3,
          3,
          3,
          4,
          1,
          4,
          5,
          2,
          5,
        ],
      },
    ],
  },
];
